import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from "../config";
import './HRDashboard.css';
import * as XLSX from 'xlsx';
import axios from "axios";
import { toast } from "react-toastify";
import EmployeeDetails from './EmployeeDetails';

import {
  // ... existing imports ...
  FiUsers, FiGrid, FiBriefcase, FiFileText, FiPlus, FiHome, FiBarChart2, FiClipboard,
  FiClock, FiUserPlus, FiTarget, FiTrendingUp, FiAlertCircle, FiStar, FiEye,
  FiRefreshCw, FiArrowRight,  FiUser, FiMessageCircle,
 FiXCircle, FiChevronRight, FiDownload, FiCheckCircle, FiCalendar,
  FiList, FiLayout, FiZap, FiPieChart,

  FiMail, FiMapPin, FiBook, FiBriefcase as FiBriefcase2,
  FiAward, FiDollarSign,  FiTrash2, FiSearch, FiFilter, FiMoreVertical,
  FiBell, FiHelpCircle, FiLogOut, FiCamera, FiImage, FiFolder,
  FiLock, FiUnlock, FiActivity, FiTrendingDown, FiMinus,
  FiMoreHorizontal, FiChevronLeft, FiChevronUp, FiHeart,
  FiThumbsUp, FiThumbsDown, FiFlag, FiGitBranch,
  FiGitMerge, FiGitPullRequest, FiGitCommit,
  FiCode, FiCpu, FiServer, FiCloud, FiWifi,
  FiBattery, FiBatteryCharging, FiBluetooth,
  FiWifiOff, FiVolume2, FiVolumeX, FiMic,
  FiMicOff, FiVideo, FiVideoOff, FiHeadphones,
  FiRadio, FiTv, FiSmartphone, FiTablet,
  FiMonitor, FiPrinter, FiHardDrive,
  FiMusic, FiFilm, FiCameraOff,
  FiSun, FiMoon, FiCloudRain,
  FiCloudSnow, FiCloudLightning,
  FiWind, FiThermometer, FiDroplet,
  FiUmbrella, FiAnchor, FiCompass,
  FiMap, FiNavigation, FiNavigation2,
  FiPackage, FiShoppingCart, FiShoppingBag,
  FiCreditCard, FiPercent, FiTag,
  FiGift, FiKey, FiShield,
  FiShieldOff, FiUmbrella as FiUmbrella2,
  FiAlertTriangle, FiInfo, FiMinusCircle,
  FiX, FiCheck, FiCheckSquare,
  FiSquare, FiCircle, FiRadio as FiRadio2,
  FiToggleLeft, FiToggleRight, FiChevronsRight,
  FiChevronsLeft, FiChevronsUp, FiChevronsDown,
  FiArrowUp, FiArrowDown, FiArrowLeft,
  FiCornerUpLeft, FiCornerUpRight,
  FiCornerDownLeft, FiCornerDownRight,
  FiCornerLeftUp, FiCornerLeftDown,
  FiCornerRightUp, FiCornerRightDown,
  FiMaximize2, FiMinimize2, FiMove,
  FiRotateCw, FiRotateCcw, FiRepeat,
  FiShuffle, FiSkipBack, FiSkipForward,
  FiFastForward, FiRewind, FiPlay,
  FiPause, FiStopCircle, FiPlayCircle,
  FiPauseCircle, FiStopCircle as FiStopCircle2,
  FiMusic as FiMusic2, FiVolume as FiVolume,
  FiVolume1, FiVolumeX as FiVolumeX2,
  FiMic as FiMic2, FiVideo as FiVideo2,
  FiCamera as FiCamera2, FiImage as FiImage2,
  FiFilm as FiFilm2, FiMonitor as FiMonitor2,
  FiSmartphone as FiSmartphone2,
  FiTablet as FiTablet2, FiWatch,
  FiCommand, FiHash, FiAtSign,
  FiAperture, FiArchive, FiBookmark,
  FiBox, FiBriefcase as FiBriefcaseIcon,
  FiCalculator, FiCast, FiCoffee,
  FiCopy, FiCrosshair, FiDisc,
  FiDivide, FiDivideCircle,
  FiDivideSquare, FiDollarSign as FiDollarSign2,
  FiDownloadCloud, FiEdit, FiEdit3,
  FiFeather, FiFile, FiFileMinus,
  FiFilePlus, FiFileText as FiFileText2,
  FiFolderMinus, FiFolderPlus,
  FiPhone as FiPhone2, FiPhoneCall,
  FiPhoneForwarded, FiPhoneIncoming,
  FiPhoneMissed, FiPhoneOff,
  FiPhoneOutgoing, FiPocket,
  FiPower, FiSave, FiScissors,
  FiSend, FiServer as FiServer2,
  FiTerminal, FiTool, FiTruck,
  FiTv as FiUserCheck, FiUserPlus as FiVoicemail, FiWifi as FiWifi2,
  FiWifiOff as FiWifiOff2, FiXSquare,
  FiYoutube, FiZap as FiZap2,
  FiZoomIn, FiZoomOut
} from "react-icons/fi";

const HRDashboard = () => {
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [stats, setStats] = useState({
    employees: 0,
    departments: 0,
    openPositions: 0,
    newApplications: 0
  });
  const [recentActivities, setRecentActivities] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null); // Added missing state
  const [companyLogo, setCompanyLogo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [showAddDepartment, setShowAddDepartment] = useState(false);
  const [newDepartmentName, setNewDepartmentName] = useState('');
  const [editingDepartment, setEditingDepartment] = useState(null);
  const [editDepartmentName, setEditDepartmentName] = useState('');
  const [employees, setEmployees] = useState([]);
  const [employeesLoading, setEmployeesLoading] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [calendarView, setCalendarView] = useState('month');
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [allCountriesHolidays, setAllCountriesHolidays] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('IN');
  const [meetings, setMeetings] = useState([]);
  const [employeeBirthdays, setEmployeeBirthdays] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [hiredCandidates, setHiredCandidates] = useState([]);
  const [loadingHiredCandidates, setLoadingHiredCandidates] = useState(false);
  const [showHiredCandidates, setShowHiredCandidates] = useState(false);

  const [profilePictures, setProfilePictures] = useState({});
  const [comprehensiveReports, setComprehensiveReports] = useState(null);
  const [reportLoading, setReportLoading] = useState(false);

  const [subscription, setSubscription] = useState(null);
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const [showHelp, setShowHelp] = useState(false); // Add this line

  const [profilePicture, setProfilePicture] = useState(user?.profilePicture || '');
  const [isUploading, setIsUploading] = useState(false);

  const [profileImages, setProfileImages] = useState({});
  const [uploadingImages, setUploadingImages] = useState({});

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isEmployeeModalOpen, setIsEmployeeModalOpen] = useState(false);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [employee, setEmployee] = useState(null);
  const [employeeCount, setEmployeeCount] = useState(0);

  // Add these with your other useState declarations
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [upgradeModalDetails, setUpgradeModalDetails] = useState({
    currentCount: 0,
    limit: 2,
    message: ''
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  const [teamAssignmentModal, setTeamAssignmentModal] = useState({ open: false, manager: null });
  const [fullTeamModal, setFullTeamModal] = useState({ open: false, manager: null });
  const [editManagerModal, setEditManagerModal] = useState({ open: false, manager: null });

  const [managers, setManagers] = useState([]);
  const [managersLoading, setManagersLoading] = useState(false);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [leaveFilter, setLeaveFilter] = useState('all');

  // Add these with your other useState declarations at the top
  const [departmentFilter, setDepartmentFilter] = useState('all');
  const [managerFilter, setManagerFilter] = useState('all');
  const [leaveTypeFilter, setLeaveTypeFilter] = useState('all');
  const [employeeFilter, setEmployeeFilter] = useState('all');

  const navigate = useNavigate();



  // Add this with your other useState declarations
  const [managerLeaves, setManagerLeaves] = useState([]);
  const [managerLeaveFilter, setManagerLeaveFilter] = useState('all');
  const [managerDepartmentFilter, setManagerDepartmentFilter] = useState('all');
  const [managerSearchTerm, setManagerSearchTerm] = useState('');

  // Add these state variables at the top of your component
  const [showTutorial, setShowTutorial] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [tutorialCompleted, setTutorialCompleted] = useState(false);
  const [isTutorialActive, setIsTutorialActive] = useState(false);

  // Check on component mount if user needs tutorial
  useEffect(() => {
    const hasCompletedTutorial = localStorage.getItem('hrPortalTutorialCompleted');
    const isFirstTimeUser = !hasCompletedTutorial;

    if (isFirstTimeUser) {
      // Show tutorial after a brief delay on first visit
      const timer = setTimeout(() => {
        setShowTutorial(true);
        setIsTutorialActive(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);


  useEffect(() => {
    // Load user data from session storage
    const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
    const subscriptionData = JSON.parse(sessionStorage.getItem('subscription') || '{}');

    setUser(userData);
    setSubscription(subscriptionData);

    // Fetch notification count
    fetchUnreadNotifications();

    // Fetch latest subscription status
    fetchSubscriptionStatus();
  }, []);

  const fetchUnreadNotifications = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch('/api/notifications/unread-count', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        setUnreadNotifications(data.count);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const fetchSubscriptionStatus = async () => {
    const lastFetchTime = sessionStorage.getItem('lastSubscriptionFetch');
    const currentTime = Date.now();

    // Only fetch if it's been more than 5 minutes since last fetch
    if (lastFetchTime && (currentTime - parseInt(lastFetchTime)) < 300000) {
      console.log('Skipping subscription fetch - too recent');
      return;
    }
    try {
      const token = sessionStorage.getItem('token');
      const userEmail = user?.email || sessionStorage.getItem('userEmail');

      console.log('🔄 Fetching subscription status for:', userEmail);

      const response = await fetch(
        `${API_BASE_URL}/api/hr/subscription-status?userEmail=${encodeURIComponent(userEmail)}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (!response.ok) {
        console.error('❌ Subscription status fetch failed:', response.status);
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      console.log('📊 Subscription data received:', data);

      if (data.success && data.data) {
        const subscriptionData = data.data;

        // Normalize the plan name - ensure it's always properly formatted
        let planName = 'No Plan';
        if (subscriptionData.planName) {
          // Use the planName from backend if available
          planName = subscriptionData.planName;
        } else if (subscriptionData.plan) {
          // Fallback: format the plan from backend
          const plan = subscriptionData.plan.toLowerCase();
          if (plan.includes('pro')) planName = 'Pro Plan';
          else if (plan.includes('enterprise')) planName = 'Enterprise Plan';
          else if (plan.includes('basic')) planName = 'Basic Plan';
          else if (plan.includes('premium')) planName = 'Premium Plan';
          else if (plan.includes('trial')) planName = 'Trial Plan';
          else planName = subscriptionData.plan.charAt(0).toUpperCase() + subscriptionData.plan.slice(1) + ' Plan';
        }

        const normalizedSubscription = {
          ...subscriptionData,
          planName: planName,
          plan: subscriptionData.plan || 'No Plan',
          isPaid: subscriptionData.isPaid || subscriptionData.status === 'active',
          isTrialActive: subscriptionData.isTrialActive || false,
          trialEnded: subscriptionData.trialEnded || false,
          remainingTrialDays: subscriptionData.remainingTrialDays || 0,
          remainingSubscriptionDays: subscriptionData.remainingSubscriptionDays || 0
        };

        console.log('✅ Normalized subscription:', normalizedSubscription);
        setSubscription(normalizedSubscription);
        sessionStorage.setItem('subscription', JSON.stringify(normalizedSubscription));
      } else {
        console.log('⚠️ No subscription data found');
        // Set default subscription state
        const defaultSubscription = {
          plan: 'No Plan',
          planName: 'No Plan',
          isPaid: false,
          isTrialActive: false,
          trialEnded: false,
          status: 'inactive'
        };
        setSubscription(defaultSubscription);
        sessionStorage.setItem('subscription', JSON.stringify(defaultSubscription));
      }
    } catch (error) {
      console.error('❌ Error fetching subscription status:', error);
      // Set default on error
      const defaultSubscription = {
        plan: 'No Plan',
        planName: 'No Plan',
        isPaid: false,
        isTrialActive: false,
        trialEnded: false,
        status: 'inactive'
      };
      setSubscription(defaultSubscription);
      sessionStorage.setItem('subscription', JSON.stringify(defaultSubscription));
    }
  };

  // Add this function near your other subscription functions
  const refreshSubscriptionAfterPayment = async () => {
    try {
      console.log('🔄 Refreshing subscription status after payment...');

      // Clear any cached subscription data
      sessionStorage.removeItem('subscription');

      // Fetch fresh subscription data
      await fetchSubscriptionStatus();

      // Also refresh user data
      const token = sessionStorage.getItem('token');
      const userRes = await fetch(`${API_BASE_URL}/api/auth/me`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (userRes.ok) {
        const userData = await userRes.json();
        if (userData.user) {
          const updatedUser = {
            ...userData.user,
            name: userData.user.name || sessionStorage.getItem('userName'),
            company: userData.user.company || sessionStorage.getItem('companyName')
          };
          setUser(updatedUser);
          sessionStorage.setItem('userData', JSON.stringify(updatedUser));
        }
      }

      console.log('✅ Subscription refreshed after payment');
    } catch (error) {
      console.error('Error refreshing subscription:', error);
    }
  };


  // In the EnhancedNavigationHeader component, update the subscription badge click handler:

  // Replace your existing handleSubscriptionClick function with this:

  const handleSubscriptionClick = async () => {
    // If user has active paid subscription, don't navigate to pricing page
    await fetchSubscriptionStatus();

    if (subscription?.isPaid) {
      // Show subscription details instead
      toast.success(`You are already on the ${subscription.planName || subscription.plan}. 
      Your subscription is active and managed.`);

      // Optionally, show a modal with subscription details
      // showSubscriptionDetailsModal();
      return;
    }

    // If trial has ended and not paid, navigate to pricing
    if (subscription?.trialEnded && !subscription?.isPaid) {
      const shouldUpgrade = window.confirm(
        'Your free trial has ended. Would you like to upgrade to a paid plan?'
      );

      if (shouldUpgrade) {
        navigate('/hr-pricing', {
          state: {
            userEmail: user?.email,
            companyName: user?.company,
            fromDashboard: true,
            currentSubscription: subscription
          }
        });
      }
      return;
    }


    // If trial is active, ask if they want to upgrade
    if (subscription?.isTrialActive) {
      toast.info(`You have ${subscription.remainingTrialDays} days left in your trial.`);
      return;
    }
    // Default case - navigate to pricing
    navigate('/hr-pricing', {
      state: {
        userEmail: user?.email,
        companyName: user?.company,
        fromDashboard: true,
        currentSubscription: subscription
      }
    });
  };

  useEffect(() => {
    if (subscription?.trialEnded && !subscription?.isPaid) {
      console.log('Trial has ended, please upgrade');
    }
  }, [subscription, navigate]);

  useEffect(() => {
    const fetchEmployeeCount = async () => {
      try {
        const token = sessionStorage.getItem('token');
        const companyName = user?.company || sessionStorage.getItem('companyName');

        const response = await fetch(`${API_BASE_URL}/api/employees/company/${encodeURIComponent(companyName)}/count`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (response.ok) {
          const data = await response.json();
          setEmployeeCount(data.count || 0);
        }
      } catch (error) {
        console.error('Error fetching employee count:', error);
      }
    };

    if (user?.company) {
      fetchEmployeeCount();
    }
  }, [user?.company]);

  // Add this function in HRDashboard.js
  const checkOnboardingAllowed = () => {
    const subscription = JSON.parse(sessionStorage.getItem('subscription') || '{}');
    const employeeCount = employees.length;
    const subscriptionLimit = 2; // Free tier limit

    // If user has paid subscription or pro/enterprise plan, allow unlimited
    if (subscription?.isPaid || subscription?.plan?.toLowerCase().includes('pro') || subscription?.plan?.toLowerCase().includes('enterprise')) {
      return { allowed: true, reason: '' };
    }

    // Free trial/trial ended users can only onboard 2 employees
    if (employeeCount >= subscriptionLimit) {
      return {
        allowed: false,
        reason: `You've reached the limit of ${subscriptionLimit} employees in the free tier. Upgrade to Pro/Enterprise plan to add more employees.`,
        currentCount: employeeCount,
        limit: subscriptionLimit
      };
    }

    return { allowed: true, reason: '' };
  };

  // Employee Dashboard Style Dropdown Navigation
  const dropdownItems = {
    "DASHBOARD": [
      "dashboard",
      "reports",
      "analytics"
    ],
    "EMPLOYEE MANAGEMENT": [
      "employees",
      "departments",
      "managers",
      "onboarding"
    ],
    "LEAVE & ATTENDANCE": [
      "leaves",
      "manager-leaves",
      "attendance",
      "timesheets"
    ],
    "HR OPERATIONS": [
      "recruitment",
      "performance",
      "payroll",
      "documents"
    ],
    "SETTINGS": [
      "settings",
      "calendar",
      "system"
    ]
  };

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage({ type: '', text: '' }), 4000);
  };

  // Frontend upload handler
  const handleProfilePictureUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      alert('Please upload a valid image file (JPEG, PNG, GIF, or WebP)');
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('Image size should be less than 5MB');
      return;
    }

    try {
      setIsUploading(true);

      // Create FormData
      const formData = new FormData();
      formData.append('profilePicture', file);

      // Upload to backend
      const response = await fetch(`${API_BASE_URL}/api/user/upload-profile-picture`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`
        },
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        const newProfilePictureUrl = data.profilePicture.url;

        // 1. Update profile picture in state
        setProfilePicture(newProfilePictureUrl);

        // 2. Also set as company logo in state
        setCompanyLogo(newProfilePictureUrl);

        // 3. Update user in session storage with both
        const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
        userData.profilePicture = newProfilePictureUrl;
        // Store company logo also in session storage if you want
        sessionStorage.setItem('companyLogo', newProfilePictureUrl);
        sessionStorage.setItem('userData', JSON.stringify(userData));

        // 4. Force component to re-render with updated image
        setUser(prev => ({
          ...prev,
          profilePicture: newProfilePictureUrl
        }));

        // 5. Update company logo in local storage or state
        // If you have a companyLogo state
        if (setCompanyLogo) {
          setCompanyLogo(newProfilePictureUrl);
        }

        // 6. Also update in backend for company logo (optional)
        try {
          await fetch(`${API_BASE_URL}/api/company/update-logo`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              companyLogo: newProfilePictureUrl
            })
          });
        } catch (companyLogoError) {
          console.log('Company logo update optional - not critical');
        }

        // Show success message
        showMessage('success', 'Profile picture updated successfully! Also set as company logo.');
      } else {
        throw new Error(data.error || 'Failed to upload profile picture');
      }
    } catch (error) {
      console.error('Profile picture upload error:', error);
      showMessage('error', 'Failed to upload profile picture: ' + error.message);
    } finally {
      setIsUploading(false);
      // Reset file input
      e.target.value = '';
    }
  };


  // Function to fetch profile picture
  const fetchProfilePicture = async () => {
    try {
      const token = sessionStorage.getItem('token');
      if (!token) return;

      const response = await fetch(
        `${API_BASE_URL}/api/user/profile-picture-data-url`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const data = await response.json();

      if (data.success && data.profilePicture) {
        setUser(prev => ({
          ...prev,
          profilePicture: data.profilePicture
        }));

        const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
        userData.profilePicture = data.profilePicture;
        sessionStorage.setItem('userData', JSON.stringify(userData));
      }
    } catch (error) {
      console.error('Fetch profile picture error:', error);
    }
  };


  // Call this on component mount
  useEffect(() => {
    if (user?._id) {
      sessionStorage.setItem('userId', user._id);
      fetchProfilePicture();
    }
  }, [user?._id]);




  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  const handleDropdownItemClick = (item) => {
    if (item === 'onboarding') {
      goToOnboarding();
    } else if (item === 'recruitment') {
      navigate('/hiring-dashboard');
    } else if (item === 'calendar') {
      navigate('/calendar-page');
    } else {
      setActiveTab(item);
    }
    setOpenDropdown(null);
  };


  const calculateCompletionPercentage = (employee) => {
    if (!employee) return 0;

    const fields = [
      employee.name,
      employee.email || employee.company_email,
      employee.mobile,
      employee.department,
      employee.role,
      employee.emp_id
    ];

    // Count how many basic fields are filled
    const basicFieldsFilled = fields.filter(field => field && field.trim().length > 0).length;
    const basicPercentage = (basicFieldsFilled / fields.length) * 40;

    // Check additional sections with more detailed validation
    let sectionPercentage = 0;

    // Personal Info validation - check if it has actual data
    if (employee.personalInfo) {
      let hasPersonalData = false;
      if (Array.isArray(employee.personalInfo)) {
        // Check if array has items and those items have data
        hasPersonalData = employee.personalInfo.length > 0 &&
          employee.personalInfo.some(item =>
            item && Object.keys(item).length > 0
          );
      } else if (typeof employee.personalInfo === 'object' && employee.personalInfo !== null) {
        // Check if object has any meaningful data (not just empty object)
        const keys = Object.keys(employee.personalInfo);
        hasPersonalData = keys.length > 0 &&
          keys.some(key =>
            employee.personalInfo[key] &&
            employee.personalInfo[key].toString().trim().length > 0
          );
      }
      if (hasPersonalData) sectionPercentage += 15;
    }

    // Academic Info validation
    if (employee.academicInfo && Array.isArray(employee.academicInfo)) {
      // Check if array has items with at least qualification/degree
      const hasAcademicData = employee.academicInfo.length > 0 &&
        employee.academicInfo.some(item =>
          item && (item.qualification || item.degree) &&
          (item.university || item.institution)
        );
      if (hasAcademicData) sectionPercentage += 15;
    }

    // Experience Info validation
    if (employee.experienceInfo && Array.isArray(employee.experienceInfo)) {
      // Check if array has items with at least company and role
      const hasExperienceData = employee.experienceInfo.length > 0 &&
        employee.experienceInfo.some(item =>
          item && (item.companyName || item.company) &&
          (item.role || item.position || item.designation)
        );
      if (hasExperienceData) sectionPercentage += 15;
    }

    // Passport Info validation
    if (employee.passportInfo && typeof employee.passportInfo === 'object') {
      // Check if passport has at least passport number
      const hasPassportData = employee.passportInfo.passportNumber &&
        employee.passportInfo.passportNumber.trim().length > 0;
      if (hasPassportData) sectionPercentage += 10;
    }

    // Documents validation
    if (employee.documents && Array.isArray(employee.documents)) {
      // Check if documents array has items with documentUrl
      const hasDocuments = employee.documents.length > 0 &&
        employee.documents.some(doc =>
          doc && (doc.documentUrl || doc.fileUrl)
        );
      if (hasDocuments) sectionPercentage += 5;
    }

    return Math.round(basicPercentage + sectionPercentage);
  };

  const filteredManagerLeaves = managerLeaves.filter(leave => {
    const companyName = user?.company || sessionStorage.getItem('companyName');

    // FIRST: Ensure leave belongs to current company
    const companyMatch = leave.company === companyName ||
      leave.managerCompany === companyName;

    if (!companyMatch) return false;

    // Then apply other filters
    const statusMatch = managerLeaveFilter === 'all' ||
      leave.status.toLowerCase() === managerLeaveFilter.toLowerCase();

    const departmentMatch = managerDepartmentFilter === 'all' ||
      leave.managerDepartment === managerDepartmentFilter;

    const searchMatch = !managerSearchTerm ||
      leave.managerName?.toLowerCase().includes(managerSearchTerm.toLowerCase()) ||
      leave.managerEmail?.toLowerCase().includes(managerSearchTerm.toLowerCase()) ||
      leave.managerDepartment?.toLowerCase().includes(managerSearchTerm.toLowerCase());

    return statusMatch && departmentMatch && searchMatch;
  });

  // Handle sending message to manager
  const sendMessageToManager = (managerId) => {
    console.log('Send message to manager:', managerId);
    // Implementation for sending messages
    const manager = managers.find(m => m._id === managerId);
    if (manager) {
      const message = prompt(`Enter message for ${manager.name}:`);
      if (message) {
        alert(`Message sent to ${manager.name}: ${message}`);
        // Here you would typically call an API to send the message
      }
    }
  };

  // Handle generating manager reports
  const generateManagerReports = () => {
    console.log('Generate manager reports');
    // Implementation for generating reports
    alert('Generating manager performance reports...');
    // This could open a modal with report options or generate PDF/Excel reports
  };

  // Handle exporting manager data
  const exportManagerData = () => {
    console.log('Export manager data');
    try {
      const exportData = managers.map(manager => ({
        'Manager ID': manager.emp_id || 'N/A',
        'Name': manager.name,
        'Email': manager.email,
        'Department': manager.department,
        'Company': manager.company_name,
        'Phone': manager.phone || 'N/A',
        'Team Size': getTeamSize(manager._id),
        'Registration Date': manager.createdAt ? new Date(manager.createdAt).toLocaleDateString('en-IN') : 'N/A',
        'Status': 'Active'
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Managers');

      const fileName = `managers_export_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      alert(`Managers data exported successfully! File: ${fileName}`);
    } catch (error) {
      console.error('Error exporting managers to Excel:', error);
      alert('Error exporting managers data. Please try again.');
    }
  };

  // Handle managing team assignments
  const manageTeamAssignments = () => {
    console.log('Manage team assignments');
    // Implementation for team assignments
    alert('Opening team assignment management dashboard...');
  };



  // Handle assigning team members to a manager
  const handleAssignTeamMembers = (managerId) => {
    console.log('Assign team members to manager:', managerId);
    // This could open a modal or navigate to a team assignment page
    alert(`Assign team members functionality for manager ${managerId}`);
  };

  // Handle sending message to manager
  const handleSendMessageToManager = (managerId) => {
    console.log('Send message to manager:', managerId);
    // Implementation for sending messages
    const manager = managers.find(m => m._id === managerId);
    if (manager) {
      alert(`Message functionality for ${manager.name}`);
    }
  };

  // Handle generating manager reports
  const handleGenerateManagerReports = () => {
    console.log('Generate manager reports');
    // Implementation for generating reports
    alert('Generating manager reports...');
  };

  // Handle exporting manager data
  const handleExportManagerData = () => {
    console.log('Export manager data');
    // Implementation for exporting data
    alert('Exporting manager data...');
  };

  // Handle managing team assignments
  const handleManageTeamAssignments = () => {
    console.log('Manage team assignments');
    // Implementation for team assignments
    alert('Opening team assignment management...');
  };
  // Handle status change with email notification
  const handleStatusChange = async (leave, newStatus) => {
    if (leave.status === newStatus) return;

    try {
      let rejectReason = '';
      const companyName = user?.company || sessionStorage.getItem('companyName');

      // 🔒 SECURITY CHECK: Verify this leave belongs to current company
      if (leave.company !== companyName && leave.managerCompany !== companyName) {
        alert('⛔ Access Denied: You cannot manage leaves from other companies');
        console.error('🚫 HR tried to manage leave from different company:', {
          hrCompany: companyName,
          leaveCompany: leave.company || leave.managerCompany,
          managerName: leave.managerName,
          leaveId: leave._id
        });
        return;
      }

      // If rejecting, ask for reason
      if (newStatus === 'Rejected') {
        const reason = prompt(`Please enter rejection reason for ${leave.managerName}'s leave:`);
        if (reason === null) return; // User cancelled
        if (reason.trim() === '') {
          alert('Please provide a rejection reason.');
          return;
        }
        rejectReason = reason.trim();
      }

      // Confirm action
      const actionText = newStatus === 'Approved' ? 'approve' : 'reject';
      const confirmMessage = newStatus === 'Approved'
        ? `Are you sure you want to approve ${leave.managerName}'s leave request? An approval email will be sent.`
        : `Are you sure you want to reject ${leave.managerName}'s leave request? A rejection email will be sent.`;

      if (!window.confirm(confirmMessage)) {
        // Reset dropdown to original value if user cancels
        await fetchManagerLeaves(); // Refresh to reset dropdown
        return;
      }

      const token = sessionStorage.getItem('token');

      const body = {
        status: newStatus.toLowerCase(),
        approvedBy: user?.name || 'HR Manager',
        company: companyName // Add company to body for backend validation
      };

      if (newStatus === 'Rejected') {
        body.rejectReason = rejectReason;
      }

      console.log(`🔄 HR: Updating manager leave ${leave._id} to ${newStatus} for company ${companyName}`);

      // Update leave status - add company parameter
      const endpoints = [
        `${API_BASE_URL}/api/leave/hr/update-status/${leave._id}?company=${companyName}`,
        `${API_BASE_URL}/api/leave/hr/manager-leaves/${leave._id}/status?company=${companyName}`,
      ];

      let success = false;
      let responseData = null;

      for (const endpoint of endpoints) {
        try {
          const response = await fetch(endpoint, {
            method: "PATCH",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
          });

          if (response.ok) {
            responseData = await response.json();
            console.log(`✅ Manager leave ${newStatus} successfully:`, responseData);
            success = true;
            break;
          } else if (response.status === 403) {
            // Backend rejected due to company mismatch
            alert('⛔ Access Denied: This leave does not belong to your company');
            return;
          }
        } catch (error) {
          console.log(`🚫 Endpoint error:`, error.message);
          continue;
        }
      }

      if (success) {
        // Send email notification
        await sendManagerLeaveEmail(leave, newStatus, rejectReason);

        // Update local state - double-check company match
        setManagerLeaves(prev =>
          prev.map(l =>
            l._id === leave._id && (l.company === companyName || l.managerCompany === companyName)
              ? {
                ...l,
                status: newStatus,
                rejectReason: rejectReason,
                approvedBy: body.approvedBy,
                approvedDate: new Date().toISOString()
              }
              : l
          )
        );

        alert(`✅ Manager leave request ${newStatus.toLowerCase()} successfully! Email notification sent.`);

        // Refresh data to ensure consistency
        setTimeout(() => {
          fetchManagerLeaves();
        }, 1000);
      } else {
        throw new Error('Failed to update leave status');
      }

    } catch (error) {
      console.error('❌ HR: Error updating manager leave request:', error);
      alert('Error updating manager leave request. Please try again.');
      // Refresh to reset dropdown
      await fetchManagerLeaves();
    }
  };

  // Send email notification to manager
  const sendManagerLeaveEmail = async (leave, newStatus, rejectReason = '') => {
    try {
      const token = sessionStorage.getItem('token');

      const emailData = {
        managerEmail: leave.managerEmail,
        managerName: leave.managerName,
        leaveType: leave.leaveType,
        startDate: leave.startDate,
        endDate: leave.endDate,
        totalDays: leave.totalDays,
        status: newStatus,
        rejectReason: rejectReason,
        hrName: user?.name || 'HR Manager',
        companyName: user?.company || 'Company'
      };

      console.log('📧 Sending manager leave notification email:', emailData);

      const response = await fetch(`${API_BASE_URL}/api/leave/hr/send-manager-leave-email`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(emailData)
      });

      if (response.ok) {
        console.log('✅ Manager leave email sent successfully');
      } else {
        console.warn('⚠️ Failed to send manager leave email, but leave status was updated');
      }
    } catch (error) {
      console.error('❌ Error sending manager leave email:', error);
      // Don't fail the whole operation if email fails
    }
  };


  const openTeamAssignmentModal = (manager) => {
    setTeamAssignmentModal({ open: true, manager });
  };

  // 2. Handle Team Assignment
  const handleTeamAssignment = async (managerId, employeeIds) => {
    try {
      const token = sessionStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/api/managers/${managerId}/assign-team`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ employeeIds })
      });

      if (response.ok) {
        const result = await response.json();
        alert('Team members assigned successfully!');

        // Refresh the employees data to update reporting_manager
        await fetchEmployees();
        setTeamAssignmentModal({ open: false, manager: null });
      } else {
        alert('Failed to assign team members');
      }
    } catch (error) {
      console.error('Error assigning team:', error);
      alert('Error assigning team members');
    }
  };



  // 5. Handle Update Manager
  const handleUpdateManager = async (managerId, updatedData) => {
    try {
      const token = sessionStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/api/managers/${managerId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(updatedData)
      });

      if (response.ok) {
        const updatedManager = await response.json();

        // Update managers list
        setManagers(prev =>
          prev.map(m => m._id === managerId ? updatedManager : m)
        );

        alert('Manager updated successfully!');
        setEditManagerModal({ open: false, manager: null });
      } else {
        alert('Failed to update manager');
      }
    } catch (error) {
      console.error('Error updating manager:', error);
      alert('Error updating manager');
    }
  };

  // Team Assignment Modal Component
  const TeamAssignmentModal = ({ manager, allEmployees, assignedTeamMembers, onClose, onAssign }) => {
    const [selectedEmployees, setSelectedEmployees] = useState(
      assignedTeamMembers.map(emp => emp._id)
    );

    const handleEmployeeToggle = (employeeId) => {
      setSelectedEmployees(prev =>
        prev.includes(employeeId)
          ? prev.filter(id => id !== employeeId)
          : [...prev, employeeId]
      );
    };

    const handleSubmit = () => {
      if (selectedEmployees.length === 0) {
        alert('Please select at least one team member');
        return;
      }
      onAssign(manager._id, selectedEmployees);
    };

    return (
      <div className="modal-overlay">
        <div className="modal-content team-assignment-modal">
          <div className="modal-header">
            <h3>Assign Team Members to {manager.name}</h3>
            <button className="modal-close" onClick={onClose}><FiX /></button>
          </div>

          <div className="modal-body">
            <p className="modal-subtitle">Select employees to assign to this manager</p>

            <div className="employees-list-container">
              {allEmployees
                .filter(emp => emp._id !== manager._id) // Don't include the manager themselves
                .map(employee => (
                  <div key={employee._id} className="employee-checkbox-item">
                    <input
                      type="checkbox"
                      id={`emp-${employee._id}`}
                      checked={selectedEmployees.includes(employee._id)}
                      onChange={() => handleEmployeeToggle(employee._id)}
                    />
                    <label htmlFor={`emp-${employee._id}`}>
                      <div className="employee-info">
                        <span className="employee-name">{employee.name}</span>
                        <span className="employee-details">
                          {employee.role} • {employee.department}
                        </span>
                      </div>
                    </label>
                  </div>
                ))}
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-secondary" onClick={onClose}>Cancel</button>
            <button className="btn-primary" onClick={handleSubmit}>
              Assign {selectedEmployees.length} Team Member{selectedEmployees.length !== 1 ? 's' : ''}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const viewFullTeamPage = (manager) => {
    navigate('/manager-team', {
      state: {
        manager,
        teamMembers: getTeamMembers(manager._id)
      }
    });
  };

  // Full Team View Modal Component
  // Inline modal for view full team


  // Edit Manager Modal Component
  const EditManagerModal = ({ manager, departments, onClose, onUpdate }) => {
    const [formData, setFormData] = useState({
      name: manager.name || '',
      email: manager.email || '',
      department: manager.department || '',
      phone: manager.phone || ''
    });

    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });
    };

    const handleSubmit = () => {
      if (!formData.name || !formData.email || !formData.department) {
        alert('Please fill all required fields');
        return;
      }
      onUpdate(manager._id, formData);
    };

    return (
      <div className="modal-overlay">
        <div className="modal-content edit-manager-modal">
          <div className="modal-header">
            <h3>Edit Manager: {manager.name}</h3>
            <button className="modal-close" onClick={onClose}><FiX /></button>
          </div>

          <div className="modal-body">
            <div className="form-grid">
              <div className="form-group">
                <label>Manager Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter manager name"
                />
              </div>

              <div className="form-group">
                <label>Email Address *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email address"
                />
              </div>

              <div className="form-group">
                <label>Department *</label>
                <select
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                >
                  <option value="">Select Department</option>
                  {departments.map(dept => (
                    <option key={dept._id} value={dept.name}>
                      {dept.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter phone number"
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-secondary" onClick={onClose}>Cancel</button>
            <button className="btn-primary" onClick={handleSubmit}>Update Manager</button>
          </div>
        </div>
      </div>
    );
  };


  const fetchManagerLeaves = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const companyName = user?.company || sessionStorage.getItem('companyName');

      console.log('📋 HR: Fetching manager leaves for company:', companyName);

      if (!companyName) {
        console.log('❌ No company name found');
        setManagerLeaves([]);
        return;
      }

      // Company-specific endpoint - primary
      const endpoints = [
        `${API_BASE_URL}/api/leave/hr/manager-leaves/company/${companyName}`,
        `${API_BASE_URL}/api/leave/hr/manager-leaves?company=${companyName}`,
      ];

      let managerLeavesData = [];

      for (const endpoint of endpoints) {
        try {
          console.log(`🔄 Trying manager leaves endpoint: ${endpoint}`);
          const response = await fetch(endpoint, {
            method: "GET",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });

          console.log(`📡 Response status for ${endpoint}:`, response.status);

          if (response.ok) {
            const data = await response.json();
            console.log(`✅ Success from ${endpoint}:`, data);

            let leaves = [];
            if (data.leaves && Array.isArray(data.leaves)) {
              leaves = data.leaves;
            } else if (data.data && Array.isArray(data.data)) {
              leaves = data.data;
            } else if (Array.isArray(data)) {
              leaves = data;
            }

            if (leaves.length > 0) {
              console.log(`🎯 Found ${leaves.length} manager leaves from ${endpoint}`);
              managerLeavesData = leaves;
              break;
            }
          }
        } catch (error) {
          console.log(`🚫 Endpoint error:`, error.message);
          continue;
        }
      }

      // If no company-specific endpoint works, try generic and filter manually
      if (managerLeavesData.length === 0) {
        console.log('🔄 Trying generic manager leaves endpoint with client-side filtering');
        const genericEndpoints = [
          `${API_BASE_URL}/api/leave/hr/manager-leaves`,
          `${API_BASE_URL}/api/leave/hr/all-manager-leaves`,
        ];

        for (const endpoint of genericEndpoints) {
          try {
            const response = await fetch(endpoint, {
              method: "GET",
              headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
              }
            });

            if (response.ok) {
              const data = await response.json();
              let allLeaves = [];

              if (data.leaves && Array.isArray(data.leaves)) {
                allLeaves = data.leaves;
              } else if (data.data && Array.isArray(data.data)) {
                allLeaves = data.data;
              } else if (Array.isArray(data)) {
                allLeaves = data;
              }

              // FILTER BY COMPANY ON CLIENT SIDE
              managerLeavesData = allLeaves.filter(leave =>
                leave.company === companyName ||
                leave.managerCompany === companyName ||
                (leave.manager && leave.manager.company === companyName)
              );

              console.log(`🎯 Filtered ${managerLeavesData.length} manager leaves for company ${companyName}`);
              break;
            }
          } catch (error) {
            console.log(`🚫 Generic endpoint error:`, error.message);
            continue;
          }
        }
      }

      // Normalize the data
      const normalizedLeaves = managerLeavesData.map(leave => ({
        _id: leave._id,
        managerId: leave.managerId,
        managerName: leave.managerName,
        managerEmail: leave.managerEmail,
        managerDepartment: leave.managerDepartment,
        managerCompany: leave.company || leave.managerCompany || companyName,
        leaveType: leave.leaveType,
        startDate: leave.startDate,
        endDate: leave.endDate,
        totalDays: leave.totalDays,
        reason: leave.reason,
        contactInfo: leave.contactInfo,
        handoverTo: leave.handoverTo,
        handoverEmployee: leave.handoverEmployee,
        status: leave.status,
        rejectReason: leave.rejectReason,
        appliedDate: leave.appliedDate,
        approvedBy: leave.approvedBy,
        approvedDate: leave.approvedDate,
        company: leave.company || companyName
      }));

      console.log(`✅ Final manager leaves for ${companyName}:`, normalizedLeaves.length);
      setManagerLeaves(normalizedLeaves);

    } catch (error) {
      console.error('❌ Error fetching manager leaves:', error);
      setManagerLeaves([]);
    }
  };





  const generateSampleManagerLeaves = (managersList) => {
    if (!managersList || managersList.length === 0) {
      console.log('❌ No managers available for sample data');
      return [];
    }

    return managersList.map((manager, index) => ({
      _id: `sample_ml_${index + 1}`,
      managerId: manager._id,
      managerName: manager.name,
      managerEmail: manager.email,
      managerDepartment: manager.department,
      leaveType: ['casual', 'sick', 'vacation', 'personal', 'emergency'][index % 5],
      startDate: new Date(Date.now() + (index + 1) * 7 * 24 * 60 * 60 * 1000).toISOString(),
      endDate: new Date(Date.now() + (index + 2) * 7 * 24 * 60 * 60 * 1000).toISOString(),
      totalDays: 3 + (index % 5),
      reason: 'Need to attend family function and take some rest',
      contactInfo: '+91 9876543210',
      handoverTo: `employee_${index + 1}`,
      handoverEmployee: { name: 'Team Member' },
      status: ['Pending', 'Approved', 'Rejected'][index % 3],
      appliedDate: new Date(Date.now() - index * 2 * 24 * 60 * 60 * 1000).toISOString(),
      company: manager.company_name || 'Devopstrio',
      hrId: manager.createdByHR || 'hr_default_id'
    }));
  };


  // Enhanced manager leave action handler
  // CORRECTED manager leave action handler
  // CORRECTED manager leave action handler
  const handleManagerLeaveAction = async (leaveId, action, rejectReason = "") => {
    try {
      const token = sessionStorage.getItem('token');

      const body = {
        status: action,
        approvedBy: user?.name || 'HR Manager'
      };

      if (action === 'rejected') {
        body.rejectReason = rejectReason || "No reason provided";
      }

      console.log(`🔄 HR: Updating manager leave ${leaveId} to ${action}`);

      const endpoints = [
        `${API_BASE_URL}/api/leave/hr/update-status/${leaveId}`,
        `${API_BASE_URL}/api/leave/hr/manager-leaves/${leaveId}/status`,
      ];

      let success = false;

      for (const endpoint of endpoints) {
        try {
          console.log(`🔄 Trying endpoint: ${endpoint}`);

          const response = await fetch(endpoint, {
            method: "PATCH",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
          });

          console.log(`📡 Response status:`, response.status);

          if (response.ok) {
            const result = await response.json();
            console.log(`✅ Manager leave ${action} successfully:`, result);
            success = true;
            break;
          } else {
            const errorData = await response.json();
            console.log(`❌ Endpoint failed:`, errorData);
          }
        } catch (error) {
          console.log(`🚫 Endpoint error:`, error.message);
          continue;
        }
      }

      if (success) {
        // Update local state
        setManagerLeaves(prev =>
          prev.map(leave =>
            leave._id === leaveId
              ? {
                ...leave,
                status: action.charAt(0).toUpperCase() + action.slice(1),
                rejectReason: body.rejectReason,
                approvedBy: body.approvedBy,
                approvedDate: new Date().toISOString()
              }
              : leave
          )
        );

        alert(`Manager leave request ${action} successfully!`);
        await fetchManagerLeaves(); // Refresh the list
      } else {
        throw new Error('All endpoints failed');
      }

    } catch (error) {
      console.error('❌ HR: Error updating manager leave request:', error);
      alert('Error updating manager leave request. Please try again.');
    }
  };


  // Add this function to handle manager leave approve/reject



  // Add this function to export manager leaves to Excel
  const exportManagerLeavesToExcel = () => {
    try {
      const exportData = managerLeaves.map(leave => ({
        'Manager Name': leave.managerName,
        'Manager Email': leave.managerEmail,
        'Department': leave.managerDepartment,
        'Leave Type': leave.leaveType,
        'Start Date': new Date(leave.startDate).toLocaleDateString('en-IN'),
        'End Date': new Date(leave.endDate).toLocaleDateString('en-IN'),
        'Duration': leave.totalDays + ' days',
        'Status': leave.status,
        'Reason': leave.reason,
        'Contact Info': leave.contactInfo || 'N/A',
        'Applied On': leave.appliedDate ? new Date(leave.appliedDate).toLocaleDateString('en-IN') : 'N/A',
        'Approved By': leave.approvedBy || 'N/A',
        'Approved Date': leave.approvedDate ? new Date(leave.approvedDate).toLocaleDateString('en-IN') : 'N/A',
        'Rejection Reason': leave.rejectReason || 'N/A'
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Manager Leave Requests');

      const fileName = `manager_leaves_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      alert(`Manager leave requests exported successfully! File: ${fileName}`);
    } catch (error) {
      console.error('Error exporting manager leaves to Excel:', error);
      alert('Error exporting manager leave data. Please try again.');
    }
  };

  // Load manager leaves when tab is active
  useEffect(() => {
    if (activeTab === 'manager-leaves') {
      fetchManagerLeaves();
    }
  }, [activeTab]);

  const viewEmployeeDetails = async (employeeId) => {
    try {
      setDetailsLoading(true);
      setSelectedEmployee(employeeId);

      console.log('🔍 Fetching employee details for ID:', employeeId);

      // TRY DIFFERENT ENDPOINTS FOR EMPLOYEE DATA
      const endpoints = [
        `${API_BASE_URL}/api/employees/${employeeId}`,
        `${API_BASE_URL}/api/employees/id/${employeeId}`,
        `${API_BASE_URL}/api/employee/${employeeId}`,
        `${API_BASE_URL}/api/employee/details/${employeeId}`
      ];

      let employeeData = null;
      let success = false;

      // Try each endpoint
      for (const endpoint of endpoints) {
        try {
          console.log(`🔄 Trying endpoint: ${endpoint}`);
          const response = await axios.get(endpoint);

          if (response.data && response.data._id) {
            console.log(`✅ Found employee data from: ${endpoint}`);
            employeeData = response.data;
            success = true;
            break;
          }
        } catch (endpointError) {
          console.log(`❌ Endpoint failed: ${endpoint}`);
          continue;
        }
      }

      if (!success) {
        // If no endpoint works, try to find employee in local state
        console.log('🔄 Searching in local employees array...');
        const localEmployee = employees.find(emp => emp._id === employeeId);
        if (localEmployee) {
          employeeData = localEmployee;
          console.log('✅ Found employee in local state');
        } else {
          throw new Error('Employee not found');
        }
      }

      console.log('📊 Employee basic data:', employeeData);

      // Fetch additional data with fallbacks
      let personalInfo = {};
      let academicInfo = [];
      let experienceInfo = [];
      let passportInfo = {};
      let documents = [];

      // Try to fetch personal info
      try {
        const personalRes = await axios.get(`${API_BASE_URL}/api/personal-info/${employeeId}`);
        personalInfo = personalRes.data || {};
        console.log('✅ Personal info found');
      } catch (error) {
        console.log('❌ No personal info available');
      }

      // Try to fetch academic info
      try {
        const academicRes = await axios.get(`${API_BASE_URL}/api/academic-info/${employeeId}`);
        academicInfo = academicRes.data || [];
        console.log('✅ Academic info found:', academicInfo.length);
      } catch (error) {
        try {
          const academicRes2 = await axios.get(`${API_BASE_URL}/api/academics/${employeeId}`);
          academicInfo = academicRes2.data || [];
          console.log('✅ Academic info from alternative endpoint:', academicInfo.length);
        } catch (error2) {
          console.log('❌ No academic info available');
        }
      }

      // Try to fetch experience info
      try {
        const experienceRes = await axios.get(`${API_BASE_URL}/api/experience-info/${employeeId}`);
        experienceInfo = experienceRes.data || [];
        console.log('✅ Experience info found:', experienceInfo.length);
      } catch (error) {
        try {
          const experienceRes2 = await axios.get(`${API_BASE_URL}/api/experiences/${employeeId}`);
          experienceInfo = experienceRes2.data || [];
          console.log('✅ Experience info from alternative endpoint:', experienceInfo.length);
        } catch (error2) {
          console.log('❌ No experience info available');
        }
      }

      // FIXED: Fetch passport info from new endpoint structure
      try {
        const passportRes = await axios.get(`${API_BASE_URL}/api/employees/${employeeId}/passport`);
        const passportData = passportRes.data || [];

        // Convert array to object format expected by your UI
        if (passportData.length > 0) {
          // Take the most recent passport (sort by expiryDate or createdAt)
          const sortedPassports = passportData.sort((a, b) =>
            new Date(b.expiryDate) - new Date(a.expiryDate)
          );
          const latestPassport = sortedPassports[0];

          passportInfo = {
            passportNumber: latestPassport.passportNumber,
            expiryDate: latestPassport.expiryDate,
            dateOfIssue: latestPassport.issueDate,
            nameOnPassport: latestPassport.nameOnPassport,
            // Get nationality from personal info or employee data
            nationality: personalInfo?.nationality || employeeData?.nationality || 'Indian',
            placeOfIssue: latestPassport.placeOfIssue || 'Not specified',
            dateOfBirth: personalInfo?.dateOfBirth || employeeData?.dateOfBirth || '',
            visaDetails: latestPassport.visaDetails,
            // Keep the original data for reference
            _rawPassportData: passportData
          };
        }
        console.log(`✅ Passport info found: ${passportData.length} record(s)`);
      } catch (error) {
        // Try alternative endpoints as fallback
        try {
          const passportRes2 = await axios.get(`${API_BASE_URL}/api/passport-info/${employeeId}`);
          passportInfo = passportRes2.data || {};
          console.log('✅ Passport info from alternative endpoint');
        } catch (error2) {
          try {
            const passportRes3 = await axios.get(`${API_BASE_URL}/api/passports/${employeeId}`);
            passportInfo = passportRes3.data || {};
            console.log('✅ Passport info from second alternative endpoint');
          } catch (error3) {
            console.log('❌ No passport info available from any endpoint');
          }
        }
      }

      // Try to fetch documents
      try {
        const documentsRes = await axios.get(`${API_BASE_URL}/api/documents/${employeeId}`);
        documents = documentsRes.data || [];
        console.log('✅ Documents found:', documents.length);
      } catch (error) {
        try {
          const documentsRes2 = await axios.get(`${API_BASE_URL}/api/documents/employee/${employeeId}`);
          documents = documentsRes2.data || [];
          console.log('✅ Documents from alternative endpoint:', documents.length);
        } catch (error2) {
          console.log('❌ No documents available');
        }
      }

      // Combine all data
      const combinedData = {
        ...employeeData,
        personalInfo,
        academicInfo,
        experienceInfo,
        passportInfo,
        documents
      };

      console.log('📦 Combined employee data ready');
      setEmployeeDetails(combinedData);
      setIsEmployeeModalOpen(true);

    } catch (error) {
      console.error('❌ Error fetching employee details:', error);

      // Show error message
      alert(`Unable to load employee details. Error: ${error.message}`);

      // Fallback: Show basic modal with available data
      try {
        const basicResponse = await axios.get(`${API_BASE_URL}/api/employees`);
        const allEmployees = basicResponse.data || [];
        const employee = allEmployees.find(emp => emp._id === employeeId) ||
          employees.find(emp => emp._id === employeeId);

        if (employee) {
          setEmployeeDetails(employee);
          setIsEmployeeModalOpen(true);
        } else {
          alert('Employee not found in the system.');
        }
      } catch (fallbackError) {
        console.error('Fallback also failed:', fallbackError);
        alert('Could not retrieve employee information. Please try again.');
      }
    } finally {
      setDetailsLoading(false);
    }
  };

  // Enhanced leave export function
  const exportLeavesToExcel = () => {
    try {
      const exportData = leaveRequests.map(leave => ({
        'Employee ID': leave.employeeId || 'N/A',
        'Employee Name': leave.employeeName || 'N/A',
        'Leave Type': leave.type || leave.leaveType || 'N/A',
        'Start Date': new Date(leave.startDate).toLocaleDateString('en-IN'),
        'End Date': new Date(leave.endDate).toLocaleDateString('en-IN'),
        'Duration': leave.leaveDays || 'N/A',
        'Status': leave.status,
        'Reason': leave.reason || 'N/A',
        'Applied On': leave.applicationDate ? new Date(leave.applicationDate).toLocaleDateString('en-IN') : 'N/A',
        'Reporting Manager': leave.reportingManager || 'N/A',
        'Rejection Reason': leave.rejectReason || 'N/A'
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Leave Requests');

      const fileName = `leave_requests_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      alert(`Leave requests exported successfully! File: ${fileName}`);
    } catch (error) {
      console.error('Error exporting leaves to Excel:', error);
      alert('Error exporting leave data. Please try again.');
    }
  };

  // Enhanced leave filtering
  const filteredLeaveRequests = leaveRequests.filter(leave => {
    const matchesStatus = leaveFilter === 'all' ||
      leave.status.toLowerCase() === leaveFilter.toLowerCase();

    const matchesSearch = !searchTerm ||
      leave.employeeName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      leave.employeeId?.toLowerCase().includes(searchTerm.toLowerCase());

    return matchesStatus && matchesSearch;
  });

  useEffect(() => {
    if (activeTab === 'leaves') {
      fetchAllLeaveRequests();
    }
  }, [activeTab]);

  const handleLeaveAction = async (leaveId, action, rejectReason = "") => {
    try {
      const token = sessionStorage.getItem('token');

      // Convert to proper case for backend - Handle both "Pending" and "pending"
      const statusMap = {
        'approved': 'Approved',
        'rejected': 'Rejected',
        'pending': 'Pending'
      };

      const backendStatus = statusMap[action] || action;

      const body = { status: backendStatus };
      if (backendStatus === 'Rejected') {
        body.rejectReason = rejectReason || "No reason provided";
      }

      console.log(`🔄 HR: Updating leave ${leaveId} to ${backendStatus}`);

      const response = await fetch(`${API_BASE_URL}/api/leave/${leaveId}`, {
        method: "PATCH",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
      });

      if (response.ok) {
        const result = await response.json();
        console.log(`✅ HR: Leave ${backendStatus} successfully:`, result);

        // Update local state - handle both "Pending" and "pending" formats
        setLeaveRequests(prev =>
          prev.map(leave =>
            leave._id === leaveId
              ? {
                ...leave,
                status: backendStatus,
                rejectReason: body.rejectReason
              }
              : leave
          )
        );

        alert(`Leave request ${backendStatus} successfully!`);

        // Refresh leave requests
        await fetchAllLeaveRequests();
      } else {
        const errorData = await response.json();
        console.error('❌ HR: Failed to update leave:', errorData);
        alert(errorData.message || 'Failed to update leave request');
      }
    } catch (error) {
      console.error('❌ HR: Error updating leave request:', error);
      alert('Error updating leave request. Please try again.');
    }
  };

  // Calculate leave approval rate
  const getLeaveApprovalRate = (managerId) => {
    try {
      const teamLeaves = leaveRequests.filter(req => {
        const teamMembers = getTeamMembers(managerId);
        const teamMemberIds = teamMembers.map(m => m._id);
        return teamMemberIds.includes(req.employeeId);
      });

      if (teamLeaves.length === 0) return 0;

      const approvedLeaves = teamLeaves.filter(l => l.status === 'approved').length;
      return Math.round((approvedLeaves / teamLeaves.length) * 100);
    } catch (error) {
      console.error('Error calculating leave approval rate:', error);
      return 0;
    }
  };

  // Improved task completion rate with real data




  // Add this function to handle manager profile images
  const getManagerProfileImageUrl = (manager) => {
    if (!manager) return null;

    // If manager has profile image data
    if (manager.profileImage && manager.profileImage.data) {
      const url = `${API_BASE_URL}/api/managers/${manager._id}/profile-image?t=${Date.now()}`;
      console.log('Generated manager image URL:', url);
      return url;
    }

    // If profileImageUrl exists
    if (manager.profileImageUrl) {
      const url = `${API_BASE_URL}${manager.profileImageUrl}?t=${Date.now()}`;
      console.log('Using profileImageUrl:', url);
      return url;
    }

    console.log('No profile image available for manager:', manager.name);
    return null;
  };

  // Manager image error handler
  const handleManagerImageError = (e, manager) => {
    console.log('Manager image failed to load:', manager.name);
    e.target.style.display = 'none';
    // Show fallback initial
    const parent = e.target.parentElement;
    const initial = parent.querySelector('.hr-portal-manager-avatar-fallback');
    if (initial) {
      initial.style.display = 'flex';
    }
  };

  const handleManagerImageLoad = (e) => {
    console.log('Manager image loaded successfully');
    // Hide the initial when image loads
    const parent = e.target.parentElement;
    const initial = parent.querySelector('.hr-portal-manager-avatar-fallback');
    if (initial) {
      initial.style.display = 'none';
    }
  };


  // Add these functions to generate mock data when APIs don't return data
  const generateMockLeaveRequests = () => {
    if (employees.length === 0) {
      // Return some basic mock data if no employees
      return [
        {
          _id: 'mock_leave_1',
          employeeId: 'mock_emp_1',
          employeeName: 'John Doe',
          startDate: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(),
          endDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(),
          type: 'Casual Leave',
          status: 'Pending',
          reason: 'Family function',
          applicationDate: new Date().toISOString(),
          leaveDays: 4
        },
        {
          _id: 'mock_leave_2',
          employeeId: 'mock_emp_2',
          employeeName: 'Jane Smith',
          startDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
          endDate: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString(),
          type: 'Sick Leave',
          status: 'Approved',
          reason: 'Medical appointment',
          applicationDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
          leaveDays: 3
        }
      ];
    }

    return employees.slice(0, 5).map(employee => ({
      _id: `mock_leave_${employee._id}`,
      employeeId: employee._id,
      employeeName: employee.name,
      startDate: new Date(Date.now() + Math.random() * 7 * 24 * 60 * 60 * 1000),
      endDate: new Date(Date.now() + (Math.random() * 7 + 3) * 24 * 60 * 60 * 1000),
      type: ['Sick Leave', 'Casual Leave', 'Emergency Leave'][Math.floor(Math.random() * 3)],
      status: Math.random() > 0.7 ? 'Pending' : (Math.random() > 0.5 ? 'Approved' : 'Rejected'),
      reason: 'Personal reasons',
      applicationDate: new Date(),
      leaveDays: Math.floor(Math.random() * 10) + 1,
      reportingManager: employee.reporting_manager
    }));
  };

  const generateMockAttendanceData = () => {
    if (employees.length === 0) return [];

    const today = new Date().toISOString().split('T')[0];
    return employees.map(employee => ({
      _id: `mock_att_${employee._id}`,
      employeeId: employee._id,
      employeeName: employee.name,
      date: today,
      status: Math.random() > 0.2 ? 'present' : 'absent',
      checkIn: '09:00',
      checkOut: '18:00'
    }));
  };


  const fetchAllLeaveRequests = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const companyName = user?.company || sessionStorage.getItem('companyName');

      console.log('📋 HR: Fetching leave requests for company:', companyName);

      if (!companyName) {
        console.log('❌ No company name found');
        setLeaveRequests([]);
        return [];
      }

      // ✅ Use company-specific endpoint as primary
      const primaryEndpoint = `${API_BASE_URL}/api/leave/company/${companyName}`;
      console.log(`🔄 HR: Trying leave endpoint: ${primaryEndpoint}`);

      const response = await fetch(primaryEndpoint, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      let allLeaveRequests = [];

      if (response.ok) {
        const leaveData = await response.json();
        console.log(`✅ HR: Leave data from company endpoint:`, leaveData);

        // Handle different response formats
        const requests = leaveData.data || leaveData.leaveRequests || leaveData || [];

        // Normalize status
        const normalizedRequests = requests.map(request => ({
          ...request,
          status: request.status?.charAt(0).toUpperCase() + request.status?.slice(1).toLowerCase() || 'Pending',
          employeeName: request.employeeName || request.employee?.name || 'Unknown Employee'
        }));

        allLeaveRequests = normalizedRequests;
        console.log(`🎯 HR: Found ${normalizedRequests.length} leave requests from company endpoint`);
      } else {
        // Fallback to generic endpoint and filter by company
        console.log(`❌ Company-specific endpoint failed, trying generic endpoint`);
        const genericEndpoint = `${API_BASE_URL}/api/leave/all`;
        const genericResponse = await fetch(genericEndpoint, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        if (genericResponse.ok) {
          const genericData = await genericResponse.json();
          const allRequests = genericData.data || genericData.leaveRequests || genericData || [];

          // ✅ Filter by company on the client side
          allLeaveRequests = allRequests.filter(request =>
            request.company === companyName ||
            (request.employee && request.employee.company === companyName)
          );

          console.log(`🎯 HR: Found ${allLeaveRequests.length} leave requests after filtering`);
        }
      }

      console.log('✅ HR: Final leave requests for company:', allLeaveRequests);
      setLeaveRequests(allLeaveRequests);
      return allLeaveRequests;

    } catch (error) {
      console.error('❌ HR: Error fetching leave requests:', error);
      setLeaveRequests([]);
      return [];
    }
  };

  // Fetch attendance data
  const fetchAttendanceData = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const today = new Date().toISOString().split('T')[0];

      const response = await fetch(`${API_BASE_URL}/api/attendance?date=${today}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        const attendanceData = await response.json();
        setAttendanceData(attendanceData.data || attendanceData || []);
      } else {
        console.error('Failed to fetch attendance data');
        setAttendanceData([]);
      }
    } catch (error) {
      console.error('Error fetching attendance data:', error);
      setAttendanceData([]);
    }
  };


  useEffect(() => {
    if (activeTab === 'managers') {
      const loadManagersData = async () => {
        await fetchAllManagers();

        // Try to fetch real data first
        let leaveData = await fetchAllLeaveRequests();
        let attendanceData = await fetchAttendanceData();

        // If no real data, generate mock data
        if (!leaveData || leaveData.length === 0) {
          const mockLeaves = generateMockLeaveRequests();
          setLeaveRequests(mockLeaves);
        }

        if (!attendanceData || attendanceData.length === 0) {
          const mockAttendance = generateMockAttendanceData();
          setAttendanceData(mockAttendance);
        }
      };

      loadManagersData();
    }
  }, [activeTab]);

  // Also update the existing fetchDashboardStats to include leave and attendance data if needed


  // HRDashboard.js - Update the fetchAllManagers function

  const fetchAllManagers = async () => {
    try {
      setManagersLoading(true);
      const token = sessionStorage.getItem('token');
      const companyName = user?.company || sessionStorage.getItem('companyName');

      console.log('🔄 Fetching REAL managers data for company:', companyName);

      if (!token || !companyName) {
        console.error('❌ No authentication token or company name found');
        setManagers([]);
        return;
      }

      // Always use company-specific endpoints
      const endpoints = [
        `${API_BASE_URL}/api/managers/company/${companyName}`,
        `${API_BASE_URL}/api/managers?company_name=${encodeURIComponent(companyName)}`,
        `${API_BASE_URL}/api/managers?company=${encodeURIComponent(companyName)}`
      ];

      let managersData = [];

      for (const endpoint of endpoints) {
        try {
          console.log(`🔍 Trying company-specific endpoint: ${endpoint}`);
          const response = await fetch(endpoint, {
            method: "GET",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });

          console.log(`📡 Response status for ${endpoint}:`, response.status);

          if (response.ok) {
            const data = await response.json();
            console.log(`✅ Success from ${endpoint}:`, data);

            // Handle different response formats
            if (Array.isArray(data)) {
              managersData = data;
            } else if (data.data && Array.isArray(data.data)) {
              managersData = data.data;
            } else if (data.managers && Array.isArray(data.managers)) {
              managersData = data.managers;
            }

            if (managersData.length > 0) {
              console.log(`🎯 Found ${managersData.length} REAL managers from ${endpoint}`);
              break;
            }
          }
        } catch (error) {
          console.log(`🚫 Endpoint error:`, error.message);
          continue;
        }
      }

      // If no managers found from APIs, show empty state
      if (managersData.length === 0) {
        console.log(`⚠️ No managers found for company: ${companyName}`);
      }

      console.log('<FiUser /> Final managers data for company:', managersData);
      setManagers(managersData);

    } catch (error) {
      console.error('❌ Error fetching managers:', error);
      setManagers([]);
    } finally {
      setManagersLoading(false);
    }
  };

  // Get team size for a manager
  // HRDashboard.js - Update the getTeamSize function

  // Get team size for a manager - IMPROVED VERSION
  const getTeamSize = (managerId) => {
    if (!employees.length) {
      console.log('❌ No employees data available');
      return 0;
    }

    const manager = managers.find(m => m._id === managerId);
    if (!manager) {
      console.log('❌ Manager not found with ID:', managerId);
      return 0;
    }

    console.log('🔍 Finding team members for manager:', manager.name);
    console.log('📊 Total employees:', employees.length);

    const teamMembers = employees.filter(emp => {
      // Check all possible reporting manager formats
      const matches =
        emp.reporting_manager === managerId ||
        emp.reporting_manager === manager?._id ||
        emp.reporting_manager === manager?.name ||
        emp.reporting_manager?.name === manager?.name ||
        emp.reporting_manager === manager?.manager_id ||
        emp.reporting_manager === manager?.emp_id;

      if (matches) {
        console.log('✅ Team member found:', emp.name, '| Reporting manager:', emp.reporting_manager);
      }

      return matches;
    });

    console.log(`<FiUsers /> Manager ${manager.name} has ${teamMembers.length} team members`);
    return teamMembers.length;
  };

  // Get team members for a manager - IMPROVED VERSION
  // HRDashboard.jsx - Fix the getTeamMembers function
  const getTeamMembers = (managerId) => {
    if (!employees.length) {
      console.log('❌ No employees data available');
      return [];
    }

    const manager = managers.find(m => m._id === managerId);
    if (!manager) {
      console.log('❌ Manager not found with ID:', managerId);
      return [];
    }

    console.log('🔍 Finding team members for manager:', manager.name);
    console.log('📊 Total employees:', employees.length);

    const teamMembers = employees.filter(emp => {
      // Check all possible reporting manager formats
      const matches =
        emp.reporting_manager === managerId ||
        emp.reporting_manager === manager?._id ||
        emp.reporting_manager === manager?.name ||
        emp.reporting_manager?.name === manager?.name ||
        emp.reporting_manager === manager?.manager_id ||
        emp.reporting_manager === manager?.emp_id;

      if (matches) {
        console.log('✅ Team member found:', emp.name, '| Reporting manager:', emp.reporting_manager);
      }

      return matches;
    });

    console.log(`<FiUsers /> Manager ${manager.name} has ${teamMembers.length} team members:`, teamMembers.map(m => m.name));
    return teamMembers;
  };

  const getTeamLeaveRequests = (managerId) => {
    if (!leaveRequests.length) return [];

    const teamMembers = getTeamMembers(managerId);
    const teamMemberIds = teamMembers.map(member => member._id);

    return leaveRequests.filter(request =>
      teamMemberIds.includes(request.employeeId)
    );
  };

  const getPendingLeaveRequests = (managerId) => {
    try {
      const teamLeaves = getTeamLeaveRequests(managerId);
      return teamLeaves.filter(leave =>
        leave.status === 'Pending' || leave.status === 'pending'
      ).length;
    } catch (error) {
      console.error('Error calculating pending leave requests:', error);
      return 0;
    }
  };


  const getTeamAttendanceCount = (managerId) => {
    try {
      const teamAttendance = getTeamAttendance(managerId);
      const today = new Date().toISOString().split('T')[0];
      return teamAttendance.filter(att =>
        att.date === today && att.status === 'present'
      ).length;
    } catch (error) {
      console.error('Error calculating team attendance:', error);
      return 0;
    }
  };

  // Get team attendance for today - IMPROVED
  const getTeamAttendance = (managerId) => {
    if (!attendanceData.length) return [];

    const teamMembers = getTeamMembers(managerId);
    const teamMemberIds = teamMembers.map(member => member._id);

    return attendanceData.filter(att =>
      teamMemberIds.includes(att.employeeId)
    );
  };

  // Calculate task completion rate
  const getTaskCompletionRate = (managerId) => {
    const teamMembers = getTeamMembers(managerId);
    if (teamMembers.length === 0) return 0;

    // This would need integration with your task management system
    // For now, returning a mock value
    return Math.floor(Math.random() * 40) + 60; // 60-100%
  };

  // Calculate team productivity
  const getTeamProductivity = (managerId) => {
    const teamMembers = getTeamMembers(managerId);
    if (teamMembers.length === 0) return 0;

    // Mock productivity calculation
    return Math.floor(Math.random() * 30) + 70; // 70-100%
  };

  // Calculate total team size across all managers
  const calculateTotalTeamSize = () => {
    return managers.reduce((total, manager) => total + getTeamSize(manager._id), 0);
  };

  // Export managers to Excel
  const exportManagersToExcel = () => {
    try {
      const exportData = managers.map(manager => ({
        'Manager ID': manager.emp_id || 'N/A',
        'Name': manager.name,
        'Email': manager.email,
        'Department': manager.department,
        'Company': manager.company_name,
        'Phone': manager.phone || 'N/A',
        'Team Size': getTeamSize(manager._id),
        'Registration Date': manager.createdAt ? new Date(manager.createdAt).toLocaleDateString('en-IN') : 'N/A',
        'Last Active': manager.lastLogin ? new Date(manager.lastLogin).toLocaleDateString('en-IN') : 'Never'
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Managers');

      const fileName = `managers_export_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      alert(`Managers data exported successfully! File: ${fileName}`);
    } catch (error) {
      console.error('Error exporting managers to Excel:', error);
      alert('Error exporting managers data. Please try again.');
    }
  };

  // View manager details
  const viewManagerDetails = (managerId) => {
    navigate(`/manager-details/${managerId}`);
  };

  // Edit manager
  const editManager = (managerId) => {
    navigate(`/manager-registration?edit=${managerId}`);
  };

  // View manager team
  const viewManagerTeam = (managerId) => {
    navigate(`/manager-team/${managerId}`);
  };

  // Load managers when tab is active
  useEffect(() => {
    if (activeTab === 'managers') {
      fetchAllManagers();
    }
  }, [activeTab]);


  // Add these functions inside your HRDashboard component, before the return statement

  // Function to handle image upload
  const handleImageUpload = async (employeeId, event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file');
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('Image size should be less than 5MB');
      return;
    }

    setUploadingImages(prev => ({ ...prev, [employeeId]: true }));

    try {
      const token = sessionStorage.getItem('token');
      const formData = new FormData();
      formData.append('profilePic', file);

      const response = await fetch(`${API_BASE_URL}/api/profiles/${employeeId}/profile-picture`, {
        method: 'PUT',
        headers: {
          "Authorization": `Bearer ${token}`
        },
        body: formData
      });

      if (response.ok) {
        const updatedProfile = await response.json();
        setProfileImages(prev => ({
          ...prev,
          [employeeId]: updatedProfile.profilePic
        }));
        alert('Profile image updated successfully!');
      } else {
        throw new Error('Failed to upload image');
      }
    } catch (error) {
      console.error('Error uploading profile image:', error);
      alert('Error uploading profile image');
    } finally {
      setUploadingImages(prev => ({ ...prev, [employeeId]: false }));
    }
  };

  // Function to fetch profile images for all employees
  const fetchAllProfileImages = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const imagePromises = employees.map(async (employee) => {
        try {
          const response = await fetch(`${API_BASE_URL}/api/profiles/${employee._id}`, {
            headers: { "Authorization": `Bearer ${token}` }
          });

          if (response.ok) {
            const profileData = await response.json();
            return {
              employeeId: employee._id,
              profilePic: profileData.profilePic
            };
          }
          return null;
        } catch (error) {
          console.error(`Error fetching profile for ${employee.name}:`, error);
          return null;
        }
      });

      const results = await Promise.all(imagePromises);
      const newProfileImages = {};

      results.forEach(result => {
        if (result && result.profilePic) {
          newProfileImages[result.employeeId] = result.profilePic;
        }
      });

      setProfileImages(newProfileImages);
      console.log('✅ Loaded profile images for', Object.keys(newProfileImages).length, 'employees');
    } catch (error) {
      console.error('Error fetching profile images:', error);
    }
  };

  // Fetch images when employees data changes or when reports are generated
  useEffect(() => {
    if (employees.length > 0 && comprehensiveReports) {
      fetchAllProfileImages();
    }
  }, [employees, comprehensiveReports]);

  // Fetch images when employees data changes
  useEffect(() => {
    if (employees.length > 0) {
      fetchAllProfileImages();
    }
  }, [employees]);

  // Function to refresh single employee image
  const refreshEmployeeImage = async (employeeId) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/profiles/${employeeId}`, {
        headers: { "Authorization": `Bearer ${token}` }
      });

      if (response.ok) {
        const profileData = await response.json();
        setProfileImages(prev => ({
          ...prev,
          [employeeId]: profileData.profilePic
        }));
        console.log('🔄 Refreshed image for employee:', employeeId);
      }
    } catch (error) {
      console.error('Error refreshing employee image:', error);
    }
  };
  // Helper function for department statistics
  const generateDepartmentStats = (employees) => {
    const departmentStats = {};

    employees.forEach(employee => {
      if (!departmentStats[employee.department]) {
        departmentStats[employee.department] = {
          total: 0,
          active: 0,
          roles: new Set()
        };
      }

      departmentStats[employee.department].total++;
      if (employee.status === 'active') {
        departmentStats[employee.department].active++;
      }
      departmentStats[employee.department].roles.add(employee.role);
    });

    return Object.entries(departmentStats).map(([dept, stats]) => ({
      department: dept,
      totalEmployees: stats.total,
      activeEmployees: stats.active,
      roles: Array.from(stats.roles),
      percentage: employees.length > 0 ? ((stats.total / employees.length) * 100).toFixed(1) : '0'
    }));
  };

  // Helper function for hiring trends
  const generateHiringTrends = (employees) => {
    const monthlyHires = Array(12).fill(0);
    const currentYear = new Date().getFullYear();

    employees.forEach(employee => {
      if (employee.joiningDate) {
        const joinDate = new Date(employee.joiningDate);
        if (joinDate.getFullYear() === currentYear) {
          monthlyHires[joinDate.getMonth()]++;
        }
      }
    });

    return {
      monthlyHires,
      currentYear
    };
  };

  // Export comprehensive reports function
  const exportComprehensiveReports = () => {
    try {
      if (!comprehensiveReports) {
        alert('Please generate comprehensive reports first');
        return;
      }

      // Prepare data for export - include all employee details
      const exportData = comprehensiveReports.employeeReports.map(report => ({
        'Employee ID': report.employee.emp_id || 'N/A',
        'Name': report.employee.name,
        'Department': report.employee.department,
        'Role': report.employee.role,
        'Status': report.employee.status,
        'Email': report.employee.email,
        'Company Email': report.employee.company_email,
        'Mobile': report.employee.mobile,
        'Joining Date': report.employee.joiningDate ? new Date(report.employee.joiningDate).toLocaleDateString() : 'N/A',
        'Academic Records': report.academicDetails.length,
        'Experience Records': report.experienceDetails.length,
        'Has Passport': report.passportDetails.length > 0 ? 'Yes' : 'No',
        'Personal Info': report.personalInfo ? 'Complete' : 'Incomplete',
        'Profile Completion': `${((report.summary.academicRecords > 0 ? 25 : 0) +
          (report.summary.experienceRecords > 0 ? 25 : 0) +
          (report.summary.hasPassport ? 25 : 0) +
          (report.summary.hasPersonalInfo ? 25 : 0))}%`
      }));

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Create workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Employee Comprehensive Reports');

      // Generate Excel file
      const fileName = `comprehensive_employee_reports_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      alert(`Comprehensive employee reports exported successfully! File: ${fileName}`);
    } catch (error) {
      console.error('Error exporting comprehensive reports to Excel:', error);
      alert('Error exporting comprehensive reports. Please try again.');
    }
  };

  // Also add this function to handle the sample report generation properly
  const generateSampleComprehensiveReports = () => {
    // Use the actual employees data to generate meaningful sample reports
    const sampleReports = {
      employeeReports: employees.map(employee => {
        // Generate some sample academic, experience, and passport data
        const hasAcademic = Math.random() > 0.3; // 70% chance
        const hasExperience = Math.random() > 0.2; // 80% chance
        const hasPassport = Math.random() > 0.5; // 50% chance
        const hasPersonalInfo = Math.random() > 0.4; // 60% chance

        return {
          employee: {
            _id: employee._id,
            emp_id: employee.emp_id,
            name: employee.name,
            email: employee.email,
            company_email: employee.company_email,
            mobile: employee.mobile,
            department: employee.department,
            role: employee.role,
            status: employee.status,
            joiningDate: employee.joiningDate
          },
          academicDetails: hasAcademic ? [
            {
              qualification: 'Bachelor of Engineering',
              university: 'Sample University',
              yearOfPassing: 2020,
              grade: 'First Class'
            }
          ] : [],
          experienceDetails: hasExperience ? [
            {
              company: 'Previous Company',
              position: 'Software Engineer',
              duration: '2 years'
            }
          ] : [],
          passportDetails: hasPassport ? [
            {
              passportNumber: 'A12345678',
              expiryDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString(),
              nationality: 'Indian'
            }
          ] : [],
          personalInfo: hasPersonalInfo ? {
            dob: '1990-01-01',
            gender: 'Male',
            address: 'Sample Address'
          } : null,
          summary: {
            academicRecords: hasAcademic ? 1 : 0,
            experienceRecords: hasExperience ? 1 : 0,
            hasPassport: hasPassport,
            hasPersonalInfo: hasPersonalInfo
          }
        };
      }),
      overallStats: {
        totalEmployees: employees.length,
        employeesWithCompleteProfile: employees.filter((_, index) => index % 3 === 0).length, // Roughly 33% have complete profiles
        departments: [...new Set(employees.map(e => e.department))],
        departmentWise: generateDepartmentStats(employees),
        hiringTrends: generateHiringTrends(employees)
      }
    };

    setComprehensiveReports(sampleReports);
  };


  const fetchActualEmployeeData = async () => {
    try {
      console.log('🔄 Fetching ACTUAL data from individual APIs...');
      const token = sessionStorage.getItem('token');

      const reports = await Promise.all(
        employees.map(async (employee) => {
          try {
            // Fetch ACTUAL data for each employee from CORRECT endpoints
            const [academicRes, experienceRes, passportRes, personalRes] = await Promise.allSettled([
              // Academic API
              fetch(`${API_BASE_URL}/api/academics/${employee._id}`, {
                headers: { "Authorization": `Bearer ${token}` }
              }),
              // Experience API - FIXED: Changed from /api/experience/ to /api/experiences/
              fetch(`${API_BASE_URL}/api/experiences/${employee._id}`, {
                headers: { "Authorization": `Bearer ${token}` }
              }),
              // Passport API - FIXED: Check if this endpoint exists
              fetch(`${API_BASE_URL}/api/passports/${employee._id}`, {
                headers: { "Authorization": `Bearer ${token}` }
              }),
              // Personal Info API
              fetch(`${API_BASE_URL}/api/personal-info/${employee._id}`, {
                headers: { "Authorization": `Bearer ${token}` }
              })
            ]);

            // Process ACTUAL responses with better error handling
            let academicDetails = [];
            if (academicRes.status === 'fulfilled' && academicRes.value.ok) {
              const academicData = await academicRes.value.json();
              academicDetails = Array.isArray(academicData) ? academicData :
                (academicData.data || academicData.academics || []);
            }

            let experienceDetails = [];
            if (experienceRes.status === 'fulfilled') {
              if (experienceRes.value.ok) {
                const expData = await experienceRes.value.json();
                experienceDetails = Array.isArray(expData) ? expData :
                  (expData.data || expData.experiences || []);
                console.log(`✅ Experience data for ${employee.name}:`, experienceDetails.length, 'records');
              } else {
                console.log(`❌ Experience API failed for ${employee.name}:`, experienceRes.value.status);
                // Try alternative endpoint
                try {
                  const altResponse = await fetch(`${API_BASE_URL}/api/experience/${employee._id}`, {
                    headers: { "Authorization": `Bearer ${token}` }
                  });
                  if (altResponse.ok) {
                    const altData = await altResponse.json();
                    experienceDetails = Array.isArray(altData) ? altData :
                      (altData.data || altData.experience || []);
                    console.log(`✅ Experience data from alternative endpoint for ${employee.name}:`, experienceDetails.length, 'records');
                  }
                } catch (altError) {
                  console.log(`❌ Alternative experience endpoint also failed for ${employee.name}`);
                }
              }
            }

            let passportDetails = [];
            if (passportRes.status === 'fulfilled') {
              if (passportRes.value.ok) {
                const passportData = await passportRes.value.json();
                passportDetails = Array.isArray(passportData) ? passportData :
                  (passportData.data || passportData.passports || []);
                console.log(`✅ Passport data for ${employee.name}:`, passportDetails.length, 'records');
              } else {
                console.log(`❌ Passport API failed for ${employee.name}:`, passportRes.value.status);
                // Try alternative endpoint
                try {
                  const altResponse = await fetch(`${API_BASE_URL}/api/employees/${employee._id}/passport`, {
                    headers: { "Authorization": `Bearer ${token}` }
                  });
                  if (altResponse.ok) {
                    const altData = await altResponse.json();
                    passportDetails = Array.isArray(altData) ? altData :
                      (altData.data || altData.passport || []);
                    console.log(`✅ Passport data from alternative endpoint for ${employee.name}:`, passportDetails.length, 'records');
                  }
                } catch (altError) {
                  console.log(`❌ Alternative passport endpoint also failed for ${employee.name}`);
                }
              }
            }

            let personalInfo = null;
            if (personalRes.status === 'fulfilled' && personalRes.value.ok) {
              const personalData = await personalRes.value.json();
              // Handle different response formats
              personalInfo = personalData.success ? personalData.data :
                (personalData.personalInfo || personalData);

              console.log(`✅ Personal Info for ${employee.name}:`, personalInfo ? 'Exists' : 'No data');
            } else {
              console.log(`❌ Personal Info API failed for ${employee.name}:`,
                personalRes.status === 'fulfilled' ? personalRes.value.status : 'Rejected');
            }

            console.log(`📋 ${employee.name} Data Summary:`, {
              academics: academicDetails.length,
              experiences: experienceDetails.length,
              passport: passportDetails.length,
              personalInfo: !!personalInfo,
              personalInfoFields: personalInfo ? Object.keys(personalInfo) : 'No data'
            });

            return {
              employee: {
                _id: employee._id,
                emp_id: employee.emp_id,
                name: employee.name,
                email: employee.email,
                company_email: employee.company_email,
                mobile: employee.mobile,
                department: employee.department,
                role: employee.role,
                status: employee.status,
                joiningDate: employee.joiningDate
              },
              academicDetails,
              experienceDetails,
              passportDetails,
              personalInfo,
              summary: {
                academicRecords: academicDetails.length,
                experienceRecords: experienceDetails.length,
                hasPassport: passportDetails.length > 0,
                hasPersonalInfo: !!personalInfo,
                completionPercentage: calculateCompletionPercentage(
                  academicDetails,
                  experienceDetails,
                  passportDetails,
                  personalInfo
                )
              }
            };
          } catch (error) {
            console.error(`❌ Error fetching data for ${employee.name}:`, error);
            return getEmptyEmployeeReport(employee);
          }
        })
      );

      // Calculate overall statistics
      const employeesWithData = reports.filter(r =>
        r.academicDetails.length > 0 ||
        r.experienceDetails.length > 0 ||
        r.passportDetails.length > 0 ||
        r.personalInfo
      );

      const actualReports = {
        employeeReports: reports,
        overallStats: {
          totalEmployees: employees.length,
          employeesWithData: employeesWithData.length,
          employeesWithCompleteProfile: reports.filter(r => r.summary.completionPercentage >= 75).length,
          departments: [...new Set(employees.map(e => e.department))],
          departmentWise: generateDepartmentStats(employees),
          hiringTrends: generateHiringTrends(employees),
          dataCompletion: {
            academic: reports.filter(r => r.academicDetails.length > 0).length,
            experience: reports.filter(r => r.experienceDetails.length > 0).length,
            passport: reports.filter(r => r.passportDetails.length > 0).length,
            personalInfo: reports.filter(r => r.personalInfo).length
          },
          dataBreakdown: {
            academicRecords: reports.reduce((sum, r) => sum + r.academicDetails.length, 0),
            experienceRecords: reports.reduce((sum, r) => sum + r.experienceDetails.length, 0),
            passportRecords: reports.reduce((sum, r) => sum + r.passportDetails.length, 0)
          }
        }
      };

      console.log('✅ Final Data Summary:', {
        totalEmployees: actualReports.overallStats.totalEmployees,
        withAcademic: actualReports.overallStats.dataCompletion.academic,
        withExperience: actualReports.overallStats.dataCompletion.experience,
        withPassport: actualReports.overallStats.dataCompletion.passport,
        withPersonalInfo: actualReports.overallStats.dataCompletion.personalInfo,
        totalRecords: actualReports.overallStats.dataBreakdown
      });

      setComprehensiveReports(actualReports);

    } catch (error) {
      console.error('❌ Error in actual data fetch:', error);
      setComprehensiveReports(getEmptyComprehensiveReport(employees));
    }
  };

  // Helper function for empty employee report
  const getEmptyEmployeeReport = (employee) => ({
    employee: {
      _id: employee._id,
      emp_id: employee.emp_id,
      name: employee.name,
      email: employee.email,
      company_email: employee.company_email,
      mobile: employee.mobile,
      department: employee.department,
      role: employee.role,
      status: employee.status,
      joiningDate: employee.joiningDate
    },
    academicDetails: [],
    experienceDetails: [],
    passportDetails: [],
    personalInfo: null,
    summary: {
      academicRecords: 0,
      experienceRecords: 0,
      hasPassport: false,
      hasPersonalInfo: false,
      completionPercentage: 0
    }
  });

  // Helper function for empty comprehensive report
  const getEmptyComprehensiveReport = (employees) => ({
    employeeReports: employees.map(employee => getEmptyEmployeeReport(employee)),
    overallStats: {
      totalEmployees: employees.length,
      employeesWithData: 0,
      employeesWithCompleteProfile: 0,
      departments: [...new Set(employees.map(e => e.department))],
      departmentWise: generateDepartmentStats(employees),
      hiringTrends: generateHiringTrends(employees),
      dataCompletion: { academic: 0, experience: 0, passport: 0, personalInfo: 0 }
    }
  });

  const fetchComprehensiveEmployeeReports = async () => {
    try {
      setReportLoading(true);
      const token = sessionStorage.getItem('token');

      console.log('📊 Fetching ACTUAL employee reports...');

      // First try the dedicated reports API
      const response = await fetch(`${API_BASE_URL}/api/reports/employees/${user.company}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          console.log('✅ Actual reports fetched successfully:', data.data.employeeReports.length, 'employees');
          setComprehensiveReports(data.data);
          return;
        }
      }

      // If dedicated API fails, fetch actual data from individual APIs
      console.log('🔄 Falling back to individual API calls...');
      await fetchActualEmployeeData();

    } catch (error) {
      console.error('❌ Error fetching comprehensive reports:', error);
      await fetchActualEmployeeData();
    } finally {
      setReportLoading(false);
    }
  };


  // Enhanced Animated Background with Floating Elements
  const EnhancedBackground = () => (
    <div className="hr-portal-bg-canvas">
      {/* Animated Gradient Orbs */}
      <div className="hr-portal-orb hr-portal-orb-primary"></div>
      <div className="hr-portal-orb hr-portal-orb-secondary"></div>
      <div className="hr-portal-orb hr-portal-orb-accent"></div>

      {/* Geometric Pattern Overlay */}
      <div className="hr-portal-geometric-pattern">
        <div className="hr-portal-geo-shape hr-portal-geo-triangle"></div>
        <div className="hr-portal-geo-shape hr-portal-geo-circle"></div>
        <div className="hr-portal-geo-shape hr-portal-geo-square"></div>
      </div>

      {/* Floating Cards Animation */}
      <div className="hr-portal-floating-cards">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="hr-portal-floating-card"
            style={{
              animationDelay: `${i * 2}s`,
              left: `${10 + (i * 10)}%`,
            }}
          />
        ))}
      </div>

      {/* Animated Grid */}
      <div className="hr-portal-animated-grid">
        <div className="hr-portal-grid-line hr-portal-grid-line-horizontal"></div>
        <div className="hr-portal-grid-line hr-portal-grid-line-vertical"></div>
      </div>
    </div>
  );

  // Filter employees based on search and department
  const filteredEmployees = employees.filter(employee => {
    const matchesSearch = employee.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.role?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.email?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesDepartment = selectedDepartment === 'all' || employee.department === selectedDepartment;
    return matchesSearch && matchesDepartment;
  });

  const goToEmployeeDashboard = (employeeId) => {
    navigate(`/employee-dashboard/${employeeId}`);
  };

  const exportEmployeesToExcel = () => {
    try {
      // Prepare data for export
      const exportData = employees.map(employee => ({
        'Employee ID': employee.emp_id || 'N/A',
        'Name': employee.name || 'N/A',
        'Role': employee.role || 'N/A',
        'Department': employee.department || 'N/A',
        'Email': employee.company_email || employee.email || 'N/A',
        'Mobile': employee.mobile || 'N/A',
        'Status': employee.status || 'Active',
        'Joining Date': employee.joiningDate ? new Date(employee.joiningDate).toLocaleDateString() : 'N/A',
        'Work Location': employee.workLocation || 'N/A',
        'Employment Type': employee.employmentType || 'N/A'
      }));

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Create workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Employees');

      // Generate Excel file
      const fileName = `employees_export_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      // Show success message
      alert(`Employees data exported successfully! File: ${fileName}`);
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      alert('Error exporting employees data. Please try again.');
    }
  };


  const loadHiredCandidates = async () => {
    try {
      setLoadingHiredCandidates(true);
      const token = sessionStorage.getItem('token');
      const userEmail = user?.email || sessionStorage.getItem('userEmail');
      const companyName = user?.company || sessionStorage.getItem('companyName');

      console.log('🔍 Loading hired candidates for user:', userEmail);
      console.log('🏢 User company:', companyName);

      if (!userEmail) {
        console.log('❌ No user email found');
        setHiredCandidates([]);
        return;
      }

      let hiredCandidatesData = [];

      // Try multiple endpoints to get hired candidates
      const endpoints = [
        `${API_BASE_URL}/api/offer-letters/my-offers`,
        `${API_BASE_URL}/api/offer-letters/company`,
        `${API_BASE_URL}/api/offer-letters/accepted`,
        `${API_BASE_URL}/api/offer-letters`
      ];

      for (const endpoint of endpoints) {
        try {
          console.log(`🔄 Trying endpoint: ${endpoint}`);
          const response = await fetch(endpoint, {
            method: "GET",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });

          if (response.ok) {
            const result = await response.json();
            const offers = result.data || result || [];

            console.log(`📨 Offers from ${endpoint}:`, offers.length);

            // Filter accepted offers for the current user
            const acceptedOffers = offers.filter(offer => {
              const isAccepted = offer.status === 'accepted' || offer.status === 'sent_to_candidate';
              const matchesUser =
                offer.companyDetails?.companyEmail?.toLowerCase() === userEmail.toLowerCase() ||
                offer.sentBy === user?.id ||
                offer.userEmail?.toLowerCase() === userEmail.toLowerCase();

              return isAccepted && matchesUser;
            });

            console.log(`✅ Found ${acceptedOffers.length} accepted offers from ${endpoint}`);

            // Transform to hired candidates format
            const candidates = acceptedOffers.map(offer => ({
              _id: offer._id,
              name: offer.candidateName,
              email: offer.candidateEmail,
              position: offer.position,
              department: offer.department,
              joiningDate: offer.joiningDate,
              status: 'offer_accepted',
              offerLetterId: offer._id,
              phone: offer.candidatePhone,
              type: 'hired_candidate',
              companyEmail: offer.companyDetails?.companyEmail,
              hrManagerName: offer.companyDetails?.hrManagerName,
              userEmail: offer.userEmail
            }));

            hiredCandidatesData = [...hiredCandidatesData, ...candidates];

            // If we found offers, break the loop
            if (acceptedOffers.length > 0) {
              console.log(`🎯 Using offers from ${endpoint}`);
              break;
            }
          }
        } catch (error) {
          console.log(`❌ Endpoint failed: ${endpoint}`, error);
          continue;
        }
      }

      // If no offers found from endpoints, try to get from applications
      if (hiredCandidatesData.length === 0) {
        try {
          console.log('🔄 Trying applications endpoint...');
          const appsResponse = await fetch(`${API_BASE_URL}/api/applications?status=Hired`, {
            method: "GET",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });

          if (appsResponse.ok) {
            const applications = await appsResponse.json();
            const hiredApps = applications.data || applications || [];

            console.log(`📋 Hired applications found:`, hiredApps.length);

            hiredCandidatesData = hiredApps.map(app => ({
              _id: app._id,
              name: app.name,
              email: app.email,
              position: app.jobPosition,
              department: app.department,
              status: 'Hired',
              phone: app.phone,
              type: 'hired_application',
              userEmail: userEmail
            }));
          }
        } catch (error) {
          console.error('❌ Error loading applications:', error);
        }
      }

      // Final filtering by user email for security
      const finalCandidates = hiredCandidatesData.filter(candidate => {
        const matchesEmail =
          candidate.companyEmail?.toLowerCase() === userEmail.toLowerCase() ||
          candidate.userEmail?.toLowerCase() === userEmail.toLowerCase();

        return matchesEmail;
      });

      console.log(`📊 Before onboarding check: ${finalCandidates.length} candidates`);

      // Check onboarding status for each candidate
      const candidatesWithOnboardingStatus = await Promise.all(
        finalCandidates.map(async (candidate) => {
          try {
            // Check if this candidate is already onboarded by email
            const onboardingCheckResponse = await fetch(
              `${API_BASE_URL}/api/employees?email=${encodeURIComponent(candidate.email)}&company_name=${encodeURIComponent(companyName)}`,
              {
                method: "GET",
                headers: {
                  "Authorization": `Bearer ${token}`,
                  "Content-Type": "application/json"
                }
              }
            );

            let onboardingStatus = 'pending';
            let employeeId = null;
            let emp_id = null; // ✅ ADDED: Store the actual Employee ID

            if (onboardingCheckResponse.ok) {
              const employeesData = await onboardingCheckResponse.json();
              const employees = Array.isArray(employeesData) ? employeesData :
                employeesData.data || employeesData.employees || [];

              const onboardedEmployee = employees.find(emp =>
                emp.email?.toLowerCase() === candidate.email.toLowerCase() ||
                emp.company_email?.toLowerCase() === candidate.email.toLowerCase()
              );

              if (onboardedEmployee) {
                onboardingStatus = 'completed';
                employeeId = onboardedEmployee._id;
                emp_id = onboardedEmployee.emp_id; // ✅ ADDED: Get the actual Employee ID
                console.log(`<FiCheckCircle /> ${candidate.name} is already onboarded with Employee ID: ${emp_id}`);
              } else {
                console.log(`<FiClock /> ${candidate.name} is pending onboarding`);
              }
            }

            return {
              ...candidate,
              onboardingStatus, // 'pending' or 'completed'
              employeeId,
              emp_id, // ✅ ADDED: The actual generated Employee ID
              displayStatus: onboardingStatus === 'completed' ? 'Onboarded' : 'Hired'
            };
          } catch (error) {
            console.error(`❌ Error checking onboarding status for ${candidate.name}:`, error);
            return {
              ...candidate,
              onboardingStatus: 'pending',
              employeeId: null,
              emp_id: null, // ✅ ADDED
              displayStatus: 'Hired'
            };
          }
        })
      );

      console.log(`✅ Final hired candidates with onboarding status: ${candidatesWithOnboardingStatus.length}`);
      console.log('<FiUsers /> Candidates details:', candidatesWithOnboardingStatus.map(c => ({
        name: c.name,
        email: c.email,
        onboardingStatus: c.onboardingStatus,
        employeeId: c.employeeId,
        emp_id: c.emp_id // ✅ ADDED
      })));

      // Sort candidates: pending onboarding first, then completed
      const sortedCandidates = candidatesWithOnboardingStatus.sort((a, b) => {
        if (a.onboardingStatus === 'pending' && b.onboardingStatus === 'completed') return -1;
        if (a.onboardingStatus === 'completed' && b.onboardingStatus === 'pending') return 1;
        return 0;
      });

      setHiredCandidates(sortedCandidates);

    } catch (error) {
      console.error("❌ Error loading hired candidates:", error);
      setHiredCandidates([]);
    } finally {
      setLoadingHiredCandidates(false);
    }
  };

  // Add this to your useEffect for loading data
  useEffect(() => {
    if (user && activeTab === 'employees') {
      loadEmployees();
      loadHiredCandidates(); // Load hired candidates when employees tab is active
    }
  }, [activeTab, user]);

  // Function to onboard a hired candidate

  const onboardHiredCandidate = (candidate) => {
    // Prepare onboarding data with all candidate information
    const onboardingData = {
      candidateId: candidate._id,
      name: candidate.name,
      email: candidate.email,
      position: candidate.position,
      department: candidate.department,
      joiningDate: candidate.joiningDate,
      phone: candidate.phone,
      type: 'new_hire',
      offerLetterId: candidate.offerLetterId,
      source: 'hiring_dashboard',
      // Add any other relevant fields from the candidate
      company_email: candidate.email, // Use personal email as company email initially
      role: candidate.position, // Use position as role
      mobile: candidate.phone, // Use phone as mobile
      // ✅ ADDED: Callback to refresh after onboarding
      refreshCallback: () => {
        console.log('🔄 Refreshing hired candidates list after onboarding...');
        loadHiredCandidates(); // This will reload and show "Onboarding Complete"
      }
    };

    // Store in sessionStorage for the onboarding page
    sessionStorage.setItem('onboardingCandidate', JSON.stringify(onboardingData));

    // Navigate to onboarding page
    navigate('/onboardingpage');
  };

  // Function to toggle hired candidates view
  const toggleHiredCandidatesView = () => {
    setShowHiredCandidates(!showHiredCandidates);
    if (!showHiredCandidates) {
      loadHiredCandidates();
    }
  };

  useEffect(() => {
    if (activeTab === 'calendar') {
      fetchWorldwideHolidays();
      fetchMeetings();
      if (employees.length > 0) {
        processEmployeeBirthdays(employees);
      }
    }
  }, [activeTab, employees]);

  const fetchWorldwideHolidays = async (year = currentYear) => {
    try {
      const sampleHolidays = [
        { date: `${year}-01-01`, name: 'New Year', country: 'IN', type: 'national' },
        { date: `${year}-01-26`, name: 'Republic Day', country: 'IN', type: 'national' },
        { date: `${year}-03-25`, name: 'Holi', country: 'IN', type: 'national' },
        { date: `${year}-08-15`, name: 'Independence Day', country: 'IN', type: 'national' },
        { date: `${year}-10-02`, name: 'Gandhi Jayanti', country: 'IN', type: 'national' },
        { date: `${year}-12-25`, name: 'Christmas', country: 'IN', type: 'national' },
      ];

      setAllCountriesHolidays(sampleHolidays);
      return sampleHolidays;
    } catch (error) {
      console.error("Error fetching worldwide holidays:", error);
      const fallbackHolidays = [
        { date: `${year}-01-01`, name: 'New Year', country: 'IN', type: 'national' },
        { date: `${year}-12-25`, name: 'Christmas', country: 'IN', type: 'national' },
      ];
      setAllCountriesHolidays(fallbackHolidays);
      return fallbackHolidays;
    }
  };

  const countries = [
    { code: 'IN', name: 'India', flag: '🇮🇳' },
    { code: 'US', name: 'United States', flag: '🇺🇸' },
    { code: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
    { code: 'AE', name: 'UAE', flag: '🇦🇪' },
    { code: 'SG', name: 'Singapore', flag: '🇸🇬' },
    { code: 'CA', name: 'Canada', flag: '🇨🇦' },
    { code: 'AU', name: 'Australia', flag: '🇦🇺' },
    { code: 'DE', name: 'Germany', flag: '🇩🇪' },
    { code: 'FR', name: 'France', flag: '🇫🇷' },
    { code: 'JP', name: 'Japan', flag: '🇯🇵' },
    { code: 'CN', name: 'China', flag: '🇨🇳' },
    { code: 'BR', name: 'Brazil', flag: '🇧🇷' }
  ];

  const getHolidaysForCountry = (countryCode = selectedCountry, year = currentYear) => {
    return allCountriesHolidays.filter(holiday =>
      holiday.country === countryCode && holiday.date.startsWith(year.toString())
    );
  };

  const fetchMeetings = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/meetings`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        const meetingsData = await response.json();
        setMeetings(meetingsData.data || []);
        return meetingsData.data || [];
      } else {
        console.error('Failed to fetch meetings');
        setMeetings([]);
        return [];
      }
    } catch (error) {
      console.error("Error fetching meetings:", error);
      const sampleMeetings = [
        {
          _id: '1',
          title: 'Team Standup',
          date: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0],
          time: '10:00 AM',
          type: 'daily',
          participants: ['Team Members']
        },
        {
          _id: '2',
          title: 'HR Planning',
          date: new Date(new Date().setDate(new Date().getDate() + 3)).toISOString().split('T')[0],
          time: '2:00 PM',
          type: 'planning',
          participants: ['HR Team']
        }
      ];
      setMeetings(sampleMeetings);
      return sampleMeetings;
    }
  };

  const processEmployeeBirthdays = (employees) => {
    const birthdays = employees.map(employee => {
      if (employee.dateOfBirth) {
        const dob = new Date(employee.dateOfBirth);
        return {
          id: employee._id,
          name: employee.name,
          date: employee.dateOfBirth,
          day: dob.getDate(),
          month: dob.getMonth(),
          department: employee.department
        };
      }
      return null;
    }).filter(bday => bday !== null);

    setEmployeeBirthdays(birthdays);
    return birthdays;
  };

  const getTimeAgo = (date) => {
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return 'Just now';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} minutes ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)} days ago`;

    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const generateRecentActivities = (employees) => {
    if (!employees || employees.length === 0) {
      return [
        { id: 1, action: 'No recent activities', person: 'System', time: 'Just now', type: 'info' }
      ];
    }

    const recentEmployees = employees
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 4);

    const activities = recentEmployees.map((employee, index) => {
      const timeAgo = getTimeAgo(new Date(employee.createdAt));

      return {
        id: employee._id || index + 1,
        action: 'New employee onboarded',
        person: employee.name,
        time: timeAgo,
        employeeData: employee,
        type: 'success'
      };
    });

    return activities;
  };

  const fetchDashboardStats = async (companyName) => {
    try {
      setLoading(true);

      const [employeesData, departmentsData] = await Promise.all([
        fetchEmployees(companyName),
        fetchDepartments(companyName)
      ]);

      const activities = generateRecentActivities(employeesData);

      setDepartments(departmentsData);
      setEmployees(employeesData);

      const dashboardStats = {
        employees: employeesData.length,
        departments: departmentsData.length,
        openPositions: 0,
        newApplications: 0
      };

      setStats(dashboardStats);
      setRecentActivities(activities);
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      const token = sessionStorage.getItem('token');
      const companyId = sessionStorage.getItem('companyId');
      const companyName = sessionStorage.getItem('companyName');
      const userName = sessionStorage.getItem('userName');

      if (!token) {
        navigate('/');
        return;
      }

      try {
        const res = await fetch(`${API_BASE_URL}/api/auth/me`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        const data = await res.json();

        if (!res.ok || !data.user) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('companyId');
          sessionStorage.removeItem('companyName');
          sessionStorage.removeItem('userName');
          navigate('/');
          return;
        }

        const userData = {
          ...data.user,
          name: data.user.name || userName || 'User',
          company: data.user.company || companyName || 'Company',
          companyId: data.user.companyId || companyId
        };

        setUser(userData);

        if (!companyId || companyId !== data.user.companyId) {
          sessionStorage.setItem('companyId', data.user.companyId);
          sessionStorage.setItem('companyName', data.user.company || companyName);
          setCompanyLogo(null);
        }
        if (!companyName && data.user.company) sessionStorage.setItem('companyName', data.user.company);
        if (!userName && data.user.name) sessionStorage.setItem('userName', data.user.name);

        const savedLogo = sessionStorage.getItem(`companyLogo-${data.user.companyId}`);
        if (savedLogo) setCompanyLogo(savedLogo);

        await fetchDashboardStats(userData.company);

      } catch (err) {
        console.error("Error fetching user:", err);
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  useEffect(() => {
    if (activeTab === 'employees') {
      loadEmployees();
    }
  }, [activeTab, user]);

  const loadEmployees = async () => {
    if (!user) return;

    setEmployeesLoading(true);
    try {
      const employeesData = await fetchEmployees(user.company);
      setEmployees(employeesData);
    } catch (error) {
      console.error("Error loading employees:", error);
    } finally {
      setEmployeesLoading(false);
    }
  };

  const addDepartment = async () => {
    if (!newDepartmentName.trim()) return;

    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/departments`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: newDepartmentName.trim(),
          company_name: user.company
        })
      });

      if (response.ok) {
        const newDept = await response.json();
        setDepartments([...departments, newDept]);
        setNewDepartmentName('');
        setShowAddDepartment(false);
        setStats(prev => ({ ...prev, departments: prev.departments + 1 }));
      } else {
        const errorData = await response.json();
        alert(errorData.message || 'Failed to add department');
      }
    } catch (error) {
      console.error("Error adding department:", error);
      alert('Error adding department');
    }
  };

  const updateDepartment = async () => {
    if (!editDepartmentName.trim() || !editingDepartment) return;

    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/departments/${editingDepartment._id}`, {
        method: "PUT",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: editDepartmentName.trim()
        })
      });

      if (response.ok) {
        const updatedDept = await response.json();
        setDepartments(departments.map(dept =>
          dept._id === editingDepartment._id ? updatedDept : dept
        ));
        setEditingDepartment(null);
        setEditDepartmentName('');
      } else {
        const errorData = await response.json();
        alert(errorData.message || 'Failed to update department');
      }
    } catch (error) {
      console.error("Error updating department:", error);
      alert('Error updating department');
    }
  };

  const deleteDepartment = async (departmentId) => {
    if (!window.confirm('Are you sure you want to delete this department?')) return;

    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/departments/${departmentId}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        setDepartments(departments.filter(dept => dept._id !== departmentId));
        setStats(prev => ({ ...prev, departments: Math.max(0, prev.departments - 1) }));
      } else {
        const errorData = await response.json();
        alert(errorData.message || 'Failed to delete department');
      }
    } catch (error) {
      console.error("Error deleting department:", error);
      alert('Error deleting department');
    }
  };

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");

    if (confirmLogout) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('companyId');
      sessionStorage.removeItem('companyName');
      sessionStorage.removeItem('userName');
      sessionStorage.removeItem('userData');
      sessionStorage.removeItem('subscription');
      navigate('/');
    }
  };


  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !user) return;

    const formData = new FormData();
    formData.append('logo', file);
    formData.append('companyId', user.companyId);

    try {
      const res = await fetch(`${API_BASE_URL}/upload-logo`, {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      if (data.logo) {
        setCompanyLogo(data.logo);
        sessionStorage.setItem(`companyLogo-${user.companyId}`, data.logo);
      }
    } catch (err) {
      console.error("Error uploading logo:", err);
    }
  };

  const handleSettingsClick = () => {
    setActiveTab('settings');
  };

  const refreshStats = async () => {
    if (user) {
      await fetchDashboardStats(user.company);
    }
  };

  const startEditDepartment = (department) => {
    setEditingDepartment(department);
    setEditDepartmentName(department.name);
  };

  const cancelEdit = () => {
    setEditingDepartment(null);
    setEditDepartmentName('');
  };

  // Enhanced Stat Card Component with Hover Effects
  const StatCard = ({
    icon,
    value,
    label,
    trend,
    color = 'blue',
    onClick,
    isLoading = false,
    progressValue = 0,
    size = 'medium',
    tooltip
  }) => {
    const [isHovered, setIsHovered] = useState(false);

    const getTrendData = (trend) => {
      if (!trend) return null;
      const isPositive = typeof trend === 'string'
        ? trend.includes('+') || !trend.includes('-')
        : trend >= 0;

      return {
        value: trend,
        isPositive,
        icon: isPositive ? '↗' : '↘'
      };
    };

    const trendData = getTrendData(trend);

    return (
      <div
        className={`
        hr-portal-stat-tile 
        hr-portal-stat-${color}
        hr-portal-stat-${size}
        ${onClick ? 'hr-portal-stat-clickable' : ''}
        ${isLoading ? 'hr-portal-stat-loading' : ''}
      `}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        role={onClick ? "button" : "article"}
        tabIndex={onClick ? 0 : -1}
        aria-label={tooltip || `${label}: ${value}${trend ? `, ${trend} trend` : ''}`}
        title={tooltip}
      >
        {/* Animated Background Elements */}
        <div className="hr-portal-stat-glow-effect"></div>
        <div className="hr-portal-stat-particles"></div>

        {/* Main Content */}
        <div className="hr-portal-stat-inner">
          {/* Icon with Animation */}
          <div className="hr-portal-stat-icon-wrapper">
            <div className="hr-portal-stat-icon">
              {isLoading ? (
                <div className="hr-portal-stat-loading-spinner"></div>
              ) : (
                icon
              )}
            </div>
            {/* <div className={`hr-portal-stat-pulse ${isHovered ? 'hr-portal-stat-pulse-active' : ''}`}></div> */}
          </div>

          {/* Content */}
          <div className="hr-portal-stat-content">
            {isLoading ? (
              <>
                <div className="hr-portal-stat-skeleton hr-portal-stat-skeleton-value"></div>
                <div className="hr-portal-stat-skeleton hr-portal-stat-skeleton-label"></div>
              </>
            ) : (
              <>
                <h3 className="hr-portal-stat-value">{value}</h3>
                <p className="hr-portal-stat-label">{label}</p>
                {trendData && (
                  <span className={`
                  hr-portal-stat-trend
                  ${trendData.isPositive ? 'hr-portal-stat-trend-positive' : 'hr-portal-stat-trend-negative'}
                `}>
                    <span className="hr-portal-stat-trend-icon">{trendData.icon}</span>
                    {trendData.value}
                  </span>
                )}
              </>
            )}
          </div>

          {/* Interactive Arrow */}
          {onClick && (
            <div className={`
            hr-portal-stat-arrow
            ${isHovered ? 'hr-portal-stat-arrow-active' : ''}
          `}>
              <span>→</span>
            </div>
          )}
        </div>

        {/* Animated Progress Bar */}
        <div className="hr-portal-stat-progress-bar">
          <div
            className="hr-portal-stat-progress-fill"
            style={{
              width: `${isLoading ? 0 : progressValue}%`,
              transition: isLoading ? 'none' : 'width 1.5s cubic-bezier(0.4, 0, 0.2, 1)'
            }}
          ></div>
        </div>
      </div>
    );
  };

  // Enhanced Activity Item with Animation
  const ActivityItem = ({
    activity,
    index,
    onClick,
    isNew = false,
    isRead = false,
    showTimeline = true,
    compact = false
  }) => (
    <div
      className={`
      hr-portal-activity-stream-item 
      hr-portal-activity-${activity.type}
      hr-portal-activity-${activity.priority || 'normal'}
      ${isNew ? 'hr-portal-activity-new' : ''}
      ${isRead ? 'hr-portal-activity-read' : ''}
      ${compact ? 'hr-portal-activity-compact' : ''}
      ${onClick ? 'hr-portal-activity-clickable' : ''}
    `}
      style={{
        '--animation-delay': `${index * 0.05}s`,
        '--item-index': index
      }}
      onClick={onClick}
      role={onClick ? "button" : "listitem"}
      tabIndex={onClick ? 0 : -1}
      aria-label={`Activity: ${activity.action} by ${activity.person} at ${activity.time}`}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      {/* Timeline Connection */}
      {showTimeline && (
        <div className="hr-portal-activity-timeline">
          <div className="hr-portal-activity-timeline-line"></div>
        </div>
      )}

      {/* Animated Indicator */}
      <div className="hr-portal-activity-indicator">
        <div className="hr-portal-activity-dot">
          <div className="hr-portal-activity-dot-inner"></div>
        </div>
        <div className="hr-portal-activity-ripple"></div>
        {isNew && (
          <div className="hr-portal-activity-new-badge" aria-label="New activity">
            <span>●</span>
          </div>
        )}
      </div>

      {/* Main Content */}
      <div className="hr-portal-activity-content">
        <div className="hr-portal-activity-header">
          <div className="hr-portal-activity-action-wrapper">
            <span className="hr-portal-activity-action">{activity.action}</span>
            {activity.priority === 'high' && (
              <span className="hr-portal-activity-priority-badge" aria-label="High priority">
                <span>!</span>
              </span>
            )}
          </div>
          <div className="hr-portal-activity-time-wrapper">
            <span className="hr-portal-activity-time">{activity.time}</span>
            {activity.duration && (
              <span className="hr-portal-activity-duration">{activity.duration}</span>
            )}
          </div>
        </div>

        <div className="hr-portal-activity-body">
          <div className="hr-portal-activity-person-info">
            <span className="hr-portal-activity-person">{activity.person}</span>
            {activity.avatar && (
              <div className="hr-portal-activity-avatar">
                {activity.avatar}
              </div>
            )}
          </div>

          {activity.description && (
            <p className="hr-portal-activity-description">{activity.description}</p>
          )}

          {activity.employeeData && (
            <div className="hr-portal-activity-meta">
              <div className="hr-portal-activity-meta-item">
                <span className="hr-portal-activity-meta-icon"><FiBriefcase /></span>
                <span className="hr-portal-activity-department">{activity.employeeData.department}</span>
              </div>
              <div className="hr-portal-activity-meta-item">
                <span className="hr-portal-activity-meta-icon"><FiBriefcase /></span>
                <span className="hr-portal-activity-role">{activity.employeeData.role}</span>
              </div>
              {activity.employeeData.location && (
                <div className="hr-portal-activity-meta-item">
                  <span className="hr-portal-activity-meta-icon"><FiMapPin /></span>
                  <span className="hr-portal-activity-location">{activity.employeeData.location}</span>
                </div>
              )}
            </div>
          )}

          {/* Action Buttons */}
          {(activity.actions || onClick) && (
            <div className="hr-portal-activity-actions">
              {activity.actions?.map((action, actionIndex) => (
                <button
                  key={actionIndex}
                  className={`hr-portal-activity-action-btn hr-portal-activity-action-${action.type}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    action.onClick?.(activity);
                  }}
                  aria-label={action.label}
                >
                  {action.icon && <span className="hr-portal-activity-action-icon">{action.icon}</span>}
                  <span>{action.label}</span>
                </button>
              ))}
              {onClick && !activity.actions && (
                <button
                  className="hr-portal-activity-action-btn hr-portal-activity-action-view"
                  onClick={(e) => {
                    e.stopPropagation();
                    onClick(activity);
                  }}
                  aria-label="View details"
                >
                  <span>View Details</span>
                  <span className="hr-portal-activity-action-arrow">→</span>
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Hover Effect */}
      <div className="hr-portal-activity-hover-effect"></div>
    </div>
  );

  // Quick Action Card Component
  const QuickActionCard = ({
    icon,
    title,
    description,
    onClick,
    color = 'blue',
    disabled = false,
    loading = false
  }) => (
    <button
      className={`
      hr-portal-quick-action-card 
      hr-portal-action-${color}
      ${disabled ? 'hr-portal-action-disabled' : ''}
      ${loading ? 'hr-portal-action-loading' : ''}
    `}
      onClick={disabled || loading ? undefined : onClick}
      disabled={disabled || loading}
      aria-label={`${title} - ${description}`}
    >
      {/* Background Glow Effect */}
      <div className="hr-portal-action-glow"></div>

      {/* Loading Spinner */}
      {loading && (
        <div className="hr-portal-action-spinner">
          <div className="hr-portal-spinner-circle"></div>
        </div>
      )}

      {/* Main Content */}
      <div className="hr-portal-action-content-wrapper">
        <div className="hr-portal-action-icon">
          {icon}
        </div>

        <div className="hr-portal-action-content">
          <h4>{title}</h4>
          <p>{description}</p>
        </div>

        <div className="hr-portal-action-arrow">
          <span>→</span>
        </div>
      </div>
    </button>
  );

  /*-----------------------Enhanced Navigation Header with Dropdowns----------------------*/
  // Enhanced Navigation Header with Dropdowns
  const EnhancedNavigationHeader = () => (
    <header className="hr-portal-header-navigation-unique">
      <div className="hr-portal-header-content-unique">
        {/* Brand Identity Section */}
        <div className="hr-portal-brand-identity-unique">
          <div className="hr-portal-logo-container-unique">
            {/* Always show user's profile picture as company logo if exists */}
            {user?.profilePicture ? (
              <img
                src={user.profilePicture}
                alt="Company Logo"
                className="hr-portal-logo-unique"
              />
            ) : companyLogo ? (
              <img src={companyLogo} alt="Company Logo" className="hr-portal-logo-unique" />
            ) : (
              <div className="hr-portal-logo-placeholder-unique">
                <span>{user?.company?.charAt(0) || 'H'}</span>
              </div>
            )}
            <div className="hr-portal-logo-glow-effect-unique"></div>
          </div>
          <div className="hr-portal-brand-text-unique">
            <h1 className="hr-portal-company-title-unique">{user?.company || 'HR Portal'}</h1>
            <span className="hr-portal-portal-subtitle-unique">Human Resources Management</span>
          </div>
        </div>

        {/* Middle Section - User & Subscription Info */}
        <div className="hr-portal-center-section-unique">
          <div className="hr-portal-user-subscription-wrapper-unique">

            {/* User Info Compact */}
            <div className="hr-portal-user-info-compact-unique">
              <div className="hr-portal-user-avatar-compact-unique">
                {user?.profilePicture ? (
                  <img
                    src={user.profilePicture}
                    alt={user?.name}
                    className="hr-portal-avatar-img-unique"
                  />
                ) : (
                  <span className="hr-portal-avatar-initial-compact-unique">
                    {user?.name?.charAt(0) || 'U'}
                  </span>
                )}
              </div>
              <div className="hr-portal-user-details-compact-unique">
                <span className="hr-portal-user-name-compact-unique">{user?.name || 'User'}</span>
                <span className="hr-portal-company-name-compact-unique">{user?.company || 'Company Name'}</span>
              </div>
            </div>

            {/* Subscription Badge */}
            <div className="hr-portal-subscription-badge-container-unique">
              {subscription?.isPaid ? (
                <div
                  className="hr-portal-subscription-badge-unique paid-active-unique"
                  onClick={() => {
                    fetchSubscriptionStatus();
                    toast.info('Subscription status refreshed');
                  }}
                  title="Click to manage subscription"
                  style={{ cursor: 'pointer' }}
                >
                  <FiAward className="hr-portal-badge-icon-unique" />
                  <span className="hr-portal-badge-text-unique">
                    {subscription.planName || subscription.plan || 'Paid Plan'}
                    {subscription.remainingSubscriptionDays && ` (${subscription.remainingSubscriptionDays}d)`}
                  </span>
                  <span className="hr-portal-badge-status-unique">Active</span>
                </div>
              ) : subscription?.isTrialActive ? (
                <div
                  className="hr-portal-subscription-badge-unique trial-active-unique"
                  onClick={handleSubscriptionClick}
                  style={{ cursor: 'pointer' }}
                  title="Click to upgrade your trial"
                >
                  <FiStar className="hr-portal-badge-icon-unique" />
                  <span className="hr-portal-badge-text-unique">
                    Trial ({subscription.remainingTrialDays || 30}d left)
                  </span>
                  <span className="hr-portal-upgrade-indicator-unique">↑</span>
                </div>
              ) : subscription?.trialEnded && !subscription?.isPaid ? (
                <div
                  className="hr-portal-subscription-badge-unique trial-ended-unique"
                  onClick={handleSubscriptionClick}
                  style={{ cursor: 'pointer' }}
                  title="Click to subscribe"
                >
                  <span className="hr-portal-badge-icon-unique"><FiAlertTriangle /></span>
                  <span className="hr-portal-badge-text-unique">Trial Ended</span>
                  <span className="hr-portal-upgrade-indicator-unique urgent-unique">↑</span>
                </div>
              ) : (
                <div
                  className="hr-portal-subscription-badge-unique no-plan-unique"
                  onClick={handleSubscriptionClick}
                  style={{ cursor: 'pointer' }}
                  title="Click to get a plan"
                >
                  <span className="hr-portal-badge-icon-unique"><FiLock /></span>
                  <span className="hr-portal-badge-text-unique">Get Plan</span>
                  <span className="hr-portal-upgrade-indicator-unique">↑</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Right Section - Actions */}
        <div className="hr-portal-user-navigation-unique">
          {/* Quick Actions Menu */}
          <div className="hr-portal-quick-actions-unique">
            {/* Support Button */}
            <button
              className="hr-portal-action-btn-unique hr-portal-support-btn-unique"
              onClick={() => window.open('mailto:support@hrcopilot.com', '_blank')}
              title="Contact Support"
            >
              <span className="hr-portal-action-icon-unique"><FiMessageCircle /></span>
              <span className="hr-portal-action-tooltip-unique">Support</span>
            </button>

            {/* Logout Button */}
            <button
              className="hr-portal-action-btn-unique hr-portal-logout-btn-unique"
              onClick={handleLogout}
              title="Logout"
            >
              <span className="hr-portal-action-icon-unique"><FiLogOut /></span>
              <span className="hr-portal-action-tooltip-unique">Logout</span>
            </button>
          </div>

          {/* User Avatar with Profile Picture Upload */}
          <div className="hr-portal-user-avatar-container-unique">
            <div
              className="hr-portal-user-avatar-unique profile-picture-upload-container-unique"
              onClick={(e) => {
                e.stopPropagation();
                document.getElementById('profile-picture-input-unique').click();
              }}
              style={{
                backgroundImage: user?.profilePicture ? `url(${user.profilePicture})` : undefined,
                cursor: 'pointer'
              }}
              title="Change Profile Picture"
            >
              {!user?.profilePicture && (
                <span className="hr-portal-avatar-initial-unique">
                  {user?.name?.charAt(0) || 'U'}
                </span>
              )}
              <div className="profile-picture-upload-overlay-unique">
                <span className="upload-icon-unique"><FiCamera /></span>
              </div>
              <input
                id="profile-picture-input-unique"
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={handleProfilePictureUpload}
              />
            </div>
            <div className="hr-portal-avatar-status-indicator-unique"></div>

            {/* User Dropdown Menu */}
            <div className="hr-portal-user-dropdown-unique">
              <div className="hr-portal-dropdown-header-unique">
                <div className="hr-portal-user-info-dropdown-unique">
                  <div
                    className="hr-portal-user-avatar-dropdown-unique profile-picture-dropdown-unique"
                    onClick={(e) => {
                      e.stopPropagation();
                      document.getElementById('profile-picture-dropdown-input-unique').click();
                    }}
                    style={{
                      backgroundImage: user?.profilePicture ? `url(${user.profilePicture})` : undefined,
                      cursor: 'pointer'
                    }}
                  >
                    {!user?.profilePicture && (
                      <span>{user?.name?.charAt(0) || 'U'}</span>
                    )}
                    <div className="profile-picture-dropdown-overlay-unique">
                      <span className="upload-icon-small-unique"><FiCamera /></span>
                    </div>
                    <input
                      id="profile-picture-dropdown-input-unique"
                      type="file"
                      accept="image/*"
                      style={{ display: 'none' }}
                      onChange={handleProfilePictureUpload}
                    />
                  </div>
                  <div>
                    <p className="hr-portal-user-name-dropdown-unique">{user?.name}</p>
                    <p className="hr-portal-user-email-dropdown-unique">{user?.email}</p>
                    <button
                      className="change-photo-btn-unique"
                      onClick={(e) => {
                        e.stopPropagation();
                        document.getElementById('profile-picture-dropdown-input-unique').click();
                      }}
                    >
                      Change Photo
                    </button>
                  </div>
                </div>

                <div className="hr-portal-subscription-status-dropdown-unique">
                  {subscription?.isTrialActive && (
                    <span className="hr-portal-badge-unique trial-unique">Trial ({subscription.remainingTrialDays}d)</span>
                  )}
                  {subscription?.isPaid && (
                    <span className="hr-portal-badge-unique paid-unique">
                      {subscription.plan === 'pro' ? 'Pro Plan' : 'Enterprise Plan'}
                    </span>
                  )}
                  {!subscription && (
                    <span className="hr-portal-badge-unique no-plan-unique">No Plan</span>
                  )}
                </div>
              </div>

              <div className="hr-portal-dropdown-menu-unique">
                <button
                  onClick={() => navigate('/hr-pricing')}
                  className="hr-portal-subscription-dropdown-unique"
                >
                  <span>  <FiDollarSign /></span> Manage Subscription
                </button>
                {/* <button 
              onClick={() => navigate('/settings')}
              className="hr-portal-settings-dropdown-unique"
            >
              <span>⚙️</span> Settings
            </button> */}
                <button onClick={handleLogout} className="hr-portal-logout-dropdown-unique">
                  <span><FiLogOut /></span> Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );

  // Quick Actions Panel (Employee Dashboard Style)
  const QuickActionsPanel = () => (
    <div className="hr-portal-quick-actions-panel">
      <h3 className="hr-portal-sidebar-title">QUICK ACTIONS</h3>

      {/* Dashboard */}
      <button
        className={`hr-portal-action-button ${activeTab === 'dashboard' ? 'active' : ''}`}
        onClick={() => setActiveTab('dashboard')}
      >
        <span className="hr-portal-action-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 3v18h18V3H3z" />
            <path d="M3 9h18M9 21V9" />
          </svg>
        </span>
        Dashboard
      </button>

      {/* Add New Employee */}
     <button
        className={`hr-portal-action-button ${activeTab === 'onboarding' ? 'active' : ''}`}
        onClick={() => {
          setActiveTab('onboarding');
          goToOnboarding();
        }}>
        <span className="hr-portal-action-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="9" cy="7" r="4" />
            <path d="M2 21v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v2" />
            <path d="M19 8v6M22 11h-6" />
          </svg>
        </span>
        Add New Employee
      </button>

      {/* Hired Employees */}
      <button
        className={`hr-portal-action-button ${activeTab === 'employees' ? 'active' : ''}`}
        onClick={() => setActiveTab('employees')}
      >
        <span className="hr-portal-action-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="9" cy="7" r="4" />
            <circle cx="17" cy="7" r="3" />
            <path d="M2 21v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v2" />
            <path d="M17 11a4 4 0 0 1 3 4v6" />
          </svg>
        </span>
        Hired Employees
      </button>

      {/* Employee Details */}
      <button
        className={`hr-portal-action-button ${activeTab === 'employee-details' ? 'active' : ''}`}
        onClick={() => {
          setActiveTab('employee-details');
          navigate('/employee-details');
        }}
      >
        <span className="hr-portal-action-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="8" r="4" />
            <path d="M4 21a8 8 0 0 1 16 0" />
          </svg>
        </span>
        Employee Details
      </button>

      {/* Managers */}
      <button
        className={`hr-portal-action-button ${activeTab === 'managers' ? 'active' : ''}`}
        onClick={() => setActiveTab('managers')}
      >
        <span className="hr-portal-action-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="7" r="4" />
            <path d="M5 21v-2a7 7 0 0 1 14 0v2" />
          </svg>
        </span>
        Managers
      </button>

      {/* Employee Leaves */}
      <button
        className={`hr-portal-action-button ${activeTab === 'leaves' ? 'active' : ''}`}
        onClick={() => setActiveTab('leaves')}
      >
        <span className="hr-portal-action-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M2 12h20M12 2v20" />
          </svg>
        </span>
        Employee Leaves
      </button>

      {/* Manager Leaves */}
      <button
        className={`hr-portal-action-button ${activeTab === 'manager-leaves' ? 'active' : ''}`}
        onClick={() => setActiveTab('manager-leaves')}
      >
        <span className="hr-portal-action-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v12" />
            <path d="M6 12h12" />
          </svg>
        </span>
        Manager Leaves
      </button>

      {/* Departments */}
      <button
        className={`hr-portal-action-button ${activeTab === 'departments' ? 'active' : ''}`}
        onClick={() => setActiveTab('departments')}
      >
        <span className="hr-portal-action-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <path d="M3 9h18M9 21V9" />
          </svg>
        </span>
        Departments
      </button>
    </div>
  );



  // Enhanced Employee Card with Dashboard Integration
  const EnhancedEmployeeCard = ({ employee, onViewDashboard, onViewProfile }) => {
    const [completionRate, setCompletionRate] = useState(0);
    const [recentActivity, setRecentActivity] = useState([]);

    useEffect(() => {
      const loadEmployeeData = async () => {
        // Simulate profile completion calculation
        const completion = Math.floor(Math.random() * 100);
        setCompletionRate(completion);

        // Simulate recent activity
        const activities = [
          { action: 'Updated personal info', time: '2 hours ago' },
          { action: 'Submitted timesheet', time: '1 day ago' },
          { action: 'Completed training', time: '3 days ago' }
        ].slice(0, 2);
        setRecentActivity(activities);
      };
      loadEmployeeData();
    }, [employee._id]);

    return (
      <div className="hr-portal-employee-card-enhanced">
        <div className="hr-portal-employee-card-header">
          <div className="hr-portal-employee-avatar-section">
            <div className="hr-portal-employee-avatar-large">
              {employee.name ? employee.name.charAt(0).toUpperCase() : 'E'}
            </div>
            <div className={`hr-portal-employee-status-indicator ${employee.status === 'active' ? 'active' : 'inactive'}`}></div>
          </div>
          <div className="hr-portal-employee-basic-info">
            <h4 className="hr-portal-employee-name">{employee.name}</h4>
            <p className="hr-portal-employee-role">{employee.role}</p>
            <span className="hr-portal-employee-id">ID: {employee.emp_id}</span>
            <span className="hr-portal-employee-department">{employee.department}</span>
          </div>
          <div className="hr-portal-profile-completion-badge">
            <div className="hr-portal-completion-circle">
              <svg width="40" height="40" viewBox="0 0 40 40">
                <circle cx="20" cy="20" r="18" stroke="#e6e6e6" strokeWidth="3" fill="none" />
                <circle cx="20" cy="20" r="18" stroke="#4CAF50" strokeWidth="3" fill="none"
                  strokeDasharray="113" strokeDashoffset={113 - (completionRate * 113 / 100)}
                  transform="rotate(-90 20 20)" />
              </svg>
              <span className="hr-portal-completion-percent">{completionRate}%</span>
            </div>
          </div>
        </div>

        <div className="hr-portal-employee-card-body">
          <div className="hr-portal-contact-info">
            <div className="hr-portal-contact-item">
              <span className="hr-portal-contact-icon"><FiMail /></span>
              <span className="hr-portal-contact-value">{employee.email}</span>
            </div>
            {employee.mobile && (
              <div className="hr-portal-contact-item">
                <span className="hr-portal-contact-icon"><FiSmartphone /></span>
                <span className="hr-portal-contact-value">{employee.mobile}</span>
              </div>
            )}
          </div>

          {recentActivity.length > 0 && (
            <div className="hr-portal-recent-activity">
              <h5>Recent Activity</h5>
              {recentActivity.map((activity, index) => (
                <div key={index} className="hr-portal-activity-item">
                  <span className="hr-portal-activity-icon">•</span>
                  <span className="hr-portal-activity-text">{activity.action}</span>
                  <span className="hr-portal-activity-time">{activity.time}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="hr-portal-employee-card-actions">
          <button
            className="hr-portal-action-btn hr-portal-primary"
            onClick={() => onViewDashboard(employee._id)}
          >
            View Dashboard
          </button>
          <button
            className="hr-portal-action-btn hr-portal-secondary"
            onClick={() => onViewProfile(employee)}
          >
            Quick View
          </button>
        </div>
      </div>
    );
  };

  // Quick Employee Profile Modal
  const EmployeeQuickViewModal = ({ employee, isOpen, onClose }) => {
    if (!isOpen || !employee) return null;

    return (
      <div className="hr-portal-modal-overlay">
        <div className="hr-portal-quick-view-modal">
          <div className="hr-portal-modal-header">
            <h3>Employee Quick View</h3>
            <button className="hr-portal-modal-close" onClick={onClose}><FiX /></button>
          </div>
          <div className="hr-portal-quick-view-content">
            <div className="hr-portal-employee-summary">
              <div className="hr-portal-summary-avatar">
                {employee.name ? employee.name.charAt(0).toUpperCase() : 'E'}
              </div>
              <div className="hr-portal-summary-details">
                <h4>{employee.name}</h4>
                <p>{employee.role} • {employee.department}</p>
                <span className="hr-portal-employee-id">Employee ID: {employee.emp_id}</span>
              </div>
            </div>

            <div className="hr-portal-detail-grid">
              <div className="hr-portal-detail-item">
                <label>Email</label>
                <span>{employee.email}</span>
              </div>
              <div className="hr-portal-detail-item">
                <label>Mobile</label>
                <span>{employee.mobile || 'Not provided'}</span>
              </div>
              <div className="hr-portal-detail-item">
                <label>Status</label>
                <span className={`hr-portal-status-badge hr-portal-status-${employee.status || 'active'}`}>
                  {employee.status || 'Active'}
                </span>
              </div>
              <div className="hr-portal-detail-item">
                <label>Joining Date</label>
                <span>{employee.joiningDate ? new Date(employee.joiningDate).toLocaleDateString() : 'Not specified'}</span>
              </div>
            </div>

            <div className="hr-portal-quick-actions">
              <button
                className="hr-portal-action-btn hr-portal-primary"
                onClick={() => {
                  onClose();
                  goToEmployeeDashboard(employee._id);
                }}
              >
                Full Dashboard
              </button>
              <button
                className="hr-portal-action-btn hr-portal-secondary"
                onClick={() => {
                  onClose();
                  navigate(`/onboardingpage?edit=${employee._id}`);
                }}
              >
                Edit Profile
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // State for quick view modal
  const [quickViewEmployee, setQuickViewEmployee] = useState(null);
  const [showQuickView, setShowQuickView] = useState(false);

  const handleQuickView = (employee) => {
    setQuickViewEmployee(employee);
    setShowQuickView(true);
  };

  // Enhanced Employee Management Section
  const EmployeeManagementDashboard = () => {
    const [employeeStats, setEmployeeStats] = useState({
      total: 0,
      active: 0,
      newThisMonth: 0,
      profileComplete: 0
    });

    useEffect(() => {
      calculateEmployeeStats();
    }, [employees]);

    const calculateEmployeeStats = () => {
      const total = employees.length;
      const active = employees.filter(emp => emp.status === 'active').length;
      const newThisMonth = employees.filter(emp => {
        if (!emp.joiningDate) return false;
        const joinDate = new Date(emp.joiningDate);
        const now = new Date();
        return joinDate.getMonth() === now.getMonth() && joinDate.getFullYear() === now.getFullYear();
      }).length;

      setEmployeeStats({ total, active, newThisMonth, profileComplete: 0 });
    };

    return (
      <div className="hr-portal-employee-management-dashboard">
        <div className="hr-portal-employee-stats-overview">
          <div className="hr-portal-stat-card-enhanced">
            <div className="hr-portal-stat-icon"><FiUsers /></div>
            <div className="hr-portal-stat-content">
              <h3>{employeeStats.total}</h3>
              <p>Total Employees</p>
              <span className="hr-portal-stat-trend">+{employeeStats.newThisMonth} this month</span>
            </div>
          </div>
          <div className="hr-portal-stat-card-enhanced">
            <div className="hr-portal-stat-icon"><FiCheckCircle /></div>
            <div className="hr-portal-stat-content">
              <h3>{employeeStats.active}</h3>
              <p>Active Employees</p>
              <span className="hr-portal-stat-trend">{Math.round((employeeStats.active / employeeStats.total) * 100)}% active rate</span>
            </div>
          </div>
          <div className="hr-portal-stat-card-enhanced">
            <div className="hr-portal-stat-icon"><FiBarChart2 /></div>
            <div className="hr-portal-stat-content">
              <h3>{employeeStats.profileComplete}</h3>
              <p>Complete Profiles</p>
              <span className="hr-portal-stat-trend">Profile completion tracking</span>
            </div>
          </div>
          <div className="hr-portal-stat-card-enhanced">
            <div className="hr-portal-stat-icon"><FiBriefcase /></div>
            <div className="hr-portal-stat-content">
              <h3>{departments.length}</h3>
              <p>Departments</p>
              <span className="hr-portal-stat-trend">Team organization</span>
            </div>
          </div>
        </div>

        <div className="hr-portal-employee-grid-section">
          <div className="hr-portal-section-header">
            <h3>Employee Directory</h3>
            <div className="hr-portal-section-actions">
              <button className="hr-portal-primary-btn" onClick={goToOnboarding}>
                + Add Employee
              </button>
              <button className="hr-portal-secondary-btn" onClick={loadEmployees}>
                Refresh
              </button>
            </div>
          </div>

          {employeesLoading ? (
            <div className="hr-portal-loading-container">
              <div className="hr-portal-loading-spinner"></div>
              <p>Loading employees...</p>
            </div>
          ) : filteredEmployees.length === 0 ? (
            <div className="hr-portal-empty-state">
              <div className="hr-portal-empty-icon"><FiUsers /></div>
              <h4>No Employees Found</h4>
              <p>Get started by adding your first employee to the system.</p>
              <button className="hr-portal-primary-btn" onClick={goToOnboarding}>
                Add First Employee
              </button>
            </div>
          ) : (
            <div className="hr-portal-employee-grid-enhanced">
              {filteredEmployees.map(employee => (
                <EnhancedEmployeeCard
                  key={employee._id}
                  employee={employee}
                  onViewDashboard={goToEmployeeDashboard}
                  onViewProfile={handleQuickView}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  // Enhanced Dashboard with Employee Integration
  const EnhancedDashboard = () => {
    const [dashboardStats, setDashboardStats] = useState({
      totalEmployees: 0,
      activeEmployees: 0,
      departments: 0,
      pendingLeaves: 0,
      recentHires: 0,
      profileCompletion: 0
    });

    useEffect(() => {
      updateDashboardStats();
    }, [employees, leaveRequests]);

    const updateDashboardStats = () => {
      const totalEmployees = employees.length;
      const activeEmployees = employees.filter(emp => emp.status === 'active').length;
      const pendingLeaves = leaveRequests.filter(leave =>
        leave.status === 'Pending' || leave.status === 'pending'
      ).length;
      const recentHires = employees.filter(emp => {
        if (!emp.joiningDate) return false;
        const joinDate = new Date(emp.joiningDate);
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        return joinDate > thirtyDaysAgo;
      }).length;

      setDashboardStats({
        totalEmployees,
        activeEmployees,
        departments: departments.length,
        pendingLeaves,
        recentHires,
        profileCompletion: 0
      });
    };

    return (
      <>
        <div className="hrcd-hero-wrapper">
          <div className="hrcd-hero-container">
            <div className="hrcd-hero-content-area">
              <div className="hrcd-hero-text-block">
                <h2 className="hrcd-hero-heading hrcd-fade-in">
                  Welcome back, <span className="hrcd-hero-username hrcd-gradient-text">{user.name}</span>
                </h2>
                <p className="hrcd-hero-description hrcd-slide-up">
                  Here's what's happening with your team today. You have <strong>{stats.employees}</strong> employees across <strong>{stats.departments}</strong> departments.
                </p>
              </div>
              <div className="hrcd-hero-actions-wrapper">
                <div className="hrcd-date-time-display hrcd-scale-in">
                  <div className="hrcd-date-primary">
                    {new Date().toLocaleDateString('en-US', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </div>
                  <div className="hrcd-time-secondary hrcd-pulse">
                    <FiClock className="hrcd-time-icon" />
                    {new Date().toLocaleTimeString('en-US', {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </div>
                </div>
              </div>
            </div>

            <div className="hrcd-hero-background-layer">
              <div className="hrcd-floating-orb hrcd-orb-one"></div>
              <div className="hrcd-floating-orb hrcd-orb-two"></div>
              <div className="hrcd-floating-orb hrcd-orb-three"></div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="hrcd-loading-overlay">
            <div className="hrcd-loading-spinner-ring">
              {/* <FiRefreshCw className="hrcd-spinner-icon" /> */}
            </div>
            <p className="hrcd-loading-message">Loading dashboard statistics...</p>
            <div className="hrcd-loading-dots-animation">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        ) : (
          <>
            <div className="hrcd-metrics-grid-wrapper">
              {/* Total Workforce Card */}
              <div className="hrcd-metric-card-box hrcd-progressive-fade">
                <div className="hrcd-metric-card-inline">
                  <div className="hrcd-metric-icon">
                    <FiUsers className="hrcd-metric-icon-svg" />
                  </div>
                  <div className="hrcd-metric-content">
                    <div className="hrcd-metric-main-line">
                      <span className="hrcd-metric-value">{stats.employees}</span>
                    </div>
                    <br />
                    <span className="hrcd-metric-label">Total Workforce</span>
                  </div>
                </div>
              </div>

              {/* Department Units Card */}
              <div className="hrcd-metric-card-box hrcd-progressive-fade">
                <div className="hrcd-metric-card-inline">
                  <div className="hrcd-metric-icon">
                    <FiGrid className="hrcd-metric-icon-svg" />
                  </div>
                  <div className="hrcd-metric-content">
                    <div className="hrcd-metric-main-line">
                      <span className="hrcd-metric-value">{stats.departments}</span>
                    </div>
                    <br />
                    <span className="hrcd-metric-label">Department Units</span>
                  </div>
                </div>
              </div>

              {/* Active Openings Card */}
              <div className="hrcd-metric-card-box hrcd-progressive-fade">
                <div className="hrcd-metric-card-inline">
                  <div className="hrcd-metric-icon">
                    <FiBriefcase className="hrcd-metric-icon-svg" />
                  </div>
                  <div className="hrcd-metric-content">
                    <div className="hrcd-metric-main-line">
                      <span className="hrcd-metric-value">{stats.openPositions}</span>
                    </div>
                    <br />
                    <span className="hrcd-metric-label">Active Openings</span>
                  </div>
                </div>
              </div>

              {/* Candidate Applications Card */}
              <div className="hrcd-metric-card-box hrcd-progressive-fade">
                <div className="hrcd-metric-card-inline">
                  <div className="hrcd-metric-icon">
                    <FiFileText className="hrcd-metric-icon-svg" />
                  </div>
                  <div className="hrcd-metric-content">
                    <div className="hrcd-metric-main-line">
                      <span className="hrcd-metric-value">{stats.newApplications}</span>
                    </div>
                    <br />
                    <span className="hrcd-metric-label">Candidate Applications</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="hrcd-workspace-main-layout">
              <div className="hrcd-activity-panel hrcd-glass-card">
                <div className="hrcd-panel-header-wrapper">
                  <div className="hrcd-panel-title-container">
                    <h3 className="hrcd-panel-heading">Recent Activity</h3>
                    <div className="hrcd-live-status-dot hrcd-pulse-indicator"></div>
                  </div>
                  <div className="hrcd-panel-controls-group">
                    <span className="hrcd-activity-count-badge hrcd-bounce-enter">{recentActivities.length}</span>
                  </div>
                </div>
                <div className="hrcd-activity-feed-list">
                  {recentActivities.map((activity, index) => (
                    <div key={activity.id} className="hrcd-activity-item-wrapper" style={{ animationDelay: `${index * 0.1}s` }}>
                      <ActivityItem activity={activity} index={index} />
                    </div>
                  ))}
                </div>
                {recentActivities.length === 0 && (
                  <div className="hrcd-empty-state-container">
                    <div className="hrcd-empty-icon-large">📝</div>
                    <p className="hrcd-empty-text-primary">No recent activities</p>
                    <small className="hrcd-empty-text-secondary">Activities will appear here as they happen</small>
                  </div>
                )}
              </div>

              <div className="hrcd-quick-actions-panel hrcd-glass-panel">
                <div className="hrcd-actions-header-section">
                  <div className="hrcd-actions-title-group">
                    <h3 className="hrcd-actions-heading">Quick Actions</h3>
                    <FiZap className="hrcd-actions-spark-icon hrcd-energy-pulse" />
                  </div>
                </div>
                <div className="hrcd-actions-grid-layout">
                  <div className="hrcd-action-card-wrapper hrcd-cascade-animate">
                    <QuickActionCard
                      icon={<FiUserPlus className="hrcd-action-icon" />}
                      title="Add Employee"
                      description="Onboard new team member"
                      backgroundColor="blue"
                      color="primary"
                      onClick={goToOnboarding}
                      animationDelay="0.1s"
                    />
                  </div>
                  <div className="hrcd-action-card-wrapper hrcd-cascade-animate">
                    <QuickActionCard
                      icon={<FiHome className="hrcd-action-icon" />}
                      title="Manage Departments"
                      description="Organize team structure"
                      color="secondary"
                      onClick={() => setActiveTab('departments')}
                      animationDelay="0.2s"
                    />
                  </div>
                  <div className="hrcd-action-card-wrapper hrcd-cascade-animate">
                    <QuickActionCard
                      icon={<FiTarget className="hrcd-action-icon" />}
                      title="Hiring Dashboard"
                      description="Recruitment pipeline"
                      color="accent"
                      onClick={() => navigate('/hiring-dashboard')}
                      animationDelay="0.3s"
                    />
                  </div>
                  <div className="hrcd-action-card-wrapper hrcd-cascade-animate">
                    <QuickActionCard
                      icon={<FiBarChart2 className="hrcd-action-icon" />}
                      title="Generate Report"
                      description="Analytics & insights"
                      color="info"
                      onClick={() => setActiveTab('reports')}
                      animationDelay="0.4s"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="hrcd-employees-section hrcd-glassmorphism-card">
              <div className="hrcd-section-header-container">
                <div className="hrcd-section-title-area">
                  <h3 className="hrcd-section-heading">Team Members</h3>
                  <div className="hrcd-employee-count-display">
                    <span className="hrcd-count-number">{employees.length}</span>
                    <span className="hrcd-count-label">Active</span>
                  </div>
                </div>
                <div className="hrcd-header-actions-group">
                  <div className="hrcd-view-selector-dropdown">
                    <div className="hrcd-view-options-menu">
                      <div className="hrcd-view-option-item hrcd-view-active">
                        <FiLayout className="hrcd-view-option-icon" />
                        Card View
                      </div>
                      <div className="hrcd-view-option-item">
                        <FiList className="hrcd-view-option-icon" />
                        List View
                      </div>
                      <div className="hrcd-view-option-item">
                        <FiGrid className="hrcd-view-option-icon" />
                        Table View
                      </div>
                    </div>
                  </div>
                  <button
                    className="hrcd-view-all-button hrcd-gradient-hover"
                    onClick={() => setActiveTab('employees')}
                  >
                    <span className="hrcd-button-text">View All Employees</span>
                    <FiArrowRight className="hrcd-button-arrow" />
                  </button>
                </div>
              </div>

              <div className="hrcd-employees-grid-container">
                {employees.length === 0 ? (
                  <div className="hrcd-empty-employees-state hrcd-fade-in">
                    <div className="hrcd-empty-icon-animated hrcd-floating"><FiUsers /></div>
                    <h4 className="hrcd-empty-heading">No Team Members Found</h4>
                    <p className="hrcd-empty-description">Get started by adding your first employee to the system.</p>
                    <button className="hrcd-primary-action-btn hrcd-gradient-hover" onClick={goToOnboarding}>
                      <FiPlus className="hrcd-btn-icon-add" />
                      Add First Employee
                    </button>
                  </div>
                ) : (
                  employees.slice(0, 6).map((employee, index) => (
                    <div
                      key={employee._id}
                      className="hrcd-employee-card-container hrcd-stagger-card"
                      style={{ animationDelay: `${index * 0.1}s` }}
                    >
                      <div className="hrcd-employee-card-inner hrcd-hover-lift">
                        <div className="hrcd-employee-avatar-wrapper">
                          <div className="hrcd-avatar-display-container">
                            {/* Get profile picture from state */}
                            {(() => {
                              const profilePic = profilePictures[employee._id] ||
                                employee.profilePicture ||
                                employee.profilePic ||
                                employee.photo;

                              const avatarUrl = profilePic ?
                                (profilePic.startsWith('http') || profilePic.startsWith('data:')) ?
                                  profilePic :
                                  `${API_BASE_URL}${profilePic}`
                                : null;

                              return (
                                <>
                                  {avatarUrl ? (
                                    <img
                                      src={avatarUrl}
                                      alt={employee.name}
                                      className="hrcd-employee-avatar-img"
                                      onError={(e) => {
                                        // If image fails to load, show gradient avatar
                                        e.target.style.display = 'none';
                                        const gradientAvatar = e.target.nextElementSibling;
                                        if (gradientAvatar) gradientAvatar.style.display = 'flex';
                                      }}
                                      onLoad={() => {
                                        // Hide gradient avatar when image loads successfully
                                        const gradientAvatar = document.querySelector(`[data-emp-id="${employee._id}"] .hrcd-gradient-avatar`);
                                        if (gradientAvatar) gradientAvatar.style.display = 'none';
                                      }}
                                    />
                                  ) : null}

                                  <div
                                    className="hrcd-employee-avatar-circle hrcd-gradient-avatar"
                                    data-emp-id={employee._id}
                                    style={{ display: avatarUrl ? 'none' : 'flex' }}
                                  >
                                    {employee.name ? employee.name.charAt(0).toUpperCase() : 'U'}
                                  </div>
                                </>
                              );
                            })()}

                            <div className="hrcd-avatar-status-indicator hrcd-online-status"></div>
                            <div className="hrcd-presence-dot-indicator"></div>
                          </div>

                          <div className="hrcd-employee-actions-menu">
                            <div className="hrcd-actions-dropdown-menu">
                              <div
                                className="hrcd-action-menu-item"
                                onClick={() => setActiveTab('employees')}
                              >
                                <FiUser className="hrcd-action-icon-profile" />
                                View Profile
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="hrcd-employee-info-section">
                          <h4 className="hrcd-employee-name-text">{employee.name}</h4>
                          <p className="hrcd-employee-role-text">{employee.role}</p>
                          <div className="hrcd-employee-tags-group">
                            <span className="hrcd-employee-department-tag">{employee.department}</span>
                            <span className="hrcd-employee-id-tag">{employee.emp_id || 'EMP ID'}</span>
                          </div>
                        </div>

                        <div className="hrcd-employee-metadata-section">
                          <div className="hrcd-metadata-item">
                            <span className="hrcd-metadata-label">Join Date</span>
                            <span className="hrcd-metadata-value">
                              <FiCalendar className="hrcd-metadata-icon" />
                              {employee.joinDate || '2024-01-15'}
                            </span>
                          </div>
                          <div className="hrcd-metadata-item">
                            <span className="hrcd-metadata-label">Status</span>
                            <span className="hrcd-status-badge hrcd-status-active hrcd-pulse-glow">
                              <FiCheckCircle className="hrcd-status-icon" />
                              Active
                            </span>
                          </div>
                        </div>

                        <div className="hrcd-card-actions-footer">
                          <button
                            className="hrcd-profile-view-btn hrcd-gradient-hover"
                            onClick={() => setActiveTab('employees')}
                          >
                            <FiEye className="hrcd-btn-icon-view" />
                            View Profile
                          </button>
                        </div>
                      </div>

                      <div className="hrcd-card-hover-overlay"></div>
                    </div>
                  ))
                )}
              </div>

              {employees.length > 0 && (
                <div className="hrcd-grid-footer-section">
                  <div className="hrcd-footer-stats-display">
                    <span className="hrcd-stat-item-display">
                      <strong>{employees.length}</strong> total employees
                    </span>
                    <span className="hrcd-stat-item-display">
                      <strong>{stats.departments}</strong> departments
                    </span>
                    <span className="hrcd-stat-item-display">
                      <strong>98%</strong> active rate
                    </span>
                  </div>
                  <div className="hrcd-footer-actions-group">
                    <button className="hrcd-export-action-btn">
                      <FiDownload className="hrcd-btn-icon-export" />
                      Export List
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="hrcd-floating-action-button">
              <button className="hrcd-fab-main-button">
                <FiPlus className="hrcd-fab-icon-plus" />
              </button>
              <div className="hrcd-fab-menu-items">
                <button className="hrcd-fab-menu-item" onClick={goToOnboarding}>
                  <FiUserPlus className="hrcd-fab-item-icon" />
                  <span className="hrcd-fab-item-label">Add Employee</span>
                </button>
                <button className="hrcd-fab-menu-item" onClick={() => navigate('/hiring-dashboard')}>
                  <FiBriefcase className="hrcd-fab-item-icon" />
                  <span className="hrcd-fab-item-label">Hiring</span>
                </button>
                <button className="hrcd-fab-menu-item" onClick={() => setActiveTab('reports')}>
                  <FiPieChart className="hrcd-fab-item-icon" />
                  <span className="hrcd-fab-item-label">Reports</span>
                </button>
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  // Rest of your existing functions (they remain the same as in your original code)


const goToOnboarding = () => {
  const checkResult = checkOnboardingAllowed();

  if (!checkResult.allowed) {
    setShowUpgradeModal(true);
    setUpgradeModalDetails({
      currentCount: checkResult.currentCount || employees.length,
      limit: checkResult.limit || 2,
      message: checkResult.reason
    });
    return;
  }
  navigate('/onboardingpage');
};
  // const goToCalendarPage = () => {
  //   navigate('/calendar-page');
  // };

  const fetchEmployees = async (companyName) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/employees/company/${encodeURIComponent(companyName)}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        const employees = await response.json();
        const employeesArray = Array.isArray(employees) ? employees : [];

        // Fetch profile pictures for all employees
        fetchProfilePicturesForEmployees(employeesArray, token);

        return employeesArray;
      }
      return [];
    } catch (error) {
      console.error("Error fetching employees:", error);
      return [];
    }
  };

  // New function to fetch profile pictures for employees
  const fetchProfilePicturesForEmployees = async (employees, token) => {
    try {
      const profilePicMap = {};

      // Process each employee for profile picture
      const profilePromises = employees.map(async (emp) => {
        try {
          // Check if employee already has profile picture in data
          if (emp.profilePicture || emp.profilePic || emp.photo) {
            const profilePic = emp.profilePicture || emp.profilePic || emp.photo;
            // Convert relative URL to absolute URL if needed
            if (profilePic && !profilePic.startsWith('http') && !profilePic.startsWith('data:')) {
              profilePicMap[emp._id] = `${API_BASE_URL}${profilePic}`;
            } else if (profilePic) {
              profilePicMap[emp._id] = profilePic;
            }
            return;
          }

          // Try to fetch profile from profile API
          const profileResponse = await fetch(
            `${API_BASE_URL}/api/profiles/${emp._id}`,
            {
              headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
              }
            }
          );

          if (profileResponse.ok) {
            const profileData = await profileResponse.json();
            const profilePic = profileData.profilePic || profileData.profilePicture || profileData.photo;

            if (profilePic) {
              // Convert relative URL to absolute URL if needed
              if (!profilePic.startsWith('http') && !profilePic.startsWith('data:')) {
                profilePicMap[emp._id] = `${API_BASE_URL}${profilePic}`;
              } else {
                profilePicMap[emp._id] = profilePic;
              }
            }
          }
        } catch (err) {
          console.log(`Could not fetch profile picture for ${emp.name}:`, err.message);
        }
      });

      await Promise.all(profilePromises);
      setProfilePictures(profilePicMap);

    } catch (error) {
      console.error("Error fetching profile pictures:", error);
    }
  };

  const fetchDepartments = async (companyName) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/departments?company_name=${encodeURIComponent(companyName)}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.ok) {
        const departmentsData = await response.json();
        return departmentsData;
      }
      return [];
    } catch (error) {
      console.error("Error fetching departments:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      const token = sessionStorage.getItem('token');
      const companyId = sessionStorage.getItem('companyId');
      const companyName = sessionStorage.getItem('companyName');
      const userName = sessionStorage.getItem('userName');

      if (!token) {
        navigate('/');
        return;
      }

      try {
        const res = await fetch(`${API_BASE_URL}/api/auth/me`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        const data = await res.json();

        if (!res.ok || !data.user) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('companyId');
          sessionStorage.removeItem('companyName');
          sessionStorage.removeItem('userName');
          navigate('/');
          return;
        }

        const userData = {
          ...data.user,
          name: data.user.name || userName || 'User',
          company: data.user.company || companyName || 'Company',
          companyId: data.user.companyId || companyId
        };

        setUser(userData);

        if (!companyId || companyId !== data.user.companyId) {
          sessionStorage.setItem('companyId', data.user.companyId);
          sessionStorage.setItem('companyName', data.user.company || companyName);
          setCompanyLogo(null);
        }
        if (!companyName && data.user.company) sessionStorage.setItem('companyName', data.user.company);
        if (!userName && data.user.name) sessionStorage.setItem('userName', data.user.name);

        const savedLogo = sessionStorage.getItem(`companyLogo-${data.user.companyId}`);
        if (savedLogo) setCompanyLogo(savedLogo);

        await fetchDashboardStats(userData.company);

      } catch (err) {
        console.error("Error fetching user:", err);
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  useEffect(() => {
    if (activeTab === 'employees') {
      loadEmployees();
    }
  }, [activeTab, user]);

  // Main render function
  const renderDashboardContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <EnhancedDashboard />;



      case 'employees':
        return (
          <div className="emp-manager-dashboard">
            {/* Header Section */}
            <div className="emp-manager-header">
              <div className="emp-manager-title-section">
                <h2 className="emp-manager-main-title">Employee Management</h2>
                <p className="emp-manager-subtitle">Manage your team members and their information</p>
              </div>
              <div className="emp-manager-action-buttons">
                <button className="emp-action-btn emp-primary-action" onClick={goToOnboarding}>
                  <span className="emp-btn-icon"><FiPlus /></span>
                  Add New Employee
                </button>
                <button
                  className="emp-action-btn emp-export-action"
                  onClick={exportEmployeesToExcel}
                  disabled={employees.length === 0 || employeesLoading}
                  title="Export Employees to Excel"
                >
                  <span className="emp-btn-icon"><FiBarChart2 /></span>
                  Export to Excel
                </button>
                <button className="emp-action-btn emp-secondary-action" onClick={loadEmployees} disabled={employeesLoading}>
                  {employeesLoading ? (
                    <>
                      <FiRefreshCw className="spin" /> Refreshing...
                    </>
                  ) : (
                    <>
                      <FiRefreshCw /> Refresh
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* Search and Filter Section */}
            <div className="emp-controls-panel">
              <div className="emp-search-wrapper">
                <input
                  type="text"
                  placeholder="Search employees by name, role, or email..."
                  className="emp-search-field"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <span className="emp-search-icon"></span>
              </div>
              <div className="emp-filter-wrapper">
                <select
                  className="emp-department-filter"
                  value={selectedDepartment}
                  onChange={(e) => setSelectedDepartment(e.target.value)}
                >
                  <option value="all">All Departments</option>
                  {departments.map(dept => (
                    <option key={dept._id} value={dept.name}>{dept.name}</option>
                  ))}
                </select>
              </div>
              <div className="emp-results-counter">
                Showing {filteredEmployees.length} of {employees.length} employees
              </div>
            </div>

            {/* Hired Candidates Section */}
            <div className="emp-hired-candidates-panel">
              <div className="emp-panel-header">
                <h3 className="emp-panel-title1">
                  <FiStar />  Hired Candidates from Recruitment
                  <span className="emp-count-badge">{hiredCandidates.length}</span>
                </h3>
                <div className="emp-panel-controls">
                  <button
                    className={`emp-toggle-btn ${showHiredCandidates ? 'emp-toggle-active' : ''}`}
                    onClick={toggleHiredCandidatesView}
                  >
                    {showHiredCandidates ? '▲ Hide' : '▼ Show'} Hired Candidates
                  </button>
                  <button
                    className="emp-refresh-candidates-btn"
                    onClick={loadHiredCandidates}
                    disabled={loadingHiredCandidates}
                    title="Refresh Hired Candidates"
                  >
                    {loadingHiredCandidates ? <FiRefreshCw /> : <FiRefreshCw />}

                  </button>
                </div>
              </div>

              {showHiredCandidates && (
                <div className="emp-hired-candidates-content">
                  {loadingHiredCandidates ? (
                    <div className="emp-loading-panel">
                      <div className="emp-loading-spinner"></div>
                      <p>Loading hired candidates from recruitment...</p>
                    </div>
                  ) : hiredCandidates.length === 0 ? (
                    <div className="emp-empty-state emp-empty-hired">
                      <div className="emp-empty-icon"><FiBriefcase /></div>
                      <h4>No Hired Candidates Yet</h4>
                      <p>
                        Candidates you hire in the Hiring Dashboard will appear here.
                        Go to the Hiring Dashboard to make offers and hire candidates.
                      </p>
                      <div className="emp-empty-actions">
                        <button
                          className="emp-action-btn emp-primary-action"
                          onClick={() => navigate('/hiring-dashboard')}
                        >
                          Go to Hiring Dashboard
                        </button>
                        <button
                          className="emp-action-btn emp-secondary-action"
                          onClick={loadHiredCandidates}
                        >
                          Check Again
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="emp-hired-candidates-display">
                      <div className="emp-candidates-stats">
                        <div className="emp-stat-mini-card">
                          <span className="emp-stat-number">{hiredCandidates.length}</span>
                          <span className="emp-stat-label">Total Hired</span>
                        </div>
                        <div className="emp-stat-mini-card">
                          <span className="emp-stat-number">
                            {hiredCandidates.filter(c => c.joiningDate && new Date(c.joiningDate) > new Date()).length}
                          </span>
                          <span className="emp-stat-label">Upcoming Joinings</span>
                        </div>
                      </div>

                      <div className="emp-candidates-grid">
                        {hiredCandidates.map(candidate => (
                          <div key={candidate._id} className={`emp-candidate-card ${candidate.onboardingStatus === 'completed' ? 'emp-onboarded-card' : ''
                            }`}>
                            <div className="emp-candidate-header">
                              <div className="emp-candidate-avatar">
                                {candidate.name ? candidate.name.charAt(0).toUpperCase() : 'C'}
                              </div>
                              <div className="emp-candidate-info">
                                <h4 className="emp-candidate-name">{candidate.name}</h4>
                                <p className="emp-candidate-role">{candidate.position}</p>
                                {candidate.emp_id && (
                                  <div className="emp-id-display">
                                    <span className="emp-id-label">Employee ID:</span>
                                    <span className="emp-id-value">{candidate.emp_id}</span>
                                  </div>
                                )}
                              </div>
                              <div className="emp-candidate-status">
                                <span className={`emp-status-tag ${candidate.onboardingStatus === 'completed' ?
                                  'emp-status-complete' :
                                  'emp-status-hired'
                                  }`}>
                                  {candidate.onboardingStatus === 'completed' ? (
                                    <>
                                      <FiCheckCircle /> Onboarded
                                    </>
                                  ) : (
                                    <>
                                      <FiStar /> Hired
                                    </>
                                  )}
                                </span>
                              </div>
                            </div>

                            <div className="emp-candidate-details">
                              <div className="emp-detail-row">
                                <span className="emp-detail-name">Department:</span>
                                <span className="emp-detail-value">{candidate.department}</span>
                              </div>
                              <div className="emp-detail-row">
                                <span className="emp-detail-name">Email:</span>
                                <span className="emp-detail-value">{candidate.email}</span>
                              </div>
                              {candidate.phone && (
                                <div className="emp-detail-row">
                                  <span className="emp-detail-name">Phone:</span>
                                  <span className="emp-detail-value">{candidate.phone}</span>
                                </div>
                              )}
                              {candidate.joiningDate && (
                                <div className="emp-detail-row">
                                  <span className="emp-detail-name">Joining Date:</span>
                                  <span className="emp-detail-value emp-joining-date">
                                    {new Date(candidate.joiningDate).toLocaleDateString('en-IN', {
                                      day: '2-digit',
                                      month: 'short',
                                      year: 'numeric'
                                    })}
                                  </span>
                                </div>
                              )}

                              <div className="emp-detail-row">
                                <span className="emp-detail-name">Onboarding:</span>
                                <span className={`emp-detail-value ${candidate.onboardingStatus === 'completed' ?
                                  'emp-onboarding-done' :
                                  'emp-onboarding-waiting'
                                  }`}>
                                  {candidate.onboardingStatus === 'completed' ? '<FiCheckCircle /> Complete' : '<FiClock /> Pending'}
                                  {candidate.emp_id && (
                                    <span className="emp-id-badge"> (ID: {candidate.emp_id})</span>
                                  )}
                                </span>
                              </div>
                            </div>

                            <div className="emp-candidate-actions">
                              {candidate.onboardingStatus === 'completed' ? (
                                <div className="emp-action-group">
                                  <button
                                    className="emp-view-profile-btn"
                                    onClick={() => {
                                      if (candidate.employeeId) {
                                        viewEmployeeDetails(candidate.employeeId); // ✅ FIXED
                                      }
                                    }}
                                    title="View Employee Details"
                                    disabled={detailsLoading && selectedEmployee === candidate.employeeId}
                                  >
                                    {detailsLoading && selectedEmployee === candidate.employeeId ? (
                                      <>
                                        <FiClock /> View
                                      </>
                                    ) : (
                                      <>
                                        <FiEye /> View
                                      </>
                                    )}
                                  </button>
                                  <button
                                    className="emp-edit-details-btn"
                                    onClick={() => {
                                      if (candidate.employeeId) {
                                        navigate(`/onboardingpage?edit=${candidate.employeeId}`);
                                      }
                                    }}
                                    title="Edit Employee Details"
                                  >
                                    <FiEdit />Edit
                                  </button>
                                </div>
                              ) : (
                                <div className="emp-action-group">
                                  <button
                                    className="emp-start-onboarding-btn"
                                    onClick={() => onboardHiredCandidate(candidate)}
                                    title="Start Onboarding Process"
                                  >
                                    <FiZap /> Start Onboarding
                                  </button>
                                </div>
                              )}
                            </div>

                            <div className="emp-candidate-source">
                              <span className="emp-source-tag">
                                From: {candidate.type === 'hired_candidate' ? 'Offer Letter' : 'Direct Hire'}
                                {candidate.onboardingStatus === 'completed' && candidate.emp_id && ` • ID: ${candidate.emp_id}`}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Bulk Actions */}
                      <div className="emp-bulk-actions-panel">
                        <button
                          className="emp-bulk-onboard-btn"
                          onClick={() => {
                            if (hiredCandidates.length > 0) {
                              onboardHiredCandidate(hiredCandidates[0]);
                            }
                          }}
                          disabled={hiredCandidates.length === 0}
                        >
                          <FiZap /> Onboard All Hired Candidates
                        </button>
                        <span className="emp-bulk-info">
                          {hiredCandidates.length} candidates ready for onboarding
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Employees Table Section */}
            {employeesLoading ? (
              <div className="emp-loading-container">
                <div className="emp-loading-spinner"></div>
                <p>Loading employees...</p>
              </div>
            ) : filteredEmployees.length === 0 ? (
              <div className="emp-empty-state">
                <div className="emp-empty-icon"><FiUsers /></div>
                <h4>No Employees Found</h4>
                <p>Get started by adding your first employee to the system.</p>
                <button className="emp-action-btn emp-primary-action" onClick={goToOnboarding}>
                  Add First Employee
                </button>
              </div>
            ) : (
              <>
                <div className="emp-table-wrapper">
                  <div className="emp-table-container">
                    <table className="emp-data-table">
                      <thead>
                        <tr>
                          <th>Employee ID</th>
                          <th>Name</th>
                          <th>Role</th>
                          <th>Department</th>
                          <th>Email</th>
                          <th>Mobile</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredEmployees.map((employee, index) => (
                          <tr key={employee._id} className="emp-table-row">
                            <td>
                              <span className="emp-id-badge">{employee.emp_id || 'N/A'}</span>
                            </td>
                            <td>
                              <div className="emp-name-cell">
                                <div className="emp-avatar-small">
                                  {employee.profileImage && employee.profileImage.trim() !== '' ? (
                                    <img
                                      src={employee.profileImage}
                                      alt={employee.name || 'User'}
                                      className="avatar-image"
                                      onError={(e) => {
                                        console.log('Image failed to load for:', employee.name);
                                        // Show initials when image fails
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'flex';
                                      }}
                                    />
                                  ) : null}
                                  <div
                                    className="avatar-initials"
                                    style={{ display: employee.profileImage && employee.profileImage.trim() !== '' ? 'none' : 'flex' }}
                                  >
                                    {employee.name ? employee.name.charAt(0).toUpperCase() : 'U'}
                                  </div>
                                </div>
                                <span
                                  className="emp-name-link"
                                  onClick={() => viewEmployeeDetails(employee._id)} // ✅ FIXED
                                  title="View Employee Details"
                                >
                                  {employee.name || 'Unknown'}
                                </span>
                              </div>
                            </td>
                            <td>{employee.role || 'N/A'}</td>
                            <td>
                              <span className="emp-department-badge">{employee.department || 'N/A'}</span>
                            </td>
                            <td>{employee.company_email || employee.email || 'N/A'}</td>
                            <td>{employee.mobile || 'N/A'}</td>
                            <td>
                              <span className={`emp-status-indicator emp-status-${employee.status || 'active'}`}>
                                {employee.status || 'Active'}
                              </span>
                            </td>
                            <td>
                              <div className="emp-row-actions">
                                <button
                                  className="emp-view-dashboard-btn"
                                  onClick={() => viewEmployeeDetails(employee._id)} // ✅ FIXED
                                  title="View Employee Details"
                                  disabled={detailsLoading && selectedEmployee === employee._id}
                                >
                                  {detailsLoading && selectedEmployee === employee._id ? (
                                    <FiClock />
                                  ) : (
                                    <FiEye />
                                  )}
                                  View
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Employee Details Modal */}
                {/* Employee Details Modal */}
                {isEmployeeModalOpen && employeeDetails && (
                  <div className="emp-details-modal-overlay" onClick={() => setIsEmployeeModalOpen(false)}>
                    <div className="emp-details-modal" onClick={(e) => e.stopPropagation()}>
                      {/* Modal Header */}
                      <div className="emp-modal-header">
                        <div className="emp-modal-title-section">
                          <div className="emp-modal-avatar">
                            {employeeDetails.name ? employeeDetails.name.charAt(0).toUpperCase() : 'E'}
                          </div>
                          <div>
                            <h3 className="emp-modal-title">Employee Details</h3>
                            <p className="emp-modal-subtitle">{employeeDetails.emp_id || 'N/A'}</p>
                          </div>
                        </div>
                        <button
                          className="emp-modal-close"
                          onClick={() => setIsEmployeeModalOpen(false)}
                          aria-label="Close"
                        >
                          <FiX />
                        </button>
                      </div>

                      {/* Modal Content */}
                      <div className="emp-modal-content">
                        {detailsLoading ? (
                          <div className="emp-modal-loading">
                            <div className="emp-loading-spinner"></div>
                            <p>Loading employee details...</p>
                          </div>
                        ) : (
                          <div className="emp-details-container">

                            {/* Employee Basic Info Section - Improved like reports */}
                            <div className="emp-basic-info-card">
                              <div className="emp-basic-header">
                                <div className="emp-avatar-section">
                                  <div className="emp-avatar-large">
                                    {profileImages[employeeDetails._id] ? (
                                      <img
                                        src={profileImages[employeeDetails._id]}
                                        alt={employeeDetails.name}
                                        className="profile-image-display"
                                        onError={(e) => {
                                          e.target.style.display = 'none';
                                          e.target.nextSibling.style.display = 'flex';
                                        }}
                                      />
                                    ) : null}
                                    <div className={`avatar-fallback ${profileImages[employeeDetails._id] ? 'avatar-hidden' : ''}`}>
                                      {employeeDetails.name ? employeeDetails.name.charAt(0).toUpperCase() : 'E'}
                                    </div>
                                  </div>
                                  <div className="employee-action-buttons">
                                    <div className="completion-percentage-badge">
                                      {calculateCompletionPercentage(employeeDetails)}% Complete
                                    </div>
                                  </div>
                                </div>

                                <div className="emp-details-main">
                                  <h4 className="employee-name">{employeeDetails.name || 'N/A'}</h4>
                                  <p className="employee-id-display">ID: {employeeDetails.emp_id || 'N/A'}</p>
                                  <div className="employee-meta-info">
                                    <span className="meta-tag">{employeeDetails.department || 'No Department'}</span>
                                    <span className="meta-tag">{employeeDetails.role || 'No Role'}</span>
                                    <span className={`status-tag status-${employeeDetails.status?.toLowerCase() || 'active'}`}>
                                      {employeeDetails.status || 'Active'}
                                    </span>
                                  </div>
                                  <div className="employee-contact-info">
                                    <span className="contact-item">
                                      <span className="contact-icon"><FiMail /></span>
                                      {employeeDetails.company_email || employeeDetails.email || 'No Email'}
                                    </span>
                                    {employeeDetails.mobile && (
                                      <span className="contact-item">
                                        <span className="contact-icon"><FiSmartphone /></span>
                                        {employeeDetails.mobile}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Basic Info Grid */}
                              <div className="emp-basic-info-grid-detailed">
                                <div className="emp-detail-item">
                                  <span className="emp-detail-label">Reporting Manager:</span>
                                  <span className="emp-detail-value">{employeeDetails.reporting_manager || 'N/A'}</span>
                                </div>
                                <div className="emp-detail-item">
                                  <span className="emp-detail-label">Company:</span>
                                  <span className="emp-detail-value">{employeeDetails.company_name || 'N/A'}</span>
                                </div>
                                <div className="emp-detail-item">
                                  <span className="emp-detail-label">Joining Date:</span>
                                  <span className="emp-detail-value">
                                    {employeeDetails.joining_date ? new Date(employeeDetails.joining_date).toLocaleDateString() : 'N/A'}
                                  </span>
                                </div>
                                {employeeDetails.allocated_item && (
                                  <div className="emp-detail-item">
                                    <span className="emp-detail-label">Allocated Items:</span>
                                    <span className="emp-detail-value">{employeeDetails.allocated_item}</span>
                                  </div>
                                )}
                              </div>
                            </div>
                            {/* Fixed Personal Information Section */}
                            {(employeeDetails.personalInfo &&
                              (Array.isArray(employeeDetails.personalInfo) && employeeDetails.personalInfo.length > 0) ||
                              (typeof employeeDetails.personalInfo === 'object' && Object.keys(employeeDetails.personalInfo).length > 0)) && (
                                <div className="emp-details-section">
                                  <div className="details-section-header">
                                    <h4 className="emp-section-title">
                                      <span className="emp-section-icon">👤</span> Personal Information
                                    </h4>
                                    <span className="data-badge">ACTUAL DATA</span>
                                  </div>

                                  {/* Handle both array and object cases */}
                                  {Array.isArray(employeeDetails.personalInfo) ? (
                                    // If personalInfo is an array
                                    <div className="personal-preview-grid">
                                      {employeeDetails.personalInfo.map((info, index) => (
                                        <div key={index} className="personal-info-card">
                                          <div className="personal-details-grid">
                                            {info.fatherName && (
                                              <div className="personal-detail-field">
                                                <span className="personal-label">Father's Name:</span>
                                                <span className="personal-value">{info.fatherName}</span>
                                              </div>
                                            )}
                                            {info.motherName && (
                                              <div className="personal-detail-field">
                                                <span className="personal-label">Mother's Name:</span>
                                                <span className="personal-value">{info.motherName}</span>
                                              </div>
                                            )}
                                            {info.dateOfBirth && (
                                              <div className="personal-detail-field">
                                                <span className="personal-label">Date of Birth:</span>
                                                <span className="personal-value">
                                                  {new Date(info.dateOfBirth).toLocaleDateString('en-IN')}
                                                </span>
                                              </div>
                                            )}
                                            {info.gender && (
                                              <div className="personal-detail-field">
                                                <span className="personal-label">Gender:</span>
                                                <span className="personal-value">{info.gender}</span>
                                              </div>
                                            )}
                                            {/* Add other fields similarly */}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    // If personalInfo is an object
                                    <div className="personal-preview-grid">
                                      <div className="personal-details-grid">
                                        {/* Your existing code for object structure */}
                                        {employeeDetails.personalInfo?.fatherName && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">Father's Name:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.fatherName}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.motherName && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">Mother's Name:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.motherName}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.dateOfBirth && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">Date of Birth:</span>
                                            <span className="personal-value">
                                              {new Date(employeeDetails.personalInfo.dateOfBirth).toLocaleDateString('en-IN')}
                                            </span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.gender && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">Gender:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.gender}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.bloodGroup && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">Blood Group:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.bloodGroup}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.nationality && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">Nationality:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.nationality}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.maritalStatus && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">Marital Status:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.maritalStatus}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.alternateMobile && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">Alternate Mobile:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.alternateMobile}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.emergencyContact && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">Emergency Contact:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.emergencyContact}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.address && (
                                          <div className="personal-detail-field full-width-field">
                                            <span className="personal-label">Address:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.address}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.city && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">City:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.city}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.state && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">State:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.state}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.country && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">Country:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.country}</span>
                                          </div>
                                        )}
                                        {employeeDetails.personalInfo?.pincode && (
                                          <div className="personal-detail-field">
                                            <span className="personal-label">Pincode:</span>
                                            <span className="personal-value">{employeeDetails.personalInfo.pincode}</span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}

                            {/* Academic Information - Enhanced like reports */}
                            {employeeDetails.academicInfo && employeeDetails.academicInfo.length > 0 && (
                              <div className="emp-details-section">
                                <div className="details-section-header">
                                  <h4 className="emp-section-title">
                                    <span className="emp-section-icon"><FiAward /></span> Academic Qualifications ({employeeDetails.academicInfo.length})
                                  </h4>
                                  <span className="data-badge">ACTUAL DATA</span>
                                </div>
                                <div className="academic-preview-grid">
                                  {employeeDetails.academicInfo.map((academic, idx) => (
                                    <div key={idx} className="academic-item-card">
                                      <div className="academic-item-header">
                                        <strong className="academic-qualification">{academic.qualification || academic.degree || 'Qualification'}</strong>
                                        <span className="academic-year">{academic.yearOfPassing || academic.year || 'N/A'}</span>
                                      </div>
                                      <div className="academic-details-list">
                                        <span className="academic-institution">
                                          {academic.university || academic.institution || 'University/Institution'}
                                        </span>
                                        {academic.grade && <span className="academic-grade">Grade: {academic.grade}</span>}
                                        {academic.specialization && <span className="academic-specialization">Specialization: {academic.specialization}</span>}
                                        {academic.fieldOfStudy && <span className="academic-field">Field: {academic.fieldOfStudy}</span>}
                                        {academic.percentage && <span className="academic-percentage">Percentage: {academic.percentage}%</span>}
                                        {academic.cgpa && <span className="academic-cgpa">CGPA: {academic.cgpa}</span>}
                                      </div>
                                      {academic.description && (
                                        <p className="academic-description">{academic.description}</p>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}

                            {/* Experience Information - Enhanced like reports */}
                            {employeeDetails.experienceInfo && employeeDetails.experienceInfo.length > 0 && (
                              <div className="emp-details-section">
                                <div className="details-section-header">
                                  <h4 className="emp-section-title">
                                    <span className="emp-section-icon"><FiBriefcase /></span> Work Experience ({employeeDetails.experienceInfo.length})
                                  </h4>
                                  <span className="data-badge">ACTUAL DATA</span>
                                </div>
                                <div className="experience-preview-grid">
                                  {employeeDetails.experienceInfo.map((exp, idx) => (
                                    <div key={idx} className="experience-item-card">
                                      <div className="experience-item-header">
                                        <strong className="company-name">{exp.companyName || exp.company || 'Company'}</strong>
                                        <span className="experience-duration">
                                          {exp.startDate ? new Date(exp.startDate).toLocaleDateString('en-IN') : 'Start'} -
                                          {exp.endDate ? new Date(exp.endDate).toLocaleDateString('en-IN') : 'Present'}
                                          {exp.yearsOfExperience && ` (${exp.yearsOfExperience} years)`}
                                        </span>
                                      </div>
                                      <div className="experience-details-list">
                                        <span className="experience-role">{exp.role || exp.position || exp.designation || 'Role'}</span>
                                        {exp.location && <span className="experience-location"><FiMapPin /> {exp.location}</span>}
                                        {exp.responsibilities && (
                                          <div className="experience-responsibilities">
                                            <strong>Responsibilities:</strong>
                                            <p>{exp.responsibilities}</p>
                                          </div>
                                        )}
                                        {exp.description && (
                                          <p className="experience-description">{exp.description}</p>
                                        )}
                                        {exp.skills && (
                                          <div className="experience-skills-section">
                                            <span className="skills-label">Skills: </span>
                                            {(() => {
                                              let skillsArray = [];
                                              if (Array.isArray(exp.skills)) {
                                                skillsArray = exp.skills;
                                              } else if (typeof exp.skills === 'string') {
                                                skillsArray = exp.skills.split(',').map(skill => skill.trim());
                                              }

                                              return (
                                                <>
                                                  {skillsArray.slice(0, 5).map((skill, skillIdx) => (
                                                    <span key={skillIdx} className="skill-tag">{skill}</span>
                                                  ))}
                                                  {skillsArray.length > 5 && (
                                                    <span className="more-skills-indicator">+{skillsArray.length - 5} more</span>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}

                            {/* Passport Information - Enhanced like reports */}
                            {/* Passport Information - Updated to handle array data */}
                            {(employeeDetails.passportInfo &&
                              (employeeDetails.passportInfo._rawPassportData && employeeDetails.passportInfo._rawPassportData.length > 0) ||
                              (employeeDetails.passportInfo.passportNumber)) && (
                                <div className="emp-details-section">
                                  <div className="details-section-header">
                                    <h4 className="emp-section-title">
                                      <span className="emp-section-icon"><FiUserCheck /></span>
                                      Passport Information
                                      {employeeDetails.passportInfo._rawPassportData &&
                                        ` (${employeeDetails.passportInfo._rawPassportData.length} passports)`}
                                    </h4>
                                    <span className="data-badge">ACTUAL DATA</span>
                                  </div>

                                  {/* If we have raw passport array, map through them */}
                                  {employeeDetails.passportInfo._rawPassportData ? (
                                    <div className="passport-preview-grid">
                                      {employeeDetails.passportInfo._rawPassportData.map((passport, index) => (
                                        <div key={passport._id || index} className="passport-item-card">
                                          <div className="passport-details-grid">
                                            <div className="passport-detail-field">
                                              <span className="passport-label">Passport No:</span>
                                              <span className="passport-value">{passport.passportNumber}</span>
                                            </div>
                                            <div className="passport-detail-field">
                                              <span className="passport-label">Name on Passport:</span>
                                              <span className="passport-value">{passport.nameOnPassport}</span>
                                            </div>
                                            <div className="passport-detail-field">
                                              <span className="passport-label">Issue Date:</span>
                                              <span className="passport-value">
                                                {new Date(passport.issueDate).toLocaleDateString('en-IN')}
                                              </span>
                                            </div>
                                            <div className="passport-detail-field">
                                              <span className="passport-label">Expiry Date:</span>
                                              <span className="passport-value">
                                                {new Date(passport.expiryDate).toLocaleDateString('en-IN')}
                                              </span>
                                            </div>
                                            {passport.visaDetails && (
                                              <div className="passport-detail-field">
                                                <span className="passport-label">Visa Details:</span>
                                                <span className="passport-value">{passport.visaDetails}</span>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    /* Fallback to single passport object rendering */
                                    <div className="passport-preview-grid">
                                      <div className="passport-item-card">
                                        <div className="passport-details-grid">
                                          {employeeDetails.passportInfo.passportNumber && (
                                            <div className="passport-detail-field">
                                              <span className="passport-label">Passport No:</span>
                                              <span className="passport-value">{employeeDetails.passportInfo.passportNumber}</span>
                                            </div>
                                          )}
                                          {employeeDetails.passportInfo.expiryDate && (
                                            <div className="passport-detail-field">
                                              <span className="passport-label">Expiry Date:</span>
                                              <span className="passport-value">
                                                {new Date(employeeDetails.passportInfo.expiryDate).toLocaleDateString('en-IN')}
                                              </span>
                                            </div>
                                          )}
                                          {employeeDetails.passportInfo.dateOfIssue && (
                                            <div className="passport-detail-field">
                                              <span className="passport-label">Date of Issue:</span>
                                              <span className="passport-value">
                                                {new Date(employeeDetails.passportInfo.dateOfIssue).toLocaleDateString('en-IN')}
                                              </span>
                                            </div>
                                          )}
                                          {employeeDetails.passportInfo.nationality && (
                                            <div className="passport-detail-field">
                                              <span className="passport-label">Nationality:</span>
                                              <span className="passport-value">{employeeDetails.passportInfo.nationality}</span>
                                            </div>
                                          )}
                                          {employeeDetails.passportInfo.placeOfIssue && (
                                            <div className="passport-detail-field">
                                              <span className="passport-label">Place of Issue:</span>
                                              <span className="passport-value">{employeeDetails.passportInfo.placeOfIssue}</span>
                                            </div>
                                          )}
                                          {employeeDetails.passportInfo.dateOfBirth && (
                                            <div className="passport-detail-field">
                                              <span className="passport-label">Date of Birth:</span>
                                              <span className="passport-value">
                                                {new Date(employeeDetails.passportInfo.dateOfBirth).toLocaleDateString('en-IN')}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}

                            {/* Documents Section - Updated */}
                            {employeeDetails.documents && employeeDetails.documents.length > 0 && (
                              <div className="emp-details-section">
                                <div className="details-section-header">
                                  <h4 className="emp-section-title">
                                    <span className="emp-section-icon"><FiFileText /></span> Uploaded Documents ({employeeDetails.documents.length})
                                  </h4>
                                  <span className="data-badge">HR VIEW</span>
                                </div>

                                <div className="hr-documents-container">
                                  <div className="hr-documents-grid">
                                    {employeeDetails.documents.map((doc, index) => {
                                      // Construct the document URL
                                      const getDocumentUrl = () => {
                                        if (doc.documentUrl && doc.documentUrl.startsWith('http')) {
                                          return doc.documentUrl;
                                        } else if (doc.documentUrl) {
                                          return `${API_BASE_URL}${doc.documentUrl}`;
                                        } else if (doc._id) {
                                          return `${API_BASE_URL}/api/documents/file/${doc._id}`;
                                        }
                                        return null;
                                      };

                                      const documentUrl = getDocumentUrl();

                                      // Get document icon based on type
                                      const getDocumentIcon = () => {
                                        const docName = (doc.name || doc.documentType || '').toLowerCase();
                                        if (docName.includes('marksheet')) return <FiBook />;
                                        if (docName.includes('aadhaar')) return <FiCreditCard />;
                                        if (docName.includes('pan')) return <FiCreditCard />;
                                        if (docName.includes('bank')) return <FiDollarSign />;
                                        if (docName.includes('passport')) return <FiBook />;
                                        if (docName.includes('photo')) return <FiCamera />;
                                        if (docName.includes('experience')) return <FiBriefcase />;
                                        if (docName.includes('resume')) return <FiFileText />;
                                        if (docName.includes('offer')) return <FiEdit />;
                                        return <FiClipboard />;
                                      };

                                      // Handle view document
                                      const handleViewDocument = (e) => {
                                        e.preventDefault();
                                        if (documentUrl) {
                                          window.open(documentUrl, '_blank', 'noopener,noreferrer');
                                        } else {
                                          toast.error('Document URL not available');
                                        }
                                      };

                                      // Handle download document
                                      const handleDownloadDocument = (e) => {
                                        e.preventDefault();
                                        if (documentUrl) {
                                          const a = document.createElement('a');
                                          a.href = documentUrl;
                                          a.download = doc.fileName || doc.name || 'document';
                                          document.body.appendChild(a);
                                          a.click();
                                          document.body.removeChild(a);
                                        } else {
                                          toast.error('Document not available for download');
                                        }
                                      };

                                      return (
                                        <div key={doc._id || index} className="hr-document-card">
                                          <div className="hr-doc-header">
                                            <div className="hr-doc-icon">
                                              {getDocumentIcon()}
                                            </div>
                                            <div className="hr-doc-info">
                                              <div className="hr-doc-name">
                                                {doc.name || doc.documentType || `Document ${index + 1}`}
                                              </div>
                                              <div className="hr-doc-meta">
                                                {doc.uploadedAt && (
                                                  <span className="hr-doc-date">
                                                    {new Date(doc.uploadedAt).toLocaleDateString('en-IN')}
                                                  </span>
                                                )}
                                                {doc.fileSize && (
                                                  <span className="hr-doc-size">
                                                    • {(doc.fileSize / (1024 * 1024)).toFixed(2)} MB
                                                  </span>
                                                )}
                                                {doc.uploadedVia && (
                                                  <span className="hr-doc-source">
                                                    • Via:{' '}
                                                    {doc.uploadedVia === 'mobile' ? (
                                                      <>
                                                        <FiSmartphone /> Mobile
                                                      </>
                                                    ) : (
                                                      <>
                                                        <FiMonitor /> Web
                                                      </>
                                                    )}

                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                          </div>

                                          <div className="hr-doc-actions">
                                            <button
                                              onClick={handleViewDocument}
                                              className="hr-doc-view-btn"
                                              title="View Document"
                                            >
                                              <FiEye /> View
                                            </button>
                                            <button
                                              onClick={handleDownloadDocument}
                                              className="hr-doc-download-btn"
                                              title="Download Document"
                                            >
                                              <FiDownload /> Download
                                            </button>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* No Additional Data Message */}
                            {(!employeeDetails.personalInfo || Object.keys(employeeDetails.personalInfo).length === 0) &&
                              (!employeeDetails.academicInfo || employeeDetails.academicInfo.length === 0) &&
                              (!employeeDetails.experienceInfo || employeeDetails.experienceInfo.length === 0) &&
                              (!employeeDetails.passportInfo || Object.keys(employeeDetails.passportInfo).length === 0) &&
                              (!employeeDetails.documents || employeeDetails.documents.length === 0) && (
                                <div className="emp-no-additional-data">
                                  <div className="emp-empty-icon">📋</div>
                                  <p className="no-data-text">No additional details available for this employee.</p>
                                  <button
                                    className="emp-action-btn emp-secondary-action"
                                    onClick={() => navigate(`/onboardingpage?edit=${employeeDetails._id}`)}
                                  >
                                    <FiEdit /> Add Details
                                  </button>
                                </div>
                              )}

                          </div>
                        )}
                      </div>

                      {/* Modal Footer */}
                      <div className="emp-modal-footer">
                        <button
                          className="emp-modal-btn emp-secondary-btn"
                          onClick={() => navigate(`/onboardingpage?edit=${employeeDetails._id}`)}
                        >
                          <FiEdit /> Edit Employee
                        </button>
                        {/* <button
                          className="emp-modal-btn emp-primary-btn"
                          onClick={() => {
                            setIsEmployeeModalOpen(false);
                            navigate(`/employee-dashboard/${employeeDetails._id}`);
                          }}
                        >
                          <FiEye /> View Full Dashboard
                        </button> */}
                        <button
                          className="emp-modal-btn emp-close-btn"
                          onClick={() => setIsEmployeeModalOpen(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <div className="emp-summary-cards">
                  <div className="emp-summary-card">
                    <div className="emp-summary-icon"><FiUsers /></div>
                    <div className="emp-summary-content">
                      <span className="emp-summary-count">{employees.length}</span>
                      <span className="emp-summary-text">Total Employees</span>
                    </div>
                  </div>
                  <div className="emp-summary-card emp-active-card">
                    <div className="emp-summary-icon"><FiCheckCircle /></div>
                    <div className="emp-summary-content">
                      <span className="emp-summary-count">
                        {employees.filter(e => e.status === 'active').length}
                      </span>
                      <span className="emp-summary-text">Active</span>
                    </div>
                  </div>
                  <div className="emp-summary-card emp-inactive-card">
                    <div className="emp-summary-icon"><FiPause /></div>
                    <div className="emp-summary-content">
                      <span className="emp-summary-count">
                        {employees.filter(e => e.status === 'inactive').length}
                      </span>
                      <span className="emp-summary-text">Inactive</span>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        );


      case 'departments':
        return (
          <div className="dept-manager-dashboard">
            <div className="dept-manager-header">
              <div className="dept-title-section">
                <h2 className="dept-main-title">Department Management</h2>
                <p className="dept-subtitle">Organize and manage company departments</p>
              </div>
              <div className="dept-header-actions">
                <button
                  className="dept-action-btn dept-primary-btn"
                  onClick={() => setShowAddDepartment(true)}
                >
                  <span className="dept-btn-icon">+</span>
                  Add New Department
                </button>
              </div>
            </div>

            <div className="dept-manager-interface">
              {/* Add Department Modal */}
              {showAddDepartment && (
                <div className="dept-modal-overlay">
                  <div className="dept-modal-container">
                    <div className="dept-modal-header">
                      <h3 className="dept-modal-title">Add New Department</h3>
                      <button
                        className="dept-modal-close"
                        onClick={() => {
                          setShowAddDepartment(false);
                          setNewDepartmentName('');
                        }}
                      >
                        <FiX />
                      </button>
                    </div>
                    <div className="dept-form-group">
                      <label className="dept-form-label">Department Name</label>
                      <input
                        type="text"
                        placeholder="Enter department name"
                        value={newDepartmentName}
                        onChange={(e) => setNewDepartmentName(e.target.value)}
                        className="dept-form-input"
                      />
                    </div>
                    <div className="dept-modal-actions">
                      <button
                        className="dept-action-btn dept-confirm-btn"
                        onClick={addDepartment}
                        disabled={!newDepartmentName.trim()}
                      >
                        Add Department
                      </button>
                      <button
                        className="dept-action-btn dept-cancel-btn"
                        onClick={() => {
                          setShowAddDepartment(false);
                          setNewDepartmentName('');
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Edit Department Modal */}
              {editingDepartment && (
                <div className="dept-modal-overlay">
                  <div className="dept-modal-container">
                    <div className="dept-modal-header">
                      <h3 className="dept-modal-title">Edit Department</h3>
                      <button
                        className="dept-modal-close"
                        onClick={cancelEdit}
                      >
                        <FiX />
                      </button>
                    </div>
                    <div className="dept-form-group">
                      <label className="dept-form-label">Department Name</label>
                      <input
                        type="text"
                        placeholder="Enter department name"
                        value={editDepartmentName}
                        onChange={(e) => setEditDepartmentName(e.target.value)}
                        className="dept-form-input"
                      />
                    </div>
                    <div className="dept-modal-actions">
                      <button
                        className="dept-action-btn dept-confirm-btn"
                        onClick={updateDepartment}
                        disabled={!editDepartmentName.trim()}
                      >
                        Update Department
                      </button>
                      <button
                        className="dept-action-btn dept-cancel-btn"
                        onClick={cancelEdit}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Departments Grid */}
              <div className="dept-grid-layout">
                {departments.length === 0 ? (
                  <div className="dept-empty-state">
                    <div className="dept-empty-icon"><FiBriefcase /></div>
                    <h4 className="dept-empty-title">No Departments Found</h4>
                    <p className="dept-empty-description">
                      Add your first department to organize your team structure.
                    </p>
                    <button
                      className="dept-action-btn dept-primary-btn"
                      onClick={() => setShowAddDepartment(true)}
                    >
                      Add First Department
                    </button>
                  </div>
                ) : (
                  departments.map((department) => (
                    <div key={department._id} className="dept-card">
                      <div className="dept-card-header">
                        <div className="dept-card-icon"><FiBriefcase /></div>
                        <div className="dept-card-info">
                          <h4 className="dept-card-name">{department.name}</h4>
                          <span className="dept-creation-date">
                            Created: {new Date(department.createdAt).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric'
                            })}
                          </span>
                        </div>
                      </div>
                      <div className="dept-card-actions">
                        <button
                          className="dept-edit-btn"
                          onClick={() => startEditDepartment(department)}
                          title="Edit Department"
                        >
                          <span className="dept-btn-icon"><FiEdit /></span>
                          Edit
                        </button>
                        <button
                          className="dept-delete-btn"
                          onClick={() => deleteDepartment(department._id)}
                          title="Delete Department"
                        >
                          <span className="dept-btn-icon"><FiTrash2 /></span>
                          Delete
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        );




      case 'reports':
        return (
          <div className="reports-dashboard">
            <div className="reports-header-section">
              <div className="reports-title-content">
                <h2 className="reports-main-title">Comprehensive Employee Reports</h2>
                <p className="reports-subtitle">Detailed analytics of all employee data including academic, experience, and passport details</p>
              </div>
              <div className="reports-action-buttons">
                <button
                  className="report-action-btn report-generate-btn"
                  onClick={fetchComprehensiveEmployeeReports}
                  disabled={reportLoading}
                >
                  {reportLoading ? '<FiRefreshCw /> Generating Reports...' : '<FiBarChart2 /> Generate Comprehensive Reports'}
                </button>
                <button
                  className="report-action-btn report-export-btn"
                  onClick={exportComprehensiveReports}
                  disabled={!comprehensiveReports}
                >
                  <FiDownload /> Export Full Report
                </button>
              </div>
            </div>

            {/* Comprehensive Reports Content */}
            {comprehensiveReports && (
              <div className="reports-content-area">
                {/* Overall Statistics */}
                <div className="report-section-card">
                  <h3 className="report-section-title">Overall Employee Statistics</h3>
                  <div className="stats-grid-overview">
                    <div className="stat-card-main">
                      <div className="stat-icon-wrapper"><FiUsers /></div>
                      <div className="stat-content-wrapper">
                        <h3>{comprehensiveReports.overallStats?.totalEmployees || 0}</h3>
                        <p>Total Employees</p>
                      </div>
                    </div>
                    <div className="stat-card-main">
                      <div className="stat-icon-wrapper"><FiCheckCircle /></div>
                      <div className="stat-content-wrapper">
                        <h3>{comprehensiveReports.overallStats?.employeesWithCompleteProfile || 0}</h3>
                        <p>Complete Profiles</p>
                      </div>
                    </div>
                    <div className="stat-card-main">
                      <div className="stat-icon-wrapper"><FiBriefcase /></div>
                      <div className="stat-content-wrapper">
                        <h3>{comprehensiveReports.overallStats?.departments?.length || 0}</h3>
                        <p>Departments</p>
                      </div>
                    </div>
                    <div className="stat-card-main">
                      <div className="stat-icon-wrapper"><FiTrendingUp /></div>
                      <div className="stat-content-wrapper">
                        <h3>
                          {comprehensiveReports.overallStats?.totalEmployees ?
                            ((comprehensiveReports.overallStats.employeesWithCompleteProfile / comprehensiveReports.overallStats.totalEmployees) * 100).toFixed(1)
                            : 0}%
                        </h3>
                        <p>Profile Completion Rate</p>
                      </div>
                    </div>
                  </div>

                  {/* Data Completion Breakdown */}
                  {comprehensiveReports.overallStats?.dataCompletion && (
                    <div className="data-completion-section">
                      <h4 className="completion-title">Data Completion Breakdown</h4>
                      <div className="completion-stats-grid">
                        <div className="completion-stat-item">
                          <span className="completion-label">Academic Records</span>
                          <span className="completion-value">
                            {comprehensiveReports.overallStats.dataCompletion.academic} / {comprehensiveReports.overallStats.totalEmployees}
                          </span>
                          <div className="completion-bar-container">
                            <div
                              className="completion-bar-fill completion-academic"
                              style={{
                                width: `${(comprehensiveReports.overallStats.dataCompletion.academic / comprehensiveReports.overallStats.totalEmployees) * 100}%`
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="completion-stat-item">
                          <span className="completion-label">Experience Records</span>
                          <span className="completion-value">
                            {comprehensiveReports.overallStats.dataCompletion.experience} / {comprehensiveReports.overallStats.totalEmployees}
                          </span>
                          <div className="completion-bar-container">
                            <div
                              className="completion-bar-fill completion-experience"
                              style={{
                                width: `${(comprehensiveReports.overallStats.dataCompletion.experience / comprehensiveReports.overallStats.totalEmployees) * 100}%`
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="completion-stat-item">
                          <span className="completion-label">Passport Details</span>
                          <span className="completion-value">
                            {comprehensiveReports.overallStats.dataCompletion.passport} / {comprehensiveReports.overallStats.totalEmployees}
                          </span>
                          <div className="completion-bar-container">
                            <div
                              className="completion-bar-fill completion-passport"
                              style={{
                                width: `${(comprehensiveReports.overallStats.dataCompletion.passport / comprehensiveReports.overallStats.totalEmployees) * 100}%`
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="completion-stat-item">
                          <span className="completion-label">Personal Info</span>
                          <span className="completion-value">
                            {comprehensiveReports.overallStats.dataCompletion.personalInfo} / {comprehensiveReports.overallStats.totalEmployees}
                          </span>
                          <div className="completion-bar-container">
                            <div
                              className="completion-bar-fill completion-personal"
                              style={{
                                width: `${(comprehensiveReports.overallStats.dataCompletion.personalInfo / comprehensiveReports.overallStats.totalEmployees) * 100}%`
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Employee Details with All Information */}
                <div className="report-section-card">
                  <h3 className="report-section-title">Employee Detailed Profiles</h3>
                  <div className="employee-profiles-container">
                    {comprehensiveReports.employeeReports?.map((report, index) => (
                      <div key={report.employee._id} className="employee-profile-card">
                        {/* Employee Basic Info */}
                        <div className="employee-basic-info-section">
                          <div className="employee-avatar-container">
                            <div className="employee-avatar-large">
                              {profileImages[report.employee._id] ? (
                                <img
                                  src={profileImages[report.employee._id]}
                                  alt={report.employee.name}
                                  className="profile-image-display"
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                  }}
                                />
                              ) : null}
                              <div className={`avatar-fallback ${profileImages[report.employee._id] ? 'avatar-hidden' : ''}`}>
                                {report.employee.name ? report.employee.name.charAt(0).toUpperCase() : 'E'}
                              </div>
                            </div>
                            {/* Upload button for HR */}
                            <label className="avatar-upload-label" title="Upload Profile Picture">
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleImageUpload(report.employee._id, e)}
                                disabled={uploadingImages[report.employee._id]}
                                style={{ display: 'none' }}
                              />
                              <span className="upload-icon">
                                {uploadingImages[report.employee._id] ? '<FiClock />' : '📷'}
                              </span>
                            </label>
                            {uploadingImages[report.employee._id] && (
                              <div className="avatar-upload-indicator">
                                <div className="upload-spinner"></div>
                              </div>
                            )}
                          </div>

                          <div className="employee-details-main">
                            <h4 className="employee-name">{report.employee.name}</h4>
                            <p className="employee-id-display">ID: {report.employee.emp_id}</p>
                            <div className="employee-meta-info">
                              <span className="meta-tag">{report.employee.department}</span>
                              <span className="meta-tag">{report.employee.role}</span>
                              {/* <span className={`status-indicator status-${report.employee.status || 'active'}`}>
                          {report.employee.status || 'Active'}
                        </span> */}
                            </div>
                            <div className="employee-contact-info">
                              <span className="contact-item">{report.employee.email}</span>
                              {report.employee.mobile && (
                                <span className="contact-item">{report.employee.mobile}</span>
                              )}
                            </div>
                          </div>
                          <div className="employee-action-buttons">
                            {/* <button 
                        className="view-profile-button"
                        onClick={() => goToEmployeeDashboard(report.employee._id)}
                      >
                        View Full Profile
                      </button> */}
                            <div className="completion-percentage-badge">
                              {report.summary.completionPercentage}% Complete
                            </div>
                          </div>
                        </div>

                        {/* Profile Completion Status */}
                        {/* <div className="profile-completion-section">
                          <h5 className="completion-heading">Profile Completion</h5>
                          <div className="completion-bars-grid">
                            <div className="completion-bar-item">
                              <span className="completion-category">Academic Details</span>
                              <div className="completion-bar-wrapper">
                                <div
                                  className={`completion-fill ${report.academicDetails.length > 0 ? 'completion-complete' : 'completion-incomplete'}`}
                                  style={{ width: report.academicDetails.length > 0 ? '100%' : '0%' }}
                                ></div>
                              </div>
                              <span className="completion-status-text">
                                {report.academicDetails.length > 0 ?
                                  `✅ ${report.academicDetails.length} records` :
                                  '❌ Missing'
                                }
                              </span>
                            </div>
                            <div className="completion-bar-item">
                              <span className="completion-category">Experience Details</span>
                              <div className="completion-bar-wrapper">
                                <div
                                  className={`completion-fill ${report.experienceDetails.length > 0 ? 'completion-complete' : 'completion-incomplete'}`}
                                  style={{ width: report.experienceDetails.length > 0 ? '100%' : '0%' }}
                                ></div>
                              </div>
                              <span className="completion-status-text">
                                {report.experienceDetails.length > 0 ?
                                  `✅ ${report.experienceDetails.length} records` :
                                  '❌ Missing'
                                }
                              </span>
                            </div>
                            <div className="completion-bar-item">
                              <span className="completion-category">Passport Details</span>
                              <div className="completion-bar-wrapper">
                                <div
                                  className={`completion-fill ${report.passportDetails.length > 0 ? 'completion-complete' : 'completion-incomplete'}`}
                                  style={{ width: report.passportDetails.length > 0 ? '100%' : '0%' }}
                                ></div>
                              </div>
                              <span className="completion-status-text">
                                {report.passportDetails.length > 0 ? '✅ Complete' : '❌ Missing'}
                              </span>
                            </div>
                            <div className="completion-bar-item">
                              <span className="completion-category">Personal Info</span>
                              <div className="completion-bar-wrapper">
                                <div
                                  className={`completion-fill ${report.personalInfo ? 'completion-complete' : 'completion-incomplete'}`}
                                  style={{ width: report.personalInfo ? '100%' : '0%' }}
                                ></div>
                              </div>
                              <span className="completion-status-text">
                                {report.personalInfo ? '✅ Complete' : '❌ Missing'}
                              </span>
                            </div>
                          </div>
                        </div> */}

                        {/* Academic Details Preview - ACTUAL DATA */}
                        {report.academicDetails.length > 0 && (
                          <div className="details-preview-section">
                            <div className="details-section-header">
                              <h5 className="details-title">Academic Qualifications ({report.academicDetails.length})</h5>
                              <span className="data-badge">ACTUAL DATA</span>
                            </div>
                            <div className="academic-preview-grid">
                              {report.academicDetails.map((academic, idx) => (
                                <div key={idx} className="academic-item-card">
                                  <div className="academic-item-header">
                                    <strong className="academic-qualification">{academic.qualification || 'Qualification'}</strong>
                                    <span className="academic-year">{academic.yearOfPassing || 'N/A'}</span>
                                  </div>
                                  <div className="academic-details-list">
                                    <span className="academic-institution">{academic.university || academic.institution || 'University/Institution'}</span>
                                    {academic.grade && <span className="academic-grade">Grade: {academic.grade}</span>}
                                    {academic.specialization && <span className="academic-specialization">Specialization: {academic.specialization}</span>}
                                    {academic.percentage && <span className="academic-percentage">Percentage: {academic.percentage}%</span>}
                                    {academic.cgpa && <span className="academic-cgpa">CGPA: {academic.cgpa}</span>}
                                  </div>
                                  {academic.description && (
                                    <p className="academic-description">{academic.description}</p>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Experience Details Preview - ACTUAL DATA */}
                        {report.experienceDetails.length > 0 && (
                          <div className="details-preview-section">
                            <div className="details-section-header">
                              <h5 className="details-title">Work Experience ({report.experienceDetails.length})</h5>
                              <span className="data-badge">ACTUAL DATA</span>
                            </div>
                            <div className="experience-preview-grid">
                              {report.experienceDetails.map((exp, idx) => (
                                <div key={idx} className="experience-item-card">
                                  <div className="experience-item-header">
                                    <strong className="company-name">{exp.companyName || exp.company || 'Company'}</strong>
                                    <span className="experience-duration">
                                      {exp.startDate ? new Date(exp.startDate).toLocaleDateString('en-IN') : 'Start'} -
                                      {exp.endDate ? new Date(exp.endDate).toLocaleDateString('en-IN') : 'Present'}
                                      {exp.yearsOfExperience && ` (${exp.yearsOfExperience} years)`}
                                    </span>
                                  </div>
                                  <div className="experience-details-list">
                                    <span className="experience-role">{exp.role || exp.position || 'Role'}</span>
                                    {exp.location && <span className="experience-location"><FiMapPin /> {exp.location}</span>}
                                    {exp.description && (
                                      <p className="experience-description">{exp.description}</p>
                                    )}
                                    {exp.skills && (
                                      <div className="experience-skills-section">
                                        <span className="skills-label">Skills: </span>
                                        {(() => {
                                          let skillsArray = [];
                                          if (Array.isArray(exp.skills)) {
                                            skillsArray = exp.skills;
                                          } else if (typeof exp.skills === 'string') {
                                            skillsArray = exp.skills.split(',').map(skill => skill.trim());
                                          }

                                          return (
                                            <>
                                              {skillsArray.slice(0, 5).map((skill, skillIdx) => (
                                                <span key={skillIdx} className="skill-tag">{skill}</span>
                                              ))}
                                              {skillsArray.length > 5 && (
                                                <span className="more-skills-indicator">+{skillsArray.length - 5} more</span>
                                              )}
                                            </>
                                          );
                                        })()}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Passport Details Preview - ACTUAL DATA */}
                        {report.passportDetails.length > 0 && (
                          <div className="details-preview-section">
                            <div className="details-section-header">
                              <h5 className="details-title">Passport Information</h5>
                              <span className="data-badge">ACTUAL DATA</span>
                            </div>
                            <div className="passport-preview-grid">
                              {report.passportDetails.map((passport, idx) => (
                                <div key={idx} className="passport-item-card">
                                  <div className="passport-details-grid">
                                    <div className="passport-detail-field">
                                      <span className="passport-label">Passport No:</span>
                                      <span className="passport-value">{passport.passportNumber || 'N/A'}</span>
                                    </div>
                                    <div className="passport-detail-field">
                                      <span className="passport-label">Expiry Date:</span>
                                      <span className="passport-value">
                                        {passport.expiryDate ? new Date(passport.expiryDate).toLocaleDateString('en-IN') : 'N/A'}
                                      </span>
                                    </div>
                                    <div className="passport-detail-field">
                                      <span className="passport-label">Nationality:</span>
                                      <span className="passport-value">{passport.nationality || 'N/A'}</span>
                                    </div>
                                    {passport.placeOfIssue && (
                                      <div className="passport-detail-field">
                                        <span className="passport-label">Place of Issue:</span>
                                        <span className="passport-value">{passport.placeOfIssue}</span>
                                      </div>
                                    )}
                                    {passport.dateOfIssue && (
                                      <div className="passport-detail-field">
                                        <span className="passport-label">Date of Issue:</span>
                                        <span className="passport-value">
                                          {new Date(passport.dateOfIssue).toLocaleDateString('en-IN')}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Personal Info Preview - ACTUAL DATA */}
                        {report.personalInfo && (
                          <div className="details-preview-section">
                            <div className="details-section-header">
                              <h5 className="details-title">Personal Information</h5>
                              <span className="data-badge">ACTUAL DATA</span>
                            </div>
                            <div className="personal-preview-grid">
                              <div className="personal-details-grid">
                                {report.personalInfo.fatherName && (
                                  <div className="personal-detail-field">
                                    <span className="personal-label">Father's Name:</span>
                                    <span className="personal-value">{report.personalInfo.fatherName}</span>
                                  </div>
                                )}
                                {report.personalInfo.motherName && (
                                  <div className="personal-detail-field">
                                    <span className="personal-label">Mother's Name:</span>
                                    <span className="personal-value">{report.personalInfo.motherName}</span>
                                  </div>
                                )}
                                {report.personalInfo.dateOfBirth && (
                                  <div className="personal-detail-field">
                                    <span className="personal-label">Date of Birth:</span>
                                    <span className="personal-value">
                                      {new Date(report.personalInfo.dateOfBirth).toLocaleDateString('en-IN')}
                                    </span>
                                  </div>
                                )}
                                {report.personalInfo.bloodGroup && (
                                  <div className="personal-detail-field">
                                    <span className="personal-label">Blood Group:</span>
                                    <span className="personal-value">{report.personalInfo.bloodGroup}</span>
                                  </div>
                                )}
                                {report.personalInfo.mobileNumber && (
                                  <div className="personal-detail-field">
                                    <span className="personal-label">Mobile Number:</span>
                                    <span className="personal-value">{report.personalInfo.mobileNumber}</span>
                                  </div>
                                )}
                                {report.personalInfo.emergencyContact && (
                                  <div className="personal-detail-field">
                                    <span className="personal-label">Emergency Contact:</span>
                                    <span className="personal-value">{report.personalInfo.emergencyContact}</span>
                                  </div>
                                )}
                                {report.personalInfo.address && (
                                  <div className="personal-detail-field full-width-field">
                                    <span className="personal-label">Address:</span>
                                    <span className="personal-value">{report.personalInfo.address}</span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* No Data Message */}
                        {report.academicDetails.length === 0 &&
                          report.experienceDetails.length === 0 &&
                          report.passportDetails.length === 0 &&
                          !report.personalInfo && (
                            <div className="no-data-message">
                              <div className="no-data-icon">📝</div>
                              <p className="no-data-text">No additional data available for this employee.</p>
                              {/* <button 
                        className="add-data-button"
                        onClick={() => goToEmployeeDashboard(report.employee._id)}
                      >
                        Add Employee Data
                      </button> */}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Department-wise Analysis */}
                {comprehensiveReports.overallStats?.departmentWise && (
                  <div className="report-section-card">
                    <h3 className="report-section-title">Department-wise Analysis</h3>
                    <div className="department-analysis-grid">
                      {comprehensiveReports.overallStats.departmentWise.map((dept, index) => (
                        <div key={index} className="department-analysis-card">
                          <div className="dept-analysis-header">
                            <h4 className="dept-name">{dept.department}</h4>
                            <span className="dept-percentage">{dept.percentage}% of total</span>
                          </div>
                          <div className="dept-stats-container">
                            <div className="dept-stat-item">
                              <span className="dept-stat-number">{dept.totalEmployees}</span>
                              <span className="dept-stat-label">Total Employees</span>
                            </div>
                            <div className="dept-stat-item">
                              <span className="dept-stat-number">{dept.activeEmployees}</span>
                              <span className="dept-stat-label">Active</span>
                            </div>
                          </div>
                          <div className="dept-roles-section">
                            <h5 className="roles-heading">Roles in this department:</h5>
                            <div className="roles-tags-container">
                              {dept.roles.slice(0, 3).map((role, idx) => (
                                <span key={idx} className="role-tag">{role}</span>
                              ))}
                              {dept.roles.length > 3 && (
                                <span className="more-roles-indicator">+{dept.roles.length - 3} more</span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {!comprehensiveReports && !reportLoading && (
              <div className="reports-empty-state">
                <div className="empty-state-icon"><FiBarChart2 /></div>
                <h4 className="empty-state-title">No Comprehensive Reports Generated</h4>
                <p className="empty-state-description">Generate detailed reports to view all employee information including academic, experience, and passport details.</p>
                <button
                  className="report-action-btn report-generate-btn"
                  onClick={fetchComprehensiveEmployeeReports}
                >
                  Generate Comprehensive Reports
                </button>
              </div>
            )}

            {reportLoading && (
              <div className="reports-loading-container">
                <div className="loading-spinner"></div>
                <p className="loading-text">Generating comprehensive employee reports...</p>
                <p className="loading-subtext">Fetching actual employee data from all sources...</p>
              </div>
            )}
          </div>
        );





      case 'managers':
        // Move the FullTeamViewModal component definition here
        const FullTeamViewModal = ({ manager, teamMembers, onClose }) => {
          const [searchTerm, setSearchTerm] = useState('');
          const [filterStatus, setFilterStatus] = useState('all');
          const [filterDepartment, setFilterDepartment] = useState('all');
          const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'asc' });

          // Get unique departments from team members
          const departments = [...new Set(teamMembers.map(member => member.department))];

          const handleSort = (key) => {
            let direction = 'asc';
            if (sortConfig.key === key && sortConfig.direction === 'asc') {
              direction = 'desc';
            }
            setSortConfig({ key, direction });
          };

          // Filter and sort team members
          const filteredAndSortedMembers = teamMembers
            .filter(member => {
              const matchesSearch =
                (member.name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
                (member.email?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
                (member.emp_id?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
                (member.role?.toLowerCase() || '').includes(searchTerm.toLowerCase());

              const matchesStatus = filterStatus === 'all' || member.status === filterStatus;
              const matchesDepartment = filterDepartment === 'all' || member.department === filterDepartment;

              return matchesSearch && matchesStatus && matchesDepartment;
            })
            .sort((a, b) => {
              let aValue = a[sortConfig.key];
              let bValue = b[sortConfig.key];

              if (typeof aValue === 'string') aValue = aValue.toLowerCase();
              if (typeof bValue === 'string') bValue = bValue.toLowerCase();

              if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
              if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
              return 0;
            });

          // Export to Excel function
          const exportToExcel = () => {
            const exportData = filteredAndSortedMembers.map(member => ({
              'Employee ID': member.emp_id,
              'Name': member.name,
              'Email': member.email,
              'Role': member.role,
              'Department': member.department,
              'Status': member.status,
              'Date of Joining': member.dateOfJoining || 'N/A',
              'Phone': member.phone || 'N/A'
            }));

            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Team Members');

            const fileName = `${manager.name.replace(/\s+/g, '_')}_Team_${new Date().toISOString().split('T')[0]}.xlsx`;
            XLSX.writeFile(workbook, fileName);
          };

          const viewEmployeeProfile = (employeeId) => {
            // You can implement this function or use your existing navigation
            alert(`View employee profile with ID: ${employeeId}`);
            // Or navigate to employee profile page
            // navigate(`/employee/${employeeId}`);
          };

          return (
            <div className="mage-modal-overlay mage-team-modal">
              <div className="mage-modal-content mage-team-modal-content">
                {/* Modal Header */}
                <div className="mage-modal-header mage-team-modal-header">
                  <div className="mage-modal-header-left">
                    <h3 className="mage-modal-title">
                      <span className="mage-modal-manager-icon"><FiUser /></span>
                      {manager.name}'s Team
                    </h3>
                    <p className="mage-modal-subtitle">
                      {teamMembers.length} team members • {manager.department} Department
                    </p>
                  </div>
                  <button className="mage-modal-close mage-team-close" onClick={onClose}><FiX /></button>
                </div>

                {/* Manager Info Section */}
                <div className="mage-manager-info mage-team-manager-info">
                  <div className="mage-manager-avatar mage-team-avatar">
                    {manager.name?.charAt(0).toUpperCase()}
                  </div>
                  <div className="mage-manager-details mage-team-details">
                    <h4 className="mage-manager-name mage-team-manager-name">{manager.name}</h4>
                    <div className="mage-manager-meta mage-team-manager-meta">
                      <span className="mage-meta-item mage-team-meta-item">
                        <span className="mage-meta-label mage-team-meta-label">Department:</span>
                        <span className="mage-meta-value mage-team-meta-value">{manager.department}</span>
                      </span>
                      <span className="mage-meta-item mage-team-meta-item">
                        <span className="mage-meta-label mage-team-meta-label">Email:</span>
                        <span className="mage-meta-value mage-team-meta-value">{manager.email}</span>
                      </span>
                      <span className="mage-meta-item mage-team-meta-item">
                        <span className="mage-meta-label mage-team-meta-label">Phone:</span>
                        <span className="mage-meta-value mage-team-meta-value">{manager.phone || 'N/A'}</span>
                      </span>
                    </div>
                  </div>
                  <div className="mage-team-stats mage-team-manager-stats">
                    <div className="mage-stat-card mage-team-stat-card">
                      <div className="mage-stat-number mage-team-stat-number">{teamMembers.length}</div>
                      <div className="mage-stat-label mage-team-stat-label">Total Team</div>
                    </div>
                    <div className="mage-stat-card mage-team-stat-card">
                      <div className="mage-stat-number mage-team-stat-number">
                        {teamMembers.filter(m => m.status === 'active').length}
                      </div>
                      <div className="mage-stat-label mage-team-stat-label">Active</div>
                    </div>
                    <div className="mage-stat-card mage-team-stat-card">
                      <div className="mage-stat-number mage-team-stat-number">
                        {teamMembers.filter(m => m.status === 'inactive').length}
                      </div>
                      <div className="mage-stat-label mage-team-stat-label">Inactive</div>
                    </div>
                  </div>
                </div>

                {/* Filters Section */}
                <div className="mage-filters-section mage-team-filters">
                  <div className="mage-search-box mage-team-search">
                    <input
                      type="text"
                      className="mage-search-input mage-team-search-input"
                      placeholder="Search team members..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <span className="mage-search-icon mage-team-search-icon"><FiSearch /></span>
                  </div>

                  <div className="mage-filter-group mage-team-filter-group">
                    <select
                      value={filterStatus}
                      onChange={(e) => setFilterStatus(e.target.value)}
                      className="mage-filter-select mage-team-filter-select"
                    >
                      <option value="all">All Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>

                    <select
                      value={filterDepartment}
                      onChange={(e) => setFilterDepartment(e.target.value)}
                      className="mage-filter-select mage-team-filter-select"
                    >
                      <option value="all">All Departments</option>
                      {departments.map(dept => (
                        <option key={dept} value={dept}>{dept}</option>
                      ))}
                    </select>
                  </div>

                  <button className="mage-export-btn mage-team-export-btn" onClick={exportToExcel}>
                    <span className="mage-export-icon mage-team-export-icon"><FiDownload /></span>
                    Export Excel
                  </button>
                </div>

                {/* Team Members Table */}
                <div className="mage-table-container mage-team-table-container">
                  <table className="mage-data-table mage-team-table">
                    <thead>
                      <tr>
                        <th onClick={() => handleSort('emp_id')} className="mage-sortable mage-team-sortable">
                          Employee ID {sortConfig.key === 'emp_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                        </th>
                        <th onClick={() => handleSort('name')} className="mage-sortable mage-team-sortable">
                          Name {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                        </th>
                        <th onClick={() => handleSort('role')} className="mage-sortable mage-team-sortable">
                          Role {sortConfig.key === 'role' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                        </th>
                        <th onClick={() => handleSort('department')} className="mage-sortable mage-team-sortable">
                          Department {sortConfig.key === 'department' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                        </th>
                        <th className="mage-team-email-header">Email</th>
                        <th className="mage-team-phone-header">Phone</th>
                        <th onClick={() => handleSort('status')} className="mage-sortable mage-team-sortable">
                          Status {sortConfig.key === 'status' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                        </th>
                        <th className="mage-team-actions-header">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredAndSortedMembers.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="mage-no-data mage-team-no-data">
                            <div className="mage-empty-state mage-team-empty">
                              <div className="mage-empty-icon mage-team-empty-icon"><FiUsers /></div>
                              <p className="mage-empty-text mage-team-empty-text">No team members found</p>
                              <button
                                className="mage-reset-btn mage-team-reset-btn"
                                onClick={() => {
                                  setSearchTerm('');
                                  setFilterStatus('all');
                                  setFilterDepartment('all');
                                }}
                              >
                                Reset Filters
                              </button>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        filteredAndSortedMembers.map(member => (
                          <tr key={member._id} className="mage-table-row mage-team-row">
                            <td>
                              <div className="mage-id-cell mage-team-id-cell">
                                <span className="mage-id-badge mage-team-id-badge">{member.emp_id}</span>
                              </div>
                            </td>
                            <td>
                              <div className="mage-name-cell mage-team-name-cell">
                                <div className="mage-avatar mage-team-avatar-small">
                                  {member.name?.charAt(0).toUpperCase()}
                                </div>
                                <div className="mage-name-info mage-team-name-info">
                                  <div className="mage-employee-name mage-team-employee-name">{member.name}</div>
                                  <div className="mage-employee-role mage-team-employee-role">{member.role}</div>
                                </div>
                              </div>
                            </td>
                            <td className="mage-team-role-cell">{member.role}</td>
                            <td className="mage-team-dept-cell">{member.department}</td>
                            <td>
                              <a href={`mailto:${member.email}`} className="mage-email-link mage-team-email-link">
                                {member.email}
                              </a>
                            </td>
                            <td className="mage-team-phone-cell">{member.phone || 'N/A'}</td>
                            <td>
                              <span className={`mage-status-badge mage-team-status-badge mage-status-${member.status}`}>
                                {member.status}
                              </span>
                            </td>
                            <td>
                              <div className="mage-action-buttons mage-team-action-buttons">
                                <button
                                  className="mage-action-btn mage-view-btn mage-team-view-btn"
                                  onClick={() => viewEmployeeProfile(member._id)}
                                  title="View Profile"
                                >
                                  <FiEye /> View
                                </button>
                                <button
                                  className="mage-action-btn mage-email-btn mage-team-email-btn"
                                  onClick={() => window.location.href = `mailto:${member.email}`}
                                  title="Send Email"
                                >
                                  <FiMail /> Email
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Footer with Summary */}
                <div className="mage-modal-footer mage-team-footer">
                  <div className="mage-summary-info mage-team-summary">
                    Showing {filteredAndSortedMembers.length} of {teamMembers.length} team members
                  </div>
                  <button className="mage-primary-btn mage-team-close-btn" onClick={onClose}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          );
        };

        // Update the viewFullTeam function to open modal instead of navigating
        const viewFullTeamPage = (manager) => {
          const teamMembers = getTeamMembers(manager._id);
          setFullTeamModal({
            open: true,
            manager: manager,
            teamMembers: teamMembers
          });
        };

        return (
          <div className="mage-dashboard mage-manager-dashboard">
            <div className="mage-header-section mage-manager-header">
              <div className="mage-title-content mage-manager-title-content">
                <h2 className="mage-main-title mage-manager-main-title">Manager Management</h2>
                <p className="mage-subtitle mage-manager-subtitle">View managers and their team details</p>
              </div>
              <div className="mage-action-buttons mage-manager-actions">
                <button
                  className="mage-action-btn mage-primary-btn mage-manager-add-btn"
                  onClick={() => navigate('/report-managers')}
                >
                  <span className="mage-btn-icon">+</span>
                  Add New Manager
                </button>
                <button
                  className="mage-action-btn mage-secondary-btn mage-manager-refresh-btn"
                  onClick={fetchAllManagers}
                  disabled={managersLoading}
                >
                  <span className="mage-btn-icon"><FiRefreshCw /></span>
                  {managersLoading ? 'Refreshing...' : 'Refresh'}
                </button>
              </div>
            </div>

            {/* Managers List */}
            <div className="mage-content-area mage-manager-content">
              {managersLoading ? (
                <div className="mage-loading-container mage-manager-loading">
                  <div className="mage-loading-spinner"></div>
                  <p className="mage-loading-text">Loading managers data...</p>
                </div>
              ) : managers.length === 0 ? (
                <div className="mage-empty-state mage-manager-empty">
                  <div className="mage-empty-icon mage-manager-empty-icon"><FiUser /></div>
                  <h4 className="mage-empty-title mage-manager-empty-title">No Managers Found</h4>
                  <p className="mage-empty-description mage-manager-empty-desc">
                    No managers have been registered in the system yet.
                  </p>
                  <button
                    className="mage-action-btn mage-primary-btn mage-manager-register-btn"
                    onClick={() => navigate('/report-managers')}
                  >
                    Register First Manager
                  </button>
                </div>
              ) : (
                <div className="mage-grid-layout mage-managers-grid">
                  {managers.map(manager => {
                    const teamMembers = getTeamMembers(manager._id);

                    return (
                      <div key={manager._id} className="mage-card mage-manager-card">
                        {/* Manager Basic Info */}
                        <div className="mage-basic-info mage-manager-basic-info">
                          <div className="mage-avatar-container mage-manager-avatar-container">
                            <div className="mage-avatar-large mage-manager-avatar-large">
                              {getManagerProfileImageUrl(manager) ? (
                                <img
                                  src={getManagerProfileImageUrl(manager)}
                                  alt={manager.name}
                                  className="mage-profile-image mage-manager-profile-img"
                                  onError={(e) => handleManagerImageError(e, manager)}
                                />
                              ) : (
                                <div className="mage-avatar-fallback mage-manager-avatar-fallback">
                                  {manager.name ? manager.name.charAt(0).toUpperCase() : 'M'}
                                </div>
                              )}
                            </div>
                            <div className="mage-status-indicator mage-manager-status online"></div>
                          </div>
                          <div className="mage-details-main mage-manager-details">
                            <h3 className="mage-name mage-manager-name">{manager.name}</h3>
                            <p className="mage-title mage-manager-title">{manager.department} Manager</p>
                            <span className="mage-company mage-manager-company">{manager.company_name}</span>
                            <div className="mage-contact-info mage-manager-contact">
                              <span className="mage-contact-item mage-manager-email">{manager.email}</span>
                              {manager.phone && (
                                <span className="mage-contact-item mage-manager-phone">{manager.phone}</span>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Team Summary */}
                        <div className="mage-team-summary mage-manager-team-summary">
                          <div className="mage-stats-grid mage-team-stats-grid">
                            <div className="mage-stat-card mage-team-stat-summary">
                              <span className="mage-stat-value mage-team-stat-value">{teamMembers.length}</span>
                              <span className="mage-stat-label mage-team-stat-label">Team Members</span>
                            </div>
                            <div className="mage-stat-card mage-team-stat-summary">
                              <span className="mage-stat-value mage-team-stat-value">
                                {teamMembers.filter(member => member.status === 'active').length}
                              </span>
                              <span className="mage-stat-label mage-team-stat-label">Active</span>
                            </div>
                            <div className="mage-stat-card mage-team-stat-summary">
                              <span className="mage-stat-value mage-team-stat-value">
                                {teamMembers.filter(member => member.status === 'inactive').length}
                              </span>
                              <span className="mage-stat-label mage-team-stat-label">Inactive</span>
                            </div>
                          </div>
                        </div>

                        {/* Team Members */}
                        <div className="mage-team-section mage-manager-team-section">
                          <div className="mage-section-header mage-team-section-header">
                            <h4 className="mage-section-title mage-team-section-title">Team Members ({teamMembers.length})</h4>
                            {teamMembers.length > 0 && (
                              <div className="mage-stats-badge mage-team-active-badge">
                                {teamMembers.filter(member => member.status === 'active').length} Active
                              </div>
                            )}
                          </div>
                          {teamMembers.length === 0 ? (
                            <div className="mage-empty-team mage-manager-empty-team">
                              <div className="mage-team-icon mage-manager-team-icon"><FiUsers /></div>
                              <p className="mage-team-text mage-manager-team-text">No team members assigned to this manager</p>
                              <button
                                className="mage-assign-btn mage-manager-assign-btn"
                                onClick={() => openTeamAssignmentModal(manager)}
                              >
                                Assign Team Members
                              </button>
                            </div>
                          ) : (
                            <div className="mage-team-grid mage-manager-team-grid">
                              {teamMembers.slice(0, 4).map(employee => (
                                <div key={employee._id} className="mage-member-card mage-team-member-card">
                                  <div className="mage-member-avatar mage-team-member-avatar">
                                    {employee.name ? employee.name.charAt(0).toUpperCase() : 'E'}
                                  </div>
                                  <div className="mage-member-details mage-team-member-details">
                                    <div className="mage-member-name mage-team-member-name">{employee.name}</div>
                                    <div className="mage-member-role mage-team-member-role">{employee.role}</div>
                                    <div className="mage-member-meta mage-team-member-meta">
                                      <span className="mage-member-id mage-team-member-id">ID: {employee.emp_id}</span>
                                      <span className="mage-member-dept mage-team-member-dept">{employee.department}</span>
                                    </div>
                                  </div>
                                  <div className="mage-member-status mage-team-member-status">
                                    <span className={`mage-status-badge mage-team-member-status-badge mage-status-${employee.status || 'active'}`}>
                                      {employee.status || 'Active'}
                                    </span>
                                  </div>
                                </div>
                              ))}
                              {teamMembers.length > 4 && (
                                <div className="mage-view-more mage-team-view-more">
                                  <div className="mage-more-count mage-team-more-count">
                                    +{teamMembers.length - 4} more
                                  </div>
                                  <button
                                    className="mage-view-all-btn mage-team-view-all-btn"
                                    onClick={() => viewFullTeamPage(manager)}
                                  >
                                    View All
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        {/* Actions */}
                        <div className="mage-actions-section mage-manager-actions-section">
                          <button
                            className="mage-action-button mage-primary-action mage-manager-full-team-btn"
                            onClick={() => viewFullTeamPage(manager)}
                          >
                            <span className="mage-action-icon"><FiUsers /></span>
                            View Full Team
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Quick Actions Panel */}
            <div className="mage-quick-actions mage-manager-quick-actions">
              <div className="mage-actions-header mage-quick-actions-header">
                <h4 className="mage-quick-title">Quick Actions</h4>
              </div>
              <div className="mage-actions-grid mage-quick-actions-grid">
                <button className="mage-quick-btn mage-add-manager-quick" onClick={() => navigate('/report-managers')}>
                  <span className="mage-quick-icon"><FiPlus /></span>
                  <span className="mage-quick-text">Add Manager</span>
                </button>
                {/* <button className="mage-quick-btn mage-report-quick" onClick={generateManagerReports}>
                  <span className="mage-quick-icon"><FiBarChart2 /></span>
                  <span className="mage-quick-text">Generate Reports</span>
                </button> */}
                <button className="mage-quick-btn mage-export-quick" onClick={exportManagerData}>
                  <span className="mage-quick-icon"><FiDownload /></span>
                  <span className="mage-quick-text">Export Data</span>
                </button>
                <button className="mage-quick-btn mage-assign-quick" onClick={manageTeamAssignments}>
                  <span className="mage-quick-icon"><FiShuffle /></span>
                  <span className="mage-quick-text">Team Assignments</span>
                </button>
              </div>
            </div>

            {/* Team Assignment Modal */}
            {teamAssignmentModal.open && (
              <TeamAssignmentModal
                manager={teamAssignmentModal.manager}
                allEmployees={employees}
                assignedTeamMembers={getTeamMembers(teamAssignmentModal.manager?._id)}
                onClose={() => setTeamAssignmentModal({ open: false, manager: null })}
                onAssign={handleTeamAssignment}
              />
            )}

            {/* Full Team View Modal - Updated to use inline component */}
            {fullTeamModal.open && fullTeamModal.manager && (
              <FullTeamViewModal
                manager={fullTeamModal.manager}
                teamMembers={fullTeamModal.teamMembers || []}
                onClose={() => setFullTeamModal({ open: false, manager: null, teamMembers: [] })}
              />
            )}

            {/* Edit Manager Modal */}
            {editManagerModal.open && (
              <EditManagerModal
                manager={editManagerModal.manager}
                departments={departments}
                onClose={() => setEditManagerModal({ open: false, manager: null })}
                onUpdate={handleUpdateManager}
              />
            )}
          </div>
        );


      case 'leaves':
        // Get unique values for filters
        const uniqueDepartments = [...new Set(leaveRequests.map(leave => leave.employeeDepartment).filter(Boolean))];
        const uniqueManagers = [...new Set(leaveRequests.map(leave => leave.reportingManager).filter(Boolean))];
        const uniqueLeaveTypes = [...new Set(leaveRequests.map(leave => leave.leaveType || leave.type).filter(Boolean))];
        const uniqueEmployees = [...new Map(leaveRequests.map(leave => [leave.employeeId, leave.employeeName])).values()];

        // Enhanced filtered leave requests
        const filteredLeaveRequests = leaveRequests.filter(leave => {
          // Status filter
          const statusMatch = leaveFilter === 'all' ||
            leave.status.toLowerCase() === leaveFilter.toLowerCase();

          // Department filter
          const departmentMatch = departmentFilter === 'all' ||
            leave.employeeDepartment === departmentFilter;

          // Manager filter
          const managerMatch = managerFilter === 'all' ||
            leave.reportingManager === managerFilter;

          // Leave type filter
          const leaveTypeMatch = leaveTypeFilter === 'all' ||
            (leave.leaveType || leave.type) === leaveTypeFilter;

          // Employee filter
          const employeeMatch = employeeFilter === 'all' ||
            leave.employeeName === employeeFilter;

          // Search filter
          const searchMatch = !searchTerm ||
            leave.employeeName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            leave.employeeId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            leave.employeeDepartment?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            leave.reportingManager?.toLowerCase().includes(searchTerm.toLowerCase());

          return statusMatch && departmentMatch && managerMatch &&
            leaveTypeMatch && employeeMatch && searchMatch;
        });

        // Clear all filters
        const clearAllFilters = () => {
          setLeaveFilter('all');
          setDepartmentFilter('all');
          setManagerFilter('all');
          setLeaveTypeFilter('all');
          setEmployeeFilter('all');
          setSearchTerm('');
        };

        return (
          <div className="leave-manager-dashboard">
            {/* Header Section */}
            <div className="leave-header-section">
              <div className="leave-title-content">
                <h2 className="leave-main-title">Leave Management</h2>
                <p className="leave-subtitle">View and manage all employee leave requests</p>
              </div>
              <div className="leave-action-buttons">
                <button
                  className="leave-action-btn leave-refresh-btn"
                  onClick={fetchAllLeaveRequests}
                >
                  <span className="btn-icon"><FiRefreshCw /></span>
                  Refresh
                </button>
                <button
                  className="leave-action-btn leave-export-btn"
                  onClick={exportLeavesToExcel}
                >
                  <span className="btn-icon"><FiBarChart2 /></span>
                  Export Report
                </button>
              </div>
            </div>

            {/* Leave Statistics */}
            <div className="leave-stats-grid">
              <div className="leave-stat-card">
                <div className="stat-icon-wrapper"><FiBarChart2 /></div>
                <div className="stat-content-wrapper">
                  <span className="stat-value">{leaveRequests.length}</span>
                  <span className="stat-label">Total Leaves</span>
                </div>
              </div>
              <div className="leave-stat-card">
                <div className="stat-icon-wrapper"><FiClock /></div>
                <div className="stat-content-wrapper">
                  <span className="stat-value">
                    {leaveRequests.filter(leave =>
                      leave.status === 'Pending' || leave.status === 'pending'
                    ).length}
                  </span>
                  <span className="stat-label">Pending</span>
                </div>
              </div>
              <div className="leave-stat-card">
                <div className="stat-icon-wrapper"><FiCheckCircle /></div>
                <div className="stat-content-wrapper">
                  <span className="stat-value">
                    {leaveRequests.filter(leave =>
                      leave.status === 'Approved' || leave.status === 'approved'
                    ).length}
                  </span>
                  <span className="stat-label">Approved</span>
                </div>
              </div>
              <div className="leave-stat-card">
                <div className="stat-icon-wrapper"><FiXCircle /></div>
                <div className="stat-content-wrapper">
                  <span className="stat-value">
                    {leaveRequests.filter(leave =>
                      leave.status === 'Rejected' || leave.status === 'rejected'
                    ).length}
                  </span>
                  <span className="stat-label">Rejected</span>
                </div>
              </div>
            </div>

            {/* Enhanced Filters Section */}
            <div className="leave-filters-panel">
              <div className="filters-header-section">
                <h4 className="filters-title">Filter Leaves</h4>
                <button
                  className="clear-filters-btn"
                  onClick={clearAllFilters}
                >
                  Clear All Filters
                </button>
              </div>

              <div className="filters-grid-layout">
                {/* Status Filter */}
                <div className="filter-item-wrapper">
                  <label className="filter-item-label">Status</label>
                  <select
                    className="filter-dropdown-select"
                    value={leaveFilter}
                    onChange={(e) => setLeaveFilter(e.target.value)}
                  >
                    <option value="all">All Status</option>
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </div>

                {/* Department Filter */}
                <div className="filter-item-wrapper">
                  <label className="filter-item-label">Department</label>
                  <select
                    className="filter-dropdown-select"
                    value={departmentFilter}
                    onChange={(e) => setDepartmentFilter(e.target.value)}
                  >
                    <option value="all">All Departments</option>
                    {uniqueDepartments.map(dept => (
                      <option key={dept} value={dept}>{dept}</option>
                    ))}
                  </select>
                </div>

                {/* Manager Filter */}
                <div className="filter-item-wrapper">
                  <label className="filter-item-label">Reporting Manager</label>
                  <select
                    className="filter-dropdown-select"
                    value={managerFilter}
                    onChange={(e) => setManagerFilter(e.target.value)}
                  >
                    <option value="all">All Managers</option>
                    {uniqueManagers.map(manager => (
                      <option key={manager} value={manager}>{manager}</option>
                    ))}
                  </select>
                </div>

                {/* Leave Type Filter */}
                <div className="filter-item-wrapper">
                  <label className="filter-item-label">Leave Type</label>
                  <select
                    className="filter-dropdown-select"
                    value={leaveTypeFilter}
                    onChange={(e) => setLeaveTypeFilter(e.target.value)}
                  >
                    <option value="all">All Leave Types</option>
                    {uniqueLeaveTypes.map(type => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                </div>

                {/* Employee Filter */}
                <div className="filter-item-wrapper">
                  <label className="filter-item-label">Employee</label>
                  <select
                    className="filter-dropdown-select"
                    value={employeeFilter}
                    onChange={(e) => setEmployeeFilter(e.target.value)}
                  >
                    <option value="all">All Employees</option>
                    {uniqueEmployees.map(employee => (
                      <option key={employee} value={employee}>{employee}</option>
                    ))}
                  </select>
                </div>

                {/* Search Filter */}
                <div className="filter-item-wrapper search-filter-wrapper">
                  <label className="filter-item-label">Search</label>
                  <div className="search-input-container">
                    <input
                      type="text"
                      placeholder="Search by name, ID, department, manager..."
                      className="search-input-field"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <span className="search-input-icon"></span>
                  </div>
                </div>
              </div>

              <div className="filters-footer-section">
                <div className="results-count-display">
                  Showing {filteredLeaveRequests.length} of {leaveRequests.length} leave requests
                </div>
                <div className="active-filters-container">
                  {leaveFilter !== 'all' && (
                    <span className="active-filter-tag">
                      Status: {leaveFilter}
                      <span
                        className="filter-remove-btn"
                        onClick={() => setLeaveFilter('all')}
                      >✕</span>
                    </span>
                  )}
                  {departmentFilter !== 'all' && (
                    <span className="active-filter-tag">
                      Department: {departmentFilter}
                      <span
                        className="filter-remove-btn"
                        onClick={() => setDepartmentFilter('all')}
                      >✕</span>
                    </span>
                  )}
                  {managerFilter !== 'all' && (
                    <span className="active-filter-tag">
                      Manager: {managerFilter}
                      <span
                        className="filter-remove-btn"
                        onClick={() => setManagerFilter('all')}
                      >✕</span>
                    </span>
                  )}
                  {leaveTypeFilter !== 'all' && (
                    <span className="active-filter-tag">
                      Leave Type: {leaveTypeFilter}
                      <span
                        className="filter-remove-btn"
                        onClick={() => setLeaveTypeFilter('all')}
                      >✕</span>
                    </span>
                  )}
                  {employeeFilter !== 'all' && (
                    <span className="active-filter-tag">
                      Employee: {employeeFilter}
                      <span
                        className="filter-remove-btn"
                        onClick={() => setEmployeeFilter('all')}
                      >✕</span>
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Leave Requests Table */}
            <div className="leave-requests-container">
              {filteredLeaveRequests.length === 0 ? (
                <div className="leave-empty-state">
                  <div className="empty-state-icon"><FiCalendar /></div>
                  <h4 className="empty-state-title">No Leave Requests Found</h4>
                  <p className="empty-state-description">No leave requests match your current filters.</p>
                  <button
                    className="leave-action-btn leave-primary-btn"
                    onClick={clearAllFilters}
                  >
                    Clear Filters
                  </button>
                </div>
              ) : (
                <div className="leave-table-wrapper">
                  <table className="leave-data-table">
                    <thead>
                      <tr>
                        <th>Employee Name</th>
                        <th>Employee ID</th>
                        <th>Department</th>
                        <th>Leave Type</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Duration</th>
                        <th>Status</th>
                        <th>Reason</th>
                        <th>Applied On</th>
                        <th>Reporting Manager</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLeaveRequests.map(leave => (
                        <tr key={leave._id} className="leave-table-row">
                          <td>
                            <div className="employee-info-cell">
                              <div className="employee-avatar-small">
                                {leave.employeeName ? leave.employeeName.charAt(0).toUpperCase() : 'E'}
                              </div>
                              <div className="employee-details-compact">
                                <span className="employee-name">{leave.employeeName}</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="employee-id-badge">{leave.employeeId}</span>
                          </td>
                          <td>
                            <span className="department-tag">{leave.employeeDepartment}</span>
                          </td>
                          <td>
                            <span className="leave-type-badge">{leave.leaveType || leave.type}</span>
                          </td>
                          <td>{new Date(leave.startDate).toLocaleDateString('en-IN')}</td>
                          <td>{new Date(leave.endDate).toLocaleDateString('en-IN')}</td>
                          <td>
                            <span className="leave-duration">
                              {leave.leaveDays || Math.ceil((new Date(leave.endDate) - new Date(leave.startDate)) / (1000 * 60 * 60 * 24)) + 1} days
                            </span>
                          </td>
                          <td>
                            <span className={`leave-status-indicator status-${leave.status.toLowerCase()}`}>
                              {leave.status}
                            </span>
                          </td>
                          <td>
                            <div className="leave-reason-text" title={leave.reason}>
                              {leave.reason ? (leave.reason.length > 50 ? `${leave.reason.substring(0, 50)}...` : leave.reason) : 'No reason provided'}
                            </div>
                          </td>
                          <td>
                            {leave.applicationDate ? new Date(leave.applicationDate).toLocaleDateString('en-IN') : 'N/A'}
                          </td>
                          <td>
                            <span className="reporting-manager">
                              {leave.reportingManager || 'Not assigned'}
                            </span>
                          </td>
                          <td>
                            <div className="leave-action-buttons">
                              {(leave.status === 'Pending' || leave.status === 'pending') && (
                                <>
                                  <button
                                    className="action-btn approve-action-btn"
                                    onClick={() => handleLeaveAction(leave._id, 'approved')}
                                    title="Approve Leave"
                                  >
                                    <FiCheck /> Approve
                                  </button>
                                  <button
                                    className="action-btn reject-action-btn"
                                    onClick={() => {
                                      const reason = prompt('Please enter rejection reason:');
                                      if (reason) {
                                        handleLeaveAction(leave._id, 'rejected', reason);
                                      }
                                    }}
                                    title="Reject Leave"
                                  >
                                    ✕ Reject
                                  </button>
                                </>
                              )}
                              {(leave.status === 'Approved' || leave.status === 'Rejected') && (
                                <span className="action-completed-badge">
                                  Processed
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        );


      case 'manager-leaves':
        // Add company name to the filtered leaves for better security
        const companyName = user?.company || sessionStorage.getItem('companyName');

        // First filter by company, then apply other filters
        const companyManagerLeaves = managerLeaves.filter(leave =>
          leave.company === companyName || leave.managerCompany === companyName
        );

        const filteredManagerLeaves = companyManagerLeaves.filter(leave => {
          const statusMatch = managerLeaveFilter === 'all' ||
            leave.status.toLowerCase() === managerLeaveFilter.toLowerCase();

          const departmentMatch = managerDepartmentFilter === 'all' ||
            leave.managerDepartment === managerDepartmentFilter;

          const searchMatch = !managerSearchTerm ||
            leave.managerName?.toLowerCase().includes(managerSearchTerm.toLowerCase()) ||
            leave.managerEmail?.toLowerCase().includes(managerSearchTerm.toLowerCase()) ||
            leave.managerDepartment?.toLowerCase().includes(managerSearchTerm.toLowerCase());

          return statusMatch && departmentMatch && searchMatch;
        });

        return (
          <div className="manager-leaves-dashboard">
            {/* Header Section with Company Badge */}
            <div className="manager-leaves-header">
              <div className="manager-leaves-title-section">
                <h2 className="manager-leaves-main-title">
                  Manager Leave Approvals
                  {/* <span className="company-badge">{companyName}</span> */}
                </h2>
                <p className="manager-leaves-subtitle">
                  Review and manage leave requests from {companyName} managers only
                </p>
                {companyManagerLeaves.length < managerLeaves.length && (
                  <div className="company-filter-notice">
                    🔒 Showing only {companyManagerLeaves.length} leaves from your company
                    (filtered from {managerLeaves.length} total)
                  </div>
                )}
              </div>
              <div className="manager-leaves-action-buttons">
                <button
                  className="manager-leaves-action-btn manager-leaves-refresh-btn"
                  onClick={fetchManagerLeaves}
                >
                  <span className="btn-icon"><FiRefreshCw /></span>
                  Refresh
                </button>
                <button
                  className="manager-leaves-action-btn manager-leaves-export-btn"
                  onClick={exportManagerLeavesToExcel}
                  disabled={companyManagerLeaves.length === 0}
                >
                  <span className="btn-icon"><FiBarChart2 /></span>
                  Export Report
                </button>
              </div>
            </div>

            {/* Manager Leave Statistics - Update to use companyManagerLeaves */}
            <div className="manager-leaves-stats-grid">
              <div className="manager-leaves-stat-card">
                <div className="manager-stat-icon"><FiUser /></div>
                <div className="manager-stat-content">
                  <span className="manager-stat-value">{companyManagerLeaves.length}</span>
                  <span className="manager-stat-label">
                    Manager Leaves
                    {/* <span className="stat-subtitle">Your company only</span> */}
                  </span>
                </div>
              </div>
              <div className="manager-leaves-stat-card">
                <div className="manager-stat-icon"><FiClock /></div>
                <div className="manager-stat-content">
                  <span className="manager-stat-value">
                    {companyManagerLeaves.filter(leave => leave.status === 'Pending').length}
                  </span>
                  <span className="manager-stat-label">Pending</span>
                  <span className="stat-subtitle">
                    {managerLeaves.filter(leave => leave.status === 'Pending').length} total
                  </span>
                </div>
              </div>
              <div className="manager-leaves-stat-card">
                <div className="manager-stat-icon"><FiCheckCircle /></div>
                <div className="manager-stat-content">
                  <span className="manager-stat-value">
                    {companyManagerLeaves.filter(leave => leave.status === 'Approved').length}
                  </span>
                  <span className="manager-stat-label">Approved</span>
                  <span className="stat-subtitle">
                    {managerLeaves.filter(leave => leave.status === 'Approved').length} total
                  </span>
                </div>
              </div>
              <div className="manager-leaves-stat-card">
                <div className="manager-stat-icon"><FiXCircle /></div>
                <div className="manager-stat-content">
                  <span className="manager-stat-value">
                    {companyManagerLeaves.filter(leave => leave.status === 'Rejected').length}
                  </span>
                  <span className="manager-stat-label">Rejected</span>
                  <span className="stat-subtitle">
                    {managerLeaves.filter(leave => leave.status === 'Rejected').length} total
                  </span>
                </div>
              </div>
            </div>

            {/* Manager Leave Filters - Update department options */}
            <div className="manager-leaves-filters-panel">
              <div className="manager-filters-header">
                <h4 className="manager-filters-title">
                  Filter Manager Leaves
                  <span className="filter-company-indicator">({companyName})</span>
                </h4>
                <div className="manager-filters-controls">
                  <select
                    className="manager-filter-dropdown"
                    value={managerLeaveFilter}
                    onChange={(e) => setManagerLeaveFilter(e.target.value)}
                  >
                    <option value="all">All Status</option>
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="rejected">Rejected</option>
                  </select>

                  <select
                    className="manager-filter-dropdown"
                    value={managerDepartmentFilter}
                    onChange={(e) => setManagerDepartmentFilter(e.target.value)}
                  >
                    <option value="all">All Departments</option>
                    {[...new Set(companyManagerLeaves.map(leave => leave.managerDepartment))]
                      .filter(Boolean)
                      .map(dept => (
                        <option key={dept} value={dept}>{dept}</option>
                      ))
                    }
                  </select>

                  <div className="manager-search-container">
                    <input
                      type="text"
                      placeholder={`Search ${companyName} managers...`}
                      className="manager-search-input"
                      value={managerSearchTerm}
                      onChange={(e) => setManagerSearchTerm(e.target.value)}
                    />
                    <span className="manager-search-icon"></span>
                  </div>
                </div>
              </div>
              <div className="manager-filters-footer">
                <div className="manager-results-count">
                  Showing {filteredManagerLeaves.length} of {companyManagerLeaves.length} manager leave requests
                  <span className="company-filter-note">(from {companyName})</span>
                </div>
                <div className="manager-active-filters">
                  {managerLeaveFilter !== 'all' && (
                    <span className="manager-active-filter-tag">
                      Status: {managerLeaveFilter}
                      <span
                        className="manager-filter-remove"
                        onClick={() => setManagerLeaveFilter('all')}
                      >✕</span>
                    </span>
                  )}
                  {managerDepartmentFilter !== 'all' && (
                    <span className="manager-active-filter-tag">
                      Department: {managerDepartmentFilter}
                      <span
                        className="manager-filter-remove"
                        onClick={() => setManagerDepartmentFilter('all')}
                      >✕</span>
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Manager Leave Requests Table */}
            <div className="manager-leaves-content-area">
              {companyManagerLeaves.length === 0 ? (
                <div className="manager-leaves-empty-state">
                  <div className="manager-empty-icon">
                    <FiUser />
                    <FiCalendar />
                  </div>
                  <h4 className="manager-empty-title">No Manager Leave Requests Found</h4>
                  <p className="manager-empty-description">
                    No manager leave requests have been submitted yet in {companyName}.
                  </p>
                  <button
                    className="manager-leaves-action-btn manager-leaves-primary-btn"
                    onClick={fetchManagerLeaves}
                  >
                    Check Again
                  </button>
                </div>

              ) : filteredManagerLeaves.length === 0 ? (
                <div className="manager-leaves-empty-state">
                  <div className="manager-empty-icon"> <FiSearch /> </div>

                  <h4 className="manager-empty-title">No Matching Leaves Found</h4>
                  <p className="manager-empty-description">
                    No manager leave requests match your current filters in {companyName}.
                  </p>
                  <button
                    className="manager-leaves-action-btn manager-leaves-primary-btn"
                    onClick={() => {
                      setManagerLeaveFilter('all');
                      setManagerDepartmentFilter('all');
                      setManagerSearchTerm('');
                    }}
                  >
                    Clear All Filters
                  </button>
                </div>
              ) : (
                <div className="manager-leaves-table-wrapper">
                  <table className="manager-leaves-data-table">
                    <thead>
                      <tr>
                        <th>Manager Details</th>
                        <th>Department</th>
                        <th>Company</th>
                        <th>Contact</th>
                        <th>Leave Type</th>
                        <th>Leave Period</th>
                        <th>Duration</th>
                        <th>Reason</th>
                        <th>Application Date</th>
                        <th>Handover Details</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredManagerLeaves.map(leave => (
                        <tr key={leave._id} className="manager-leave-table-row">
                          <td>
                            <div className="manager-info-cell">
                              <div className="manager-avatar-medium">
                                {leave.managerName ? leave.managerName.charAt(0).toUpperCase() : 'M'}
                              </div>
                              <div className="manager-details-compact">
                                <div className="manager-name">{leave.managerName}</div>
                                <div className="manager-email">{leave.managerEmail}</div>
                                <div className="manager-role-badge">Manager</div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="manager-department-badge">{leave.managerDepartment}</span>
                          </td>
                          <td>
                            <span className="company-badge-small">{leave.company || companyName}</span>
                          </td>
                          <td>
                            <div className="manager-contact-info">
                              <span className="contact-detail">{leave.contactInfo || 'Not provided'}</span>
                            </div>
                          </td>
                          <td>
                            <span className="manager-leave-type-tag">
                              {leave.leaveType?.charAt(0).toUpperCase() + leave.leaveType?.slice(1) || 'General Leave'}
                            </span>
                          </td>
                          <td>
                            <div className="leave-period-dates">
                              <div className="leave-start-date">
                                <strong>From:</strong> {new Date(leave.startDate).toLocaleDateString('en-IN')}
                              </div>
                              <div className="leave-end-date">
                                <strong>To:</strong> {new Date(leave.endDate).toLocaleDateString('en-IN')}
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="leave-duration-badge">
                              {leave.totalDays} day{leave.totalDays !== 1 ? 's' : ''}
                            </span>
                          </td>
                          <td>
                            <div className="manager-leave-reason" title={leave.reason}>
                              {leave.reason ? (leave.reason.length > 60 ? `${leave.reason.substring(0, 60)}...` : leave.reason) : 'No reason provided'}
                            </div>
                          </td>
                          <td>
                            <div className="application-date-info">
                              {leave.appliedDate ? new Date(leave.appliedDate).toLocaleDateString('en-IN') : 'N/A'}
                            </div>
                          </td>
                          <td>
                            <div className="handover-details">
                              <span className="handover-person">
                                {leave.handoverEmployee?.name || leave.handoverTo || 'Not assigned'}
                              </span>
                            </div>
                          </td>
                          <td>
                            <span className={`manager-leave-status status-${leave.status.toLowerCase()}`}>
                              {leave.status}
                            </span>
                          </td>
                          <td>
                            <div className="manager-leave-actions">
                              {leave.status === 'Pending' && (
                                <>
                                  <button
                                    className="manager-approve-btn"
                                    onClick={() => handleStatusChange(leave, 'Approved')}
                                    title="Approve Leave"
                                  >
                                    <FiCheck />
                                  </button>
                                  <button
                                    className="manager-reject-btn"
                                    onClick={() => {
                                      const reason = prompt('Enter rejection reason:');
                                      if (reason) {
                                        handleStatusChange(leave, 'Rejected', reason);
                                      }
                                    }}
                                    title="Reject Leave"
                                  >
                                    <FiX />
                                  </button>
                                </>
                              )}
                              {(leave.status === 'Approved' || leave.status === 'Rejected') && (
                                <span className="action-completed">
                                  <FiCheckCircle /> Processed
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        );

      case 'employee-details':
        return (
          <div className="employee-details-page-wrapper">
            <EmployeeDetails
              employees={employees || []}
              departments={departments || []}
              onBack={() => setActiveTab('employees')}
            />
          </div>
        );




      case 'settings':
        return (
          <div className="hr-portal-tab-container">
            <div className="hr-portal-page-header-section">
              <div className="hr-portal-header-content">
                <h2 className="hr-portal-page-title">Portal Settings</h2>
                <p className="hr-portal-page-subtitle">Configure your HR portal preferences and services</p>
              </div>
            </div>

            <div className="hr-portal-settings-interface">
              <div className="hr-portal-settings-section-card">
                <h3 className="hr-portal-settings-title">Company Branding</h3>
                <div className="hr-portal-branding-settings">
                  <div className="hr-portal-logo-upload-area">
                    <p>Company Logo</p>
                    <div className="hr-portal-logo-preview-container">
                      {companyLogo ? (
                        <img src={companyLogo} alt="Company Logo" className="hr-portal-logo-preview" />
                      ) : (
                        <div className="hr-portal-logo-placeholder">{user.company.charAt(0)}</div>
                      )}
                    </div>
                    <label htmlFor="hr-portal-logo-upload" className="hr-portal-upload-btn">Upload Logo</label>
                    <input
                      id="hr-portal-logo-upload"
                      type="file"
                      accept="image/*"
                      onChange={handleLogoUpload}
                      style={{ display: 'none' }}
                    />
                  </div>
                </div>
              </div>

              <div className="hr-portal-settings-section-card">
                <h3 className="hr-portal-settings-title">Portal Services</h3>

                <div className="hr-portal-services-grid-layout">

                  <div className="hr-portal-service-card">
                    <div className="hr-portal-service-icon">
                      <FiUserPlus />
                    </div>
                    <h4>Onboarding</h4>
                    <p>Manage new employee onboarding process</p>
                    <button
                      className="hr-portal-service-action-btn"
                      onClick={goToOnboarding}
                    >
                      Configure
                    </button>
                  </div>

                  <div className="hr-portal-service-card">
                    <div className="hr-portal-service-icon">
                      <FiClipboard />
                    </div>
                    <h4>Tasks</h4>
                    <p>Create and assign tasks to employees</p>
                    <button className="hr-portal-service-action-btn">Configure</button>
                  </div>

                  <div className="hr-portal-service-card">
                    <div className="hr-portal-service-icon">
                      <FiClock />
                    </div>
                    <h4>Attendance</h4>
                    <p>Track and manage employee attendance</p>
                    <button className="hr-portal-service-action-btn">Configure</button>
                  </div>

                  <div className="hr-portal-service-card">
                    <div className="hr-portal-service-icon">
                      <FiDollarSign />
                    </div>
                    <h4>Payroll</h4>
                    <p>Manage employee compensation and benefits</p>
                    <button className="hr-portal-service-action-btn">Configure</button>
                  </div>

                  <div className="hr-portal-service-card">
                    <div className="hr-portal-service-icon">
                      <FiTrendingUp />
                    </div>
                    <h4>Performance</h4>
                    <p>Set up performance review cycles</p>
                    <button className="hr-portal-service-action-btn">Configure</button>
                  </div>

                  <div className="hr-portal-service-card">
                    <div className="hr-portal-service-icon">
                      <FiFileText />
                    </div>
                    <h4>Documents</h4>
                    <p>Manage company documents and templates</p>
                    <button className="hr-portal-service-action-btn">Configure</button>
                  </div>

                </div>
              </div>


              <div className="hr-portal-settings-section-card">
                <h3 className="hr-portal-settings-title">Portal Access</h3>
                <div className="hr-portal-access-settings">
                  <div className="hr-portal-access-control-item">
                    <label className="hr-portal-toggle-switch">
                      <input type="checkbox" defaultChecked />
                      <span className="hr-portal-toggle-slider"></span>
                    </label>
                    <div className="hr-portal-access-info">
                      <h4>Employee Self-Service</h4>
                      <p>Allow employees to access their information</p>
                    </div>
                  </div>
                  <div className="hr-portal-access-control-item">
                    <label className="hr-portal-toggle-switch">
                      <input type="checkbox" defaultChecked />
                      <span className="hr-portal-toggle-slider"></span>
                    </label>
                    <div className="hr-portal-access-info">
                      <h4>Manager Portal</h4>
                      <p>Enable manager access to team information</p>
                    </div>
                  </div>
                  <div className="hr-portal-access-control-item">
                    <label className="hr-portal-toggle-switch">
                      <input type="checkbox" />
                      <span className="hr-portal-toggle-slider"></span>
                    </label>
                    <div className="hr-portal-access-info">
                      <h4>Mobile Access</h4>
                      <p>Enable mobile app access for employees</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );


      // Add other cases for different tabs as needed
      default:
        return (
          <div className="hr-portal-tab-container">
            <div className="hr-portal-page-header-section">
              <h2 className="hr-portal-page-title">{activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}</h2>
              <p className="hr-portal-page-subtitle">This section is under development</p>
            </div>
          </div>
        );
    }
  };

  if (!user) return (
    <div className="hr-portal-loading-container">
      <div className="hr-portal-loading-spinner"></div>
      <p>Loading your dashboard...</p>
    </div>
  );

  return (
    <div className="hr-portal-container-enhanced">
      <EnhancedNavigationHeader />

      {showTutorial && (
        <div className="hr-portal-tutorial-overlay-unique">
          <div className="hr-portal-tutorial-container-unique">
            <div className="hr-portal-tutorial-header-unique">
              <h2><FiTarget /> Welcome to HR Portal Dashboard</h2>
              <button
                className="hr-portal-tutorial-skip-unique"
                onClick={() => {
                  setShowTutorial(false);
                  setIsTutorialActive(false);
                  localStorage.setItem('hrPortalTutorialCompleted', 'true');
                }}
              >
                Skip Tutorial
              </button>
            </div>

            <div className="hr-portal-tutorial-content-unique">
              {currentStep === 0 && (
                <div className="hr-portal-tutorial-step-unique">
                  <div className="hr-portal-step-indicator-unique">
                    <span className="hr-portal-step-active-unique">1</span>
                    <span>2</span>
                    <span>3</span>
                    <span>4</span>
                    <span>5</span>
                  </div>

                  <h3>Step 1: Get Started with Your Dashboard</h3>
                  <p>Welcome to your HR management dashboard! Here's what you need to do first:</p>

                  <div className="hr-portal-step-instructions-unique">
                    <div className="hr-portal-instruction-card-unique">
                      <span className="hr-portal-instruction-icon-unique"><FiUsers /></span>
                      <div>
                        <strong>Add Your Team</strong>
                        <p>Click "Add Employee" to upload your team members</p>
                      </div>
                      <button
                        className="hr-portal-action-glow-unique"
                        onClick={() => {
                          navigate('/employees');
                          setCurrentStep(1);
                        }}
                      >
                        Go to Employees <FiArrowRight />
                      </button>
                    </div>

                    <div className="hr-portal-instruction-card-unique">
                      <span className="hr-portal-instruction-icon-unique"><FiClipboard /></span>
                      <div>
                        <strong>Set Up Leave Policies</strong>
                        <p>Configure your company's leave and attendance rules</p>
                      </div>
                      <button
                        className="hr-portal-action-glow-unique"
                        onClick={() => {
                          navigate('/settings/leave');
                          setCurrentStep(2);
                        }}
                      >
                        Configure Policies <FiArrowRight />
                      </button>
                    </div>
                  </div>

                  <div className="hr-portal-tutorial-actions-unique">
                    <button
                      className="hr-portal-next-btn-unique"
                      onClick={() => setCurrentStep(1)}
                    >
                      Next: Employee Management <FiArrowRight />
                    </button>
                  </div>
                </div>
              )}

              {/* Add similar React Icon replacements for other tutorial steps... */}
            </div>
          </div>
        </div>
      )}

      <div className="hr-portal-main-interface-enhanced">
        <aside className={`hr-portal-sidebar-enhanced ${sidebarCollapsed ? 'hr-portal-sidebar-collapsed' : ''}`}>
          <QuickActionsPanel />
        </aside>

        <main className="hr-portal-content-area-enhanced">
          <div className="hr-portal-content-wrapper-enhanced">
            {renderDashboardContent()}
          </div>
        </main>
      </div>

      {/* Remember to update all other emoji icons in your JSX with React Icons */}
    </div>
  );

};

export default HRDashboard;